import { css, styled } from 'styled-components';
import { UploadPhotoWrapper, UploadPhotoIcon, InputFile, EditIcon, CloseIcon, AgentDetailsInputGroup } from '../../components/agent';
import { useContext, useEffect, useState } from 'react';
import { COMMUNITY_IMAGE_URL, US_STATES } from '../../constants/common';
import { MainContext } from '../../context';
import { getAllHighlights } from '../../services/general';
import { Modal, ModalBody, ModalFooter, ModalHeader, Button, Form } from 'react-bootstrap';
import { Loader } from '../../components/loader';
import { FieldErrorMessage } from './addagent';
import isValidUrl from '../../utils/isValidUrl';
import Select from 'react-select';
import { getOfficers } from '../../services/admin';

export const AddCommunityContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 160px;
  align-self: stretch;
  padding-bottom: 160px;
  padding-top: 160px;
`;
export const HeroAndCommunityNameWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 100px;
  align-self: stretch;
`;
export const HeroWrapper = styled.div`
  display: flex;
  height: 700px;
  @media (max-width: 600px) {
    height: 450px;
  }
  justify-content: center;
  align-items: center;
  align-self: stretch;
`;
export const HeroLeftCol = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
  align-self: stretch;
  border: 1px solid var(--ywh-alto, #d8d8d8);
  background: var(--sea-salt, #fafafa);
`;
export const HeroRightCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;
  @media (max-width: 992px) {
    display: none;
  }
`;
export const HeroRightColImages = styled.div`
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  flex: 1 0 0;
  align-self: stretch;
  flex-wrap: wrap;
`;
export const HeroRightColImage = styled.div`
  display: flex;
  width: 50%;
  height: 350px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border: 1px solid var(--ywh-alto, #d8d8d8);
  background: var(--sea-salt, #fafafa);
`;

export const MediaPreview = ({ file, handleClick, hasCursor = false }) => {
  const [previewImage, setPreviewImage] = useState('');
  useEffect(() => {
    if (file && file.hasOwnProperty('url')) {
      if (file.url.includes('http')) setPreviewImage(`${file.url.replace('nhs-dynamic.secure.footprint.net', 'nhs-dynamic-secure.akamaized.net')}`);
      else setPreviewImage(`${COMMUNITY_IMAGE_URL}${file.url.replace('nhs-dynamic.secure.footprint.net', 'nhs-dynamic-secure.akamaized.net')}`);
    } else if (file && !file.hasOwnProperty('id')) {
      if (typeof file == 'string') {
        setPreviewImage(`${COMMUNITY_IMAGE_URL}${file.replace('nhs-dynamic.secure.footprint.net', 'nhs-dynamic-secure.akamaized.net')}`);
      } else {
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreviewImage(reader.result);
        };
        reader.readAsDataURL(file);
      }
    }
  }, [file]);

  if (!previewImage) return null;

  // For input preview
  if (file instanceof File && file.type.startsWith('video/')) {
    return (
      <video
        style={{
          backgroundColor: 'black',
          objectFit: 'cover',
          objectPosition: 'center',
          width: '100%',
          height: '75%',
          borderRadius: '4px',
        }}
        controls
      >
        <source
          src={previewImage}
          type="video/mp4"
        />
        Your browser does not support the video tag.
      </video>
    )
  }

  // Gallery preview
  if (Object.keys(file).includes('video_name')) {
    if (file.url.includes('bucket.yourwayhome.com')) {
      return (
        <video
          style={{
            objectFit: 'cover',
            objectPosition: 'center',
            width: '100%',
            borderRadius: '4px',
            height: '100%',
            cursor: hasCursor ? 'pointer' : 'default',
            borderRadius: '4px',
          }}
          src={file.url}
          alt=""
          onClick={handleClick}
          controls={!hasCursor}
        />
      )
    }

    if (hasCursor) {
      return (
        <img style={{
          objectFit: 'cover',
          objectPosition: 'center',
          width: '100%',
          borderRadius: '4px',
          height: '100%',
          cursor: hasCursor ? 'pointer' : 'default',
          borderRadius: '4px',
        }}
        src={ (file.url.includes('youtube') ? `https://img.youtube.com/vi/${file.video_name}/0.jpg` : `https://vumbnail.com/${file.video_name}.jpg` ) }
        alt=""
        onClick={handleClick} />
      )
    } else {
      return (
        <embed
          type="video/webm"
          src={file.url}
          style={{
            backgroundColor: 'black',
            objectFit: 'cover',
            objectPosition: 'center',
            width: '100%',
            borderRadius: '4px',
            height: '90vh',
            cursor: hasCursor ? 'pointer' : 'default',
            borderRadius: '4px',
          }}></embed>
      )
    }
  }
  return (
    <img
      style={{
        objectFit: 'cover',
        objectPosition: 'center',
        width: '100%',
        borderRadius: '4px',
        height: '100%',
        cursor: hasCursor ? 'pointer' : 'default',
      }}
      src={previewImage}
      alt=""
      onClick={handleClick}
    />
  );
};

export const UploadPhoto = ({
  title = 'UPLOAD PHOTO',
  name = 'photo',
  handleChange = () => {},
  communityFiles = null,
  isEmbedURL = false,
}) => {
  const [files, setFiles] = useState([]);
  const handleImageChange = (event) => {
    setFiles(event.target.files);
    handleChange({ target: { name: name, value: event.target.files } });
  };

  useEffect(() => {
    if (communityFiles) {
      setFiles(communityFiles.filter((c) => c));
    }
  }, [communityFiles]);

  const accept = (name === 'videos' ? 'video/*' : 'image/*')

  const svg = (name === 'videos' ? (
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="44" viewBox="0 0 60 44" fill="none">
      <path d="M40.9091 0.181641C41.6324 0.181641 42.3261 0.468978 42.8376 0.980441C43.349 1.4919 43.6364 2.1856 43.6364 2.90891V14.3635L57.8536 4.40891C58.0581 4.26561 58.2979 4.18118 58.547 4.16483C58.7962 4.14847 59.045 4.20082 59.2664 4.31617C59.4878 4.43152 59.6733 4.60544 59.8027 4.81897C59.932 5.0325 60.0003 5.27744 60 5.5271V38.4726C60.0003 38.7222 59.932 38.9672 59.8027 39.1807C59.6733 39.3942 59.4878 39.5681 59.2664 39.6835C59.045 39.7988 58.7962 39.8512 58.547 39.8348C58.2979 39.8185 58.0581 39.734 57.8536 39.5907L43.6364 29.6362V41.0907C43.6364 41.814 43.349 42.5077 42.8376 43.0192C42.3261 43.5307 41.6324 43.818 40.9091 43.818H2.72727C2.00396 43.818 1.31026 43.5307 0.7988 43.0192C0.287337 42.5077 0 41.814 0 41.0907V2.90891C0 2.1856 0.287337 1.4919 0.7988 0.980441C1.31026 0.468978 2.00396 0.181641 2.72727 0.181641H40.9091ZM21.8182 11.0907L10.9091 21.9998H19.0909V32.9089H24.5455V21.9998H32.7273L21.8182 11.0907Z" fill="#979797"/>
    </svg>
  ) : (
    <svg xmlns="http://www.w3.org/2000/svg" width="76" height="76" viewBox="0 0 76 76" fill="none">
      <path
        d="M61.1975 43.347C60.2506 43.347 59.3424 43.7232 58.6728 44.3928C58.0033 45.0624 57.6271 45.9705 57.6271 46.9175V48.2743L52.3428 42.99C50.477 41.1389 47.9552 40.1002 45.3269 40.1002C42.6986 40.1002 40.1768 41.1389 38.311 42.99L35.8117 45.4893L26.957 36.6346C25.0651 34.8337 22.5531 33.8293 19.9411 33.8293C17.329 33.8293 14.8171 34.8337 12.9251 36.6346L7.64089 41.9189V21.9244C7.64089 20.9774 8.01706 20.0693 8.68664 19.3997C9.35623 18.7301 10.2644 18.3539 11.2113 18.3539H36.2044C37.1514 18.3539 38.0595 17.9778 38.7291 17.3082C39.3987 16.6386 39.7749 15.7304 39.7749 14.7835C39.7749 13.8366 39.3987 12.9284 38.7291 12.2588C38.0595 11.5892 37.1514 11.2131 36.2044 11.2131H11.2113C8.37051 11.2131 5.64604 12.3416 3.63728 14.3503C1.62851 16.3591 0.5 19.0836 0.5 21.9244V64.7697C0.5 67.6105 1.62851 70.335 3.63728 72.3438C5.64604 74.3525 8.37051 75.481 11.2113 75.481H54.0566C56.8975 75.481 59.6219 74.3525 61.6307 72.3438C63.6395 70.335 64.768 67.6105 64.768 64.7697V46.9175C64.768 45.9705 64.3918 45.0624 63.7222 44.3928C63.0526 43.7232 62.1445 43.347 61.1975 43.347ZM11.2113 68.3401C10.2644 68.3401 9.35623 67.964 8.68664 67.2944C8.01706 66.6248 7.64089 65.7166 7.64089 64.7697V52.0232L17.9952 41.6689C18.5197 41.1691 19.2165 40.8902 19.9411 40.8902C20.6656 40.8902 21.3624 41.1691 21.887 41.6689L33.2053 52.9872L48.5582 68.3401H11.2113ZM57.6271 64.7697C57.6219 65.4532 57.3966 66.1168 56.9844 66.662L40.8817 50.4879L43.381 47.9886C43.637 47.7274 43.9425 47.5198 44.2797 47.3781C44.6169 47.2364 44.979 47.1634 45.3448 47.1634C45.7105 47.1634 46.0726 47.2364 46.4098 47.3781C46.747 47.5198 47.0525 47.7274 47.3085 47.9886L57.6271 58.3786V64.7697ZM74.4439 12.2485L63.7325 1.53716C63.393 1.2121 62.9926 0.957296 62.5543 0.787363C61.685 0.430254 60.71 0.430254 59.8408 0.787363C59.4025 0.957296 59.0021 1.2121 58.6625 1.53716L47.9512 12.2485C47.2789 12.9208 46.9011 13.8327 46.9011 14.7835C46.9011 15.7343 47.2789 16.6462 47.9512 17.3185C48.6235 17.9908 49.5354 18.3685 50.4862 18.3685C51.437 18.3685 52.3489 17.9908 53.0212 17.3185L57.6271 12.6769V32.6357C57.6271 33.5826 58.0033 34.4908 58.6728 35.1604C59.3424 35.83 60.2506 36.2062 61.1975 36.2062C62.1445 36.2062 63.0526 35.83 63.7222 35.1604C64.3918 34.4908 64.768 33.5826 64.768 32.6357V12.6769L69.3738 17.3185C69.7058 17.6532 70.1007 17.9188 70.5357 18.1C70.9708 18.2813 71.4375 18.3746 71.9089 18.3746C72.3802 18.3746 72.8469 18.2813 73.282 18.1C73.7171 17.9188 74.1119 17.6532 74.4439 17.3185C74.7785 16.9866 75.0441 16.5917 75.2254 16.1566C75.4067 15.7215 75.5 15.2548 75.5 14.7835C75.5 14.3122 75.4067 13.8455 75.2254 13.4104C75.0441 12.9753 74.7785 12.5804 74.4439 12.2485Z"
        fill="#A8A8A8"
      />
    </svg>
  ))

  return (
    <UploadPhotoWrapper className="upload-photo-wrapper">
      {
      name != 'photos' &&
      name != 'videos' &&
        files &&
        files.length > 0 &&
        Array.from(files)
          .slice(0, 1)
          .map((file, index) => (
            <MediaPreview
              className="media-preview"
              file={file}
              handleClick={() => document.getElementById(name).click()}
              key={index}
            />
          ))
      }

      {(files === null || files.length === 0 || (name === 'videos' || name === 'photos')) && ( 
        <UploadPhotoIcon onClick={() => document.getElementById(name).click()} style={isEmbedURL ? { height: '100px' } : {}}>
          {svg}
          <h5>{title}</h5>
        </UploadPhotoIcon>
      )}

      <InputFile
        name={name}
        type="file"
        accept={accept}
        id={name}
        multiple={name === 'photos' || name === 'videos'}
        onChange={handleImageChange}
      />
    </UploadPhotoWrapper>
  );
};

export const CommunityNameWrapper = styled.div`
  display: flex;
  max-width: 1200px;
  width: 100%;
  padding: 64px 48px;
  flex-direction: column;
  align-items: center;
  gap: 48px;

  border-radius: 16px;
  background: #fff;
  box-shadow: 0px 12px 24px 0px rgba(0, 0, 0, 0.25);
`;
export const CommunityNameDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 48px;
  align-self: stretch;
`;
export const CommunityNameDetails = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 1rem;

  & input.community-name,
  & .community-address {
    text-align: center;

    /* ywh-body-text */
    font-family: Montserrat;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 32.4px; /* 162% */
    width: 100%;
    border-radius: 8px;
    border: 1px solid var(--ywh-alto, #d8d8d8);
    background: var(--sea-salt, #fafafa);
    &:focus {
      outline: none;
    }
    padding: 16px;
  }

  & .community-address {
    text-align: left;
  }

  & textarea {
    display: flex;
    height: 200px;
    min-height: 200px;
    padding: 32px;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    align-self: stretch;
    border-radius: 16px;
    border: 1px solid var(--ywh-alto, #d8d8d8) q;
    background: var(--sea-salt, #fafafa);
    &:focus {
      outline: none;
    }

    /* ywh-body-text */
    font-family: Montserrat;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 32.4px; /* 162% */
  }
`;
export const CommunityNameButtons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  @media (max-width: 600px) {
    flex-direction: column;
  }
`;
export const CommunityByWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  & label {
    color: #000;
    text-align: center;

    /* ywh-h4-bold */
    font-family: Montserrat;
    font-size: 25px;
    font-style: normal;
    font-weight: 700;
    line-height: 37.5px; /* 150% */
  }

  & input {
    width: 50%;
    display: flex;
    padding: 8px 40px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 8px;
    border: 1px solid var(--ywh-alto, #d8d8d8);
    background: var(--sea-salt, #fafafa);
    text-align: center;

    /* ywh-body-text */
    font-family: Montserrat;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 32.4px; /* 162% */
    &:focus {
      outline: none;
    }
  }
`;
export const HomesButton = styled.button`
  display: flex;
  padding: 16px 32px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 100px;
  background: var(--ywh-royal-blue, #04246b);
  color: #fff;
  cursor: pointer;

  /* ywh-button-text-large */
  font-family: Montserrat;
  font-size: 19px;
  font-style: normal;
  font-weight: 500;
  line-height: 19px; /* 100% */

  ${(props) =>
    props.disabled &&
    css`
      background-color: gray;
      cursor: not-allowed;

      &:hover {
        background-color: gray;
      }
    `}
`;

export const MoveToTopButton = styled(HomesButton)`
  position: fixed;
  bottom: 1rem;
  right: 5rem;
  font-size: 80%;
  padding: 8px 16px;
  z-index: 100;
`;
export const QuickFactsWrapper = styled.div`
  display: flex;
  width: 100%;
  max-width: 1457px;
  justify-content: center;
  align-items: flex-start;
  @media (max-width: 992px) {
    padding: 0 32px;
  }
`;
export const QuickFactsContentWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
  align-self: stretch;
  border-radius: 15px;
  border: 1px solid var(--ywh-mystic, #edf2f4);
  box-shadow: 0px 10px 30px 0px #bcbcbc;
  @media (max-width: 992px) {
    flex-direction: column;
  }
`;
export const QuickFactsLeftCol = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
  align-self: stretch;
  border-right: 1px solid var(--ywh-alto, #d8d8d8);
`;
export const QuickFactsRightCol = styled.div`
  display: flex;
  padding: 64px 0px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 80px;
  flex: 1 0 0;
`;
export const QuickFactsRightColDetails = styled.div`
  display: flex;
  padding: 0px 32px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 64px;
  align-self: stretch;
`;
export const QuickFactsTextDetails = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
  gap: 64px;
  align-self: stretch;
  flex-wrap: wrap;
`;
export const FactsCard = styled.div`
  display: flex;
  width: 225px;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;
export const FactsCard160 = styled(FactsCard)`
  width: 160px;
  & input {
    display: flex;
    width: 150px;
    padding: 4px 32px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 8px;
    border: 1px solid var(--ywh-alto, #d8d8d8);
    background: var(--sea-salt, #fafafa);
    text-align: center;

    /* ywh-body-text */
    font-family: Montserrat;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 32.4px; /* 162% */
  }

  & p {
    color: #000;
    text-align: center;

    /* ywh-h4-regular */
    font-family: Montserrat;
    font-size: 25px;
    font-style: normal;
    font-weight: 400;
    line-height: 37.5px; /* 150% */
  }
`;
export const FactsCardIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const FactsCardTextContentWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;

  & label {
    color: #000;
    font-family: Montserrat;
    font-size: 25px;
    font-style: normal;
    font-weight: 700;
    line-height: 37.5px; /* 150% */
  }

  & input {
    display: flex;
    width: 150px;
    justify-content: center;
    align-items: center;
    gap: 8px;

    text-align: center;

    /* ywh-body-text */
    font-family: Montserrat;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 32.4px; /* 162% */
  }
`;
export const SectionHeaderWrapper = styled.div`
  display: flex;
  width: 100%;
  margin: 0 auto;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  padding: 0 1rem;
  @media (min-width: 993px) {
    padding: 0;
    max-width: 1280px;
  }

  & h1 {
    position: absolute;
    color: #e6e9f399;
    font-size: 80px;
    line-height: normal;
    font-weight: 700;
    bottom: 0;
    left: -8px;
    display: none;
    @media (min-width: 993px) {
      display: block;
    }
  }

  & h3 {
    color: #404041;
    font-size: 32px;
    font-weight: 700;
    line-height: 48px; /* 100% */
    border-bottom: 4px solid #cda07d;
    width: 100%;
    @media (max-width: 992px) {
      text-align: center;
    }
  }
`;
export const HighlightsWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 120px;
  align-self: stretch;
  margin: 0 1rem;
  @media (min-width: 993px) {
    margin: 0;
  }

  & .section__content-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 120px;
    align-self: stretch;

    & .section__description {
      display: flex;
      max-width: 1152px;
      width: 100%;
      margin: 0 auto;
      flex-direction: column;
      align-items: center;
      gap: 32px;

      & p {
        font-size: 24px;
        line-height: 36px;
        font-weight: 500;
      }

      & textarea {
        display: flex;
        height: 300px;
        min-height: 300px;
        padding: 32px;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        align-self: stretch;
        border-radius: 16px;
        border: 1px solid var(--ywh-alto, #d8d8d8);
        background: var(--sea-salt, #fafafa);

        /* ywh-body-text */
        font-family: Montserrat;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: 32.4px; /* 162% */
      }
    }
  }

  & .section__highlight-card-wrapper {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    align-content: flex-start;
    gap: 48px;
    align-self: stretch;
    flex-wrap: wrap;
    border-radius: 16px;
    max-width: 1152px;
    margin: 0 auto;

    & .section__highlight-card {
      display: flex;
      width: 290px;
      padding: 32px;
      flex-direction: column;
      align-items: center;
      gap: 24px;
      border-radius: 26px;
      border: 1px dashed #404041;
      position: relative;

      & h5 {
        color: #404041;
        font-size: 20px;
        font-weight: 500;
        line-height: 32px;
      }

      & .section__highlight-menu {
        display: flex;
        gap: 8px;
        position: absolute;
        top: 10px;
        right: 10px;
      }
    }
  }
`;
export const SectionDetails = styled.div`
  display: flex;
  max-width: 1152px;
  width: 100%;
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  position: relative;
  @media (max-width: 992px) {
    flex-direction: column;
  }

  & .close-icon-wrapper {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 5;
  }

  & .section__details-right-col {
    margin-left: -200px;
    max-height: 550px;
    @media (max-width: 992px) {
      margin-left: 0;
      margin-top: -200px;
      flex: 1;
    }
  }
  &:nth-child(odd) {
    flex-direction: row-reverse;
    & .close-icon-wrapper {
      right: unset;
      left: 10px;
    }
    & .section__details-right-col {
      margin-right: -200px;
      margin-left: 0px;
    }
  }

  & .section__details-text {
    display: flex;
    padding: 64px;
    justify-content: flex-end;
    align-items: center;
    align-self: stretch;
    border-radius: 24px;
    box-shadow: 0px 0px 20px 0px #bcbcbc;
    background-color: white;

    @media (max-width: 600px) {
      padding: 2rem;
    }

    & textarea {
      display: flex;
      min-height: 300px;
      padding: 32px;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
      flex: 1 0 0;
      align-self: stretch;

      /* ywh-body-text */
      font-family: Montserrat;
      font-size: 20px;
      font-style: normal;
      font-weight: 400;
      line-height: 32.4px; /* 162% */
      border-radius: 16px;
      border: 1px solid var(--ywh-alto, #d8d8d8);
      background: var(--sea-salt, #fafafa);
    }
  }
`;
export const SectionDetailsLeftCol = styled.div`
  display: flex;
  width: 676px;
  padding: 64px 0px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  flex-shrink: 0;
  z-index: 1;
  position: relative;
  @media (max-width: 768px) {
    width: 100%;
  }
`;
export const SectionDetailsRightCol = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  align-self: auto;
  border-radius: 24px;
  border: 1px solid var(--ywh-alto, #d8d8d8);
  z-index: 0;
`;
export const SectionDetailsText = ({ handleChangeWithIndex, index, value = '' }) => {
  return (
    <div className="section__details-text">
      <textarea
        placeholder="Community Highlights Details"
        name="community_description"
        value={value}
        onChange={(e) => handleChangeWithIndex(e, index)}
      ></textarea>
    </div>
  );
};

export const SectionHeader = ({ title, showH1 = false }) => {
  return (
    <SectionHeaderWrapper className="section__header" style={{ position: 'relative' }}>
      {showH1 && <h1>{title}</h1>}
      <h3 style={{ zIndex: 2 }} dangerouslySetInnerHTML={{ __html: title }}></h3>
    </SectionHeaderWrapper>
  );
};
export const SectionAgentWrapper = styled.section`
  display: flex;
  align-self: stretch;
  background-color: #edf2f4;
  padding-bottom: 100px;
  background-color: #f4f4f6;
  padding: 120px 0;
`;

export const SectionAgentContainer = styled.div`
  display: flex;
  max-width: 1280px;
  width: 100%;
  margin: 0 auto;
  flex-direction: column;
  align-items: center;
  gap: 80px;
  position: relative;
  z-index: 2;
  & .section__header h3 {
    font-size: 32px;
    line-height: 48px;
  }
`;

export const SectionAgentContentWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 16px;
  border: 1px solid #b7b7b7;
  margin: 0 auto;
  padding: 48px;
  gap: 80px;

  @media (max-width: 992px) {
    flex-direction: column;
    padding: 32px;
    gap: 60px;
    max-width: 800px;
  }
`;
export const SectionAgentLeftCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  max-width: 736px;
  padding: 32px 0;
  background-color: white;


  @media (min-width: 993px) {
    padding: 0;
    min-width: 604px;
  }

  & p {
    font-size: 17px;
    line-height: 28px;
  }

  & div.spacer {
    height: 1px;
    border-radius: 10px;
    background-color: #d8d8d8;
  }

  & div.agent-profile {
    display: flex;
    gap: 32px;

    & img {
      width: 300px;
      height: 300px;
      border-radius: 16px;
      object-position: top center;
      object-fit: cover;
    }

    & div {
      max-width: 272px;

      & h2 {
        font-size: 32px;
        line-height: 48px;
        font-weight: 600;
      }

      & h4 {
        font-size: 20px;
        font-weight: 500;
        line-height: 32px;
        margin-bottom: 16px;
      }
    }
  }
`;

export const SectionAgentRightCol = styled.div`
  display: flex;
  padding: 64px 80px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 32px;
  border-radius: 16px;
  background: white;
  padding: 60px;
  flex-basis: 50%;
  border: 1px solid var(--border-light-bd-secondary-light, #dadada);

  @media (min-width: 993px) {
    padding: 32px 64px;
    min-width: 500px;
  }

  & p {
    color: #000;
    font-family: Montserrat;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    & a {
      color: var(--ywh-azure, #5284e0);
      font-family: Montserrat;
      font-size: 17px;
      font-style: normal;
      font-weight: 400;
      line-height: 27.54px;
    }
  }
`;

export const SectionOfficerCol = styled.div`
display: flex;
flex-direction: column;
align-items: flex-start;
gap: 32px;
flex: 1 0 0;
align-self: stretch;
  & p {
    color: #404041;

/* paragraph/body */
font-family: Montserrat;
font-size: 17px;
font-style: normal;
font-weight: 400;
line-height: 28px; /* 164.706% */
  }
`


export const SectionOfficerContainer = styled.div`
display: flex;
align-items: flex-start;
gap: 32px;
flex: 1 0 0;
align-self: stretch;
flex-direction: column;
width: 100%;

& img {
  max-width: 50%;
  width: 100%;
  border-radius: 8px;
  height: auto;
  object-fit: cover;
  margin: 0 auto;

  @media (min-width: 992px) {
    max-width: 300px;
    height: 448px;
  }
}

min-height: unset;

@media (min-width: 992px) {
  min-height: 448px;
  flex-direction: row;

  & img {
    height: 448px;
  }
}

`

export const SectionOfficerDetailsWrapper = styled.div`
display: flex;
flex-direction: column;
justify-content: space-between;
align-items: flex-start;
flex: 1 0 0;
align-self: start;
width: 100%;
gap: 16px;
min-height: auto;

@media (min-width: 992px) {
  min-height: 100%;
}
`

export const SectionOfficerDetails = styled.div`
display: flex;
flex-direction: column;
align-items: flex-start;
gap: 16px;
align-self: stretch;
`

export const SectionOfficerButtonsWrapper = styled.div`
display: flex;
flex-direction: column;
align-items: flex-start;
gap: 16px;
align-self: stretch;

& button {
  width: 100%;
  border-radius: 8px;
  display: flex;
  gap: 12px;
}
`

export const SectionOfficerNameTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  & h4 {
    color: #404041;

    /* heading/head.lg */
    font-family: Montserrat;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: 48px; /* 150% */
  }

  & p {
    color: #404041;

    /* label/lab2 */
    font-family: Montserrat;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 32px; /* 160% */
  }
`
export const SectionOfficerContactDetails = styled(SectionOfficerNameTitle)`
  & p {
    color: #404041;

    /* label/lab3 */
    font-family: Montserrat;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px; /* 155.556% */

    & > span {
      /* paragraph/body */
      font-family: Montserrat;
      font-size: 17px;
      font-style: normal;
      font-weight: 400;
      line-height: 28px;
    }
  }
`

export const SectionAgentForm = styled.form`
display: flex;
flex-direction: column;
justify-content: flex-end;
align-items: center;
gap: 8px;
align-self: stretch;
& button {
    display: flex;
padding: 16px 32px;
justify-content: center;
align-items: center;
gap: 4px;
border-radius: 100px;
background: var(--ywh-royal-blue, #04246B);
color: #FFF;
cursor: pointer;

/* ywh-button-text-large */
font-family: Montserrat;
font-size: 19px;
font-style: normal;
font-weight: 500;
line-height: 19px; /* 100% *
}
`;

export const SectionAgentFormField = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  align-self: stretch;

  & > input,
  & > textarea {
    color: var(--ywh-manatee, #8d99ae);

    /* ywh-card-text */
    font-family: Montserrat;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 27px; /* 150% */
    border-radius: 4px;
    border: 1px solid var(--ywh-alto, #d8d8d8);
    background: var(--ywh-athens-gray, #f4f4f6);
    width: 100%;
    padding: 16px;
    &:focus {
      outline: none;
    }
  }
`;

export const SectionAgentFormFieldText = styled(SectionAgentFormField)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  align-self: stretch;
`;

export const SectionAgentDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 64px;
  align-self: stretch;
`;
export const SectionAgentDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  align-self: stretch;

  & .spacer {
    height: 4px;
    align-self: stretch;
    border-radius: 10px;
    background: var(--ywh-alto, #d8d8d8);
  }
`;
export const SectionAgentDetailsTextFieldWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 32px;
  align-self: stretch;
  @media (max-width: 992px) {
    flex-direction: column;
    gap: 8px;
    text-align: center;
  }
`;
export const SectionAgentDetailsTextFieldWrapperText = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  max-width: 100%;

  & label {
    color: #404041;
    text-align: left;
    font-size: 18px;
    line-height: 28px;
    font-weight: 500;
  }

  & p {
    color: #404041;
    text-align: left;
    font-size: 18px;
    font-style: normal;
    line-height: 28px;
    max-width: 100%;
  }
`;

export const SectionAgentDetailsTextFieldColWrapper = styled.div`
  flex-direction: column;
  gap: 8px;
  & > h3 {
    color: #404041;
    font-size: 32px;
    font-weight: 600;
    line-height: 48px;
  }
  & > p {
    color: #404041;
    text-align: center;
    font-size: 20px;
    font-weight: 500;
    line-height: 32px;
    margin-bottom: -16px;
  }
`;

export const SectionGalleryWrapper = styled.section`
  display: flex;
  padding-top: 60px;
  flex-direction: column;
  align-items: center;
  gap: 80px;
  align-self: stretch;
  position: relative;
  z-index: 5;
`;
export const SectionGallery = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 80px;
  align-self: stretch;
`;
export const SectionGalleryUploadWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;
export const SectionGalleryUploadImageWrapper = styled.div`
  display: flex;
  height: 320px;
  justify-content: center;
  align-items: flex-start;
  align-self: stretch;
  flex-wrap: wrap;
  gap: 1rem;
`;
export const SectionGalleryUploadImage = styled.div`
  display: flex;
  max-width: 475px;
  max-height: 320px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  align-self: stretch;
  border-radius: 16px;
  border: 1px solid var(--ywh-alto, #d8d8d8);
`;
export const SectionGalleryMediaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 64px;
  align-self: stretch;
`;
export const SectionGalleryVideo = styled.div`
  display: flex;
  width: 1280px;
  height: 720px;
  align-items: center;
  gap: 8px;
  position: relative;
  border-radius: 16px;
  overflow: hidden;

  & .close-icon-wrapper {
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 5;
  }

  &::before {
    content: '';
    height: 105px;
    width: 105px;
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='105' height='105' viewBox='0 0 105 105' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M53.0758 90.4666C57.9691 90.4666 62.8145 89.5028 67.3353 87.6302C71.8561 85.7577 75.9639 83.013 79.424 79.5529C82.884 76.0928 85.6288 71.985 87.5013 67.4642C89.3739 62.9434 90.3377 58.098 90.3377 53.2047C90.3377 48.3113 89.3739 43.466 87.5013 38.9451C85.6288 34.4243 82.884 30.3166 79.424 26.8565C75.9639 23.3964 71.8561 20.6517 67.3353 18.7791C62.8145 16.9065 57.9691 15.9427 53.0758 15.9427C43.1933 15.9427 33.7155 19.8685 26.7276 26.8565C19.7396 33.8444 15.8138 43.3222 15.8138 53.2047C15.8138 63.0872 19.7396 72.5649 26.7276 79.5529C33.7155 86.5408 43.1933 90.4666 53.0758 90.4666ZM53.0758 98.7471C78.2276 98.7471 98.6182 78.3565 98.6182 53.2047C98.6182 28.0528 78.2276 7.66224 53.0758 7.66224C27.9239 7.66224 7.53333 28.0528 7.53333 53.2047C7.53333 78.3565 27.9239 98.7471 53.0758 98.7471Z' fill='%23FAFAFA'/%3E%3Cpath d='M53.0758 90.4666C57.9691 90.4666 62.8145 89.5028 67.3353 87.6302C71.8561 85.7577 75.9639 83.013 79.424 79.5529C82.884 76.0928 85.6288 71.985 87.5013 67.4642C89.3739 62.9434 90.3377 58.098 90.3377 53.2047C90.3377 48.3113 89.3739 43.466 87.5013 38.9451C85.6288 34.4243 82.884 30.3166 79.424 26.8565C75.9639 23.3964 71.8561 20.6517 67.3353 18.7791C62.8145 16.9065 57.9691 15.9427 53.0758 15.9427C43.1933 15.9427 33.7155 19.8685 26.7276 26.8565C19.7396 33.8444 15.8138 43.3222 15.8138 53.2047C15.8138 63.0872 19.7396 72.5649 26.7276 79.5529C33.7155 86.5408 43.1933 90.4666 53.0758 90.4666Z' fill='%23CDA07D'/%3E%3Cpath d='M69.6366 53.2047L44.7953 71.1318V35.2775L69.6366 53.2047Z' fill='white'/%3E%3C/svg%3E");
  }
  & video {
    width: 100%;
  }
`;
export const SectionGalleryImages = styled.div`
  display: flex;
  max-width: 1280px;
  justify-content: center;
  align-items: center;
  align-content: center;
  gap: 0;
  align-self: stretch;
  flex-wrap: wrap;
  width: 100%;
  @media (min-width: 993px) {
    max-width: 1280px;
    margin: 0 auto;
  }
`;
export const SectionGalleryImage = styled.div`
  background-color: black;
  display: flex;
  flex-basis: 100%;
  height: 320px;
  align-items: center;
  position: relative;
  border-radius: 8px;
  border: 1px solid white;
  overflow: hidden;
  @media (min-width: 401px) {
    flex-basis: 50%;
  }
  @media (min-width: 993px) {
    flex-basis: 33%;
  }

  & .close-icon-wrapper {
    position: absolute;
    right: 10px;
    top: 10px;
  }

  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
export const SectionBuilderDetailsContainer = styled.section`
  display: flex;
  max-width: 1280px;
  width: 100%;
  margin: 0 auto;
  flex-direction: column;
  align-items: center;
  gap: 80px;
  position: relative;
  z-index: 5;
`;
export const SectionBuilderDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 136px;
  align-self: stretch;
`;
export const SectionBuilderDescriptionWrapper = styled.div`
  display: flex;
  max-width: 1280px;
  width: 100%;
  margin: 0 auto;
  padding: 0px 120px;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  @media (max-width: 768px) {
    padding: 0px 32px;
  }

  & textarea {
    color: #404041;
    display: flex;
    height: 300px;
    min-height: 300px;
    padding: 32px;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    align-self: stretch;
    border-radius: 16px;
    border: 1px solid var(--ywh-alto, #d8d8d8);
    background: var(--sea-salt, #fafafa);

    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 32px;
  }

  & p {
    color: #404041;
    text-align: center;
    font-size: 20px;
    font-weight: 400;
    line-height: 32px;
  }
`;
export const SectionBuilderLogoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  & .upload-photo-wrapper {
    flex: 0;
    padding-bottom: 32px;
    overflow: hidden;
  }
`;
export const SectionBuilderDetailsContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 80px;
  align-self: stretch;
  position: relative;
  z-index: 5;
`;
export const SectionBuilderDetailsContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 80px;
  align-self: stretch;
`;
export const SectionBuilderDetailsContentLeftCol = styled.div`
  display: flex;
  align-items: center;
  flex: 1 0 0;

  & textarea {
    display: flex;
    min-height: 300px;
    padding: 32px;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    flex: 1 0 0;
    align-self: stretch;
    border-radius: 16px;
    border: 1px solid var(--ywh-alto, #d8d8d8);
    background: var(--sea-salt, #fafafa);

    /* ywh-body-text */
    font-family: Montserrat;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 32.4px; /* 162% */
  }

  & p {
    color: var(--ywh-raisin-black, #2f2f2f);
    text-align: justify;

    /* ywh-h4-regular */
    font-family: Montserrat;
    font-size: 25px;
    font-style: normal;
    font-weight: 400;
    line-height: 37.5px; /* 150% */
  }
`;
export const SectionBuilderDetailsContentRightCol = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1 0 0;
  align-self: stretch;
  border-radius: 16px;
  border: 1px solid var(--ywh-alto, #d8d8d8);

  & .upload-photo-wrapper {
    flex: 0;
  }
`;
export const SectionBuilderDetailsContentText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;

  & textarea {
    display: flex;
    min-height: 300px;
    padding: 32px;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    flex: 1 0 0;
    align-self: stretch;
    border-radius: 16px;
    border: 1px solid var(--ywh-alto, #d8d8d8);
    background: var(--sea-salt, #fafafa);

    /* ywh-body-text */
    font-family: Montserrat;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 32.4px; /* 162% */
  }

  & p {
    max-width: 1160px;
    width: 100%;
    margin: 0 auto;
    color: var(--ywh-raisin-black, #2f2f2f);
    text-align: center;
    font-family: Montserrat;
    font-size: 39px;
    font-style: normal;
    font-weight: 400;
    line-height: 50.7px; /* 130% */
    padding: 32px;
  }
`;

export const EmbedUrlForm = styled.div`
  z-index: 5;
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	border-width: 1px 0px 0px 0px;
	border-style: solid;
	border-color: #d8d8d8;

	p {
 		display: flex;
		justify-content: center;
		width: 30%;
		font-size: 15px;
		padding: 5px;
	}

	input {
		font-size: 15px;
		width: 70%;
		border-width: 0px 0px 0px 1px;
		border-radius: 0px 0px 0px 0px;
		border-color: #d8d8d8;
		outline: none
	}

	.embed-url-submit {
		cursor: pointer;
		margin: 0 5px;
	}
`;

export const EmbedUrlGuidleines = styled.div`
	display: flex;
	flex-direction: column;
	gap: 5px;
	padding: 10px;

	.title {
 		font-size: 15px;
	}

	.sub-title {
 		font-size: 12px;
	}

	.instructions {
 		display: flex;
		flex-direction: column;
		gap: 5px;

 		p {
 			font-size: 15px;
			font-weight: 500;
		}

 		span {
 			font-size: 12px;
			background: #282828;
			color: #e2e2e2;
			padding: 5px 5px 5px 15px;
			border-radius: 5px;
			align-items: center;
			display: flex;
		}
	}
`

export const HighlightIcon = ({ variant }) => {
  switch (variant) {
    case 'Community Center':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="112" height="112" viewBox="0 0 112 112" fill="none">
          <circle cx="56" cy="56" r="52" fill="#3C4D7D" stroke="#C3CADA" strokeWidth="8" />
          <path
            d="M66 48C66 47.4696 65.7893 46.9609 65.4142 46.5858C65.0391 46.2107 64.5304 46 64 46C63.4696 46 62.9609 46.2107 62.5858 46.5858C62.2107 46.9609 62 47.4696 62 48V54C62 54.5304 62.2107 55.0391 62.5858 55.4142C62.9609 55.7893 63.4696 56 64 56C64.5304 56 65.0391 55.7893 65.4142 55.4142C65.7893 55.0391 66 54.5304 66 54V48ZM56 46C56.5304 46 57.0391 46.2107 57.4142 46.5858C57.7893 46.9609 58 47.4696 58 48V54C58 54.5304 57.7893 55.0391 57.4142 55.4142C57.0391 55.7893 56.5304 56 56 56C55.4696 56 54.9609 55.7893 54.5858 55.4142C54.2107 55.0391 54 54.5304 54 54V48C54 47.4696 54.2107 46.9609 54.5858 46.5858C54.9609 46.2107 55.4696 46 56 46ZM50 48C50 47.4696 49.7893 46.9609 49.4142 46.5858C49.0391 46.2107 48.5304 46 48 46C47.4696 46 46.9609 46.2107 46.5858 46.5858C46.2107 46.9609 46 47.4696 46 48V54C46 54.5304 46.2107 55.0391 46.5858 55.4142C46.9609 55.7893 47.4696 56 48 56C48.5304 56 49.0391 55.7893 49.4142 55.4142C49.7893 55.0391 50 54.5304 50 54V48ZM40 60C40.5304 60 41.0391 60.2107 41.4142 60.5858C41.7893 60.9609 42 61.4696 42 62V68C42 68.5304 41.7893 69.0391 41.4142 69.4142C41.0391 69.7893 40.5304 70 40 70C39.4696 70 38.9609 69.7893 38.5858 69.4142C38.2107 69.0391 38 68.5304 38 68V62C38 61.4696 38.2107 60.9609 38.5858 60.5858C38.9609 60.2107 39.4696 60 40 60ZM74 62C74 61.4696 73.7893 60.9609 73.4142 60.5858C73.0391 60.2107 72.5304 60 72 60C71.4696 60 70.9609 60.2107 70.5858 60.5858C70.2107 60.9609 70 61.4696 70 62V68C70 68.5304 70.2107 69.0391 70.5858 69.4142C70.9609 69.7893 71.4696 70 72 70C72.5304 70 73.0391 69.7893 73.4142 69.4142C73.7893 69.0391 74 68.5304 74 68V62ZM56 24H65.334C66.07 24 66.668 24.596 66.668 25.334V30.666C66.668 31.0198 66.5275 31.3591 66.2773 31.6093C66.0271 31.8595 65.6878 32 65.334 32H58V34.11C62.4004 34.602 66.4651 36.6986 69.4169 39.9991C72.3687 43.2995 74.0004 47.5722 74 52H78C79.5913 52 81.1174 52.6321 82.2426 53.7574C83.3679 54.8826 84 56.4087 84 58V76C84 76.5304 83.7893 77.0391 83.4142 77.4142C83.0391 77.7893 82.5304 78 82 78H30C29.4696 78 28.9609 77.7893 28.5858 77.4142C28.2107 77.0391 28 76.5304 28 76V58C28 56.4087 28.6321 54.8826 29.7574 53.7574C30.8826 52.6321 32.4087 52 34 52H38C37.9996 47.5722 39.6313 43.2995 42.5831 39.9991C45.5349 36.6986 49.5996 34.602 54 34.11V26C54 25.4696 54.2107 24.9609 54.5858 24.5858C54.9609 24.2107 55.4696 24 56 24ZM56 38C52.287 38 48.726 39.475 46.1005 42.1005C43.475 44.726 42 48.287 42 52V54C42 54.5304 41.7893 55.0391 41.4142 55.4142C41.0391 55.7893 40.5304 56 40 56H34C33.4696 56 32.9609 56.2107 32.5858 56.5858C32.2107 56.9609 32 57.4696 32 58V74H49V68C49 67.4696 49.2107 66.9609 49.5858 66.5858C49.9609 66.2107 50.4696 66 51 66H61C61.5304 66 62.0391 66.2107 62.4142 66.5858C62.7893 66.9609 63 67.4696 63 68V74H80V58C80 57.4696 79.7893 56.9609 79.4142 56.5858C79.0391 56.2107 78.5304 56 78 56H72C71.4696 56 70.9609 55.7893 70.5858 55.4142C70.2107 55.0391 70 54.5304 70 54V52C70 48.287 68.525 44.726 65.8995 42.1005C63.274 39.475 59.713 38 56 38ZM59 70H53V74H59V70Z"
            fill="#F4F4F6"
          />
        </svg>
      );
    case 'Park':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="112" height="112" viewBox="0 0 112 112" fill="none">
          <circle cx="56" cy="56" r="52" fill="#3C4D7D" stroke="#C3CADA" strokeWidth="8" />
          <path
            d="M83.4182 72.8H74.4545V65.3334H81.3091C81.5496 65.3334 81.7869 65.278 82.0031 65.1713C82.2192 65.0645 82.4084 64.9094 82.5563 64.7176C82.7043 64.5258 82.807 64.3024 82.8568 64.0644C82.9065 63.8264 82.902 63.58 82.8435 63.3441L74.4071 29.211C74.3214 28.8651 74.1238 28.558 73.8458 28.3386C73.5678 28.1192 73.2253 28 72.8727 28C72.5201 28 72.1776 28.1192 71.8996 28.3386C71.6216 28.558 71.4241 28.8651 71.3384 29.211L62.902 63.3441C62.8435 63.58 62.8389 63.8264 62.8887 64.0644C62.9384 64.3024 63.0412 64.5258 63.1891 64.7176C63.337 64.9094 63.5263 65.0645 63.7424 65.1713C63.9585 65.278 64.1959 65.3334 64.4364 65.3334H71.2909V72.8H53.3636V67.4667H56C56.4195 67.4667 56.8219 67.2982 57.1185 66.9981C57.4152 66.6981 57.5818 66.2911 57.5818 65.8667C57.5818 65.4424 57.4152 65.0354 57.1185 64.7354C56.8219 64.4353 56.4195 64.2668 56 64.2668H53.3636V58.9335H56C56.4195 58.9335 56.8219 58.7649 57.1185 58.4648C57.4152 58.1648 57.5818 57.7578 57.5818 57.3335C57.5818 56.9091 57.4152 56.5022 57.1185 56.2021C56.8219 55.9021 56.4195 55.7335 56 55.7335H32.8C32.3805 55.7335 31.9781 55.9021 31.6815 56.2021C31.3848 56.5022 31.2182 56.9091 31.2182 57.3335C31.2182 57.7578 31.3848 58.1648 31.6815 58.4648C31.9781 58.7649 32.3805 58.9335 32.8 58.9335H35.4364V64.2668H32.8C32.3805 64.2668 31.9781 64.4353 31.6815 64.7354C31.3848 65.0354 31.2182 65.4424 31.2182 65.8667C31.2182 66.2911 31.3848 66.6981 31.6815 66.9981C31.9781 67.2982 32.3805 67.4667 32.8 67.4667H35.4364V72.8H28.5818C28.1623 72.8 27.76 72.9686 27.4633 73.2686C27.1667 73.5687 27 73.9757 27 74.4C27 74.8244 27.1667 75.2313 27.4633 75.5314C27.76 75.8314 28.1623 76 28.5818 76H83.4182C83.8377 76 84.24 75.8314 84.5367 75.5314C84.8333 75.2313 85 74.8244 85 74.4C85 73.9757 84.8333 73.5687 84.5367 73.2686C84.24 72.9686 83.8377 72.8 83.4182 72.8ZM72.8727 36.1976L79.2844 62.1334H66.4611L72.8727 36.1976ZM38.6 58.9335H50.2V64.2668H38.6V58.9335ZM38.6 67.4667H50.2V72.8H38.6V67.4667ZM52.8364 46.1336C54.1921 46.1336 55.5173 45.7269 56.6445 44.9651C57.7718 44.2033 58.6503 43.1204 59.1691 41.8535C59.6879 40.5866 59.8237 39.1926 59.5592 37.8477C59.2947 36.5027 58.6419 35.2673 57.6833 34.2977C56.7246 33.3281 55.5033 32.6677 54.1736 32.4002C52.844 32.1327 51.4657 32.27 50.2132 32.7948C48.9607 33.3195 47.8902 34.2082 47.137 35.3484C46.3838 36.4885 45.9818 37.829 45.9818 39.2003C45.9818 41.0391 46.704 42.8026 47.9895 44.1028C49.2749 45.4031 51.0184 46.1336 52.8364 46.1336ZM52.8364 35.467C53.5664 35.467 54.28 35.6859 54.8869 36.0962C55.4939 36.5064 55.967 37.0894 56.2463 37.7716C56.5257 38.4538 56.5988 39.2044 56.4564 39.9286C56.3139 40.6528 55.9624 41.318 55.4462 41.8401C54.93 42.3622 54.2724 42.7178 53.5564 42.8619C52.8405 43.0059 52.0983 42.932 51.4239 42.6494C50.7495 42.3668 50.173 41.8883 49.7675 41.2744C49.3619 40.6605 49.1455 39.9387 49.1455 39.2003C49.1455 38.2101 49.5343 37.2606 50.2265 36.5604C50.9187 35.8603 51.8575 35.467 52.8364 35.467Z"
            fill="#F4F4F6"
            fill-opacity="0.92549"
          />
        </svg>
      );
    case 'Trails':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="112" height="112" viewBox="0 0 112 112" fill="none">
          <circle cx="56" cy="56" r="52" fill="#3C4D7D" stroke="#C3CADA" strokeWidth="8" />
          <path
            d="M56 74.1538V82M56 50.6154V58.4615M56 31V34.9231M76 50.6154H36.8287C36.5659 50.6154 36.3057 50.5647 36.0629 50.466C35.8201 50.3674 35.5995 50.2227 35.4137 50.0404L28 42.7692L35.4137 35.4981C35.5995 35.3157 35.8201 35.1711 36.0629 35.0725C36.3057 34.9738 36.5659 34.923 36.8287 34.9231H76C76.5304 34.9231 77.0391 35.1297 77.4142 35.4976C77.7893 35.8655 78 36.3644 78 36.8846V48.6538C78 49.1741 77.7893 49.673 77.4142 50.0409C77.0391 50.4087 76.5304 50.6154 76 50.6154ZM36 74.1538H75.1712C75.4341 74.1539 75.6943 74.1031 75.9371 74.0045C76.1799 73.9058 76.4005 73.7612 76.5863 73.5789L84 66.3077L76.5863 59.0365C76.4005 58.8542 76.1799 58.7096 75.9371 58.6109C75.6943 58.5123 75.4341 58.4615 75.1712 58.4615H36C35.4696 58.4615 34.9609 58.6682 34.5858 59.0361C34.2107 59.4039 34 59.9028 34 60.4231V72.1923C34 72.7125 34.2107 73.2115 34.5858 73.5793C34.9609 73.9472 35.4696 74.1538 36 74.1538Z"
            stroke="#F4F4F6"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'Greenbelt':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="112" height="112" viewBox="0 0 112 112" fill="none">
          <circle cx="56" cy="56" r="52" fill="#3C4D7D" stroke="#C3CADA" strokeWidth="8" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M30 77.3889C30 76.4312 30.3805 75.5127 31.0577 74.8354C31.7349 74.1582 32.6534 73.7778 33.6111 73.7778H78.3884C79.3461 73.7778 80.2646 74.1582 80.9418 74.8354C81.619 75.5127 81.9995 76.4312 81.9995 77.3889C81.9995 78.3466 81.619 79.2651 80.9418 79.9423C80.2646 80.6196 79.3461 81 78.3884 81H33.6111C32.6534 81 31.7349 80.6196 31.0577 79.9423C30.3805 79.2651 30 78.3466 30 77.3889ZM33.6111 76.6667C33.4195 76.6667 33.2358 76.7428 33.1004 76.8782C32.965 77.0136 32.8889 77.1973 32.8889 77.3889C32.8889 77.5804 32.965 77.7641 33.1004 77.8996C33.2358 78.035 33.4195 78.1111 33.6111 78.1111H78.3884C78.58 78.1111 78.7637 78.035 78.8991 77.8996C79.0345 77.7641 79.1106 77.5804 79.1106 77.3889C79.1106 77.1973 79.0345 77.0136 78.8991 76.8782C78.7637 76.7428 78.58 76.6667 78.3884 76.6667H33.6111ZM42.9999 73.7778V50.6667H45.8887V73.7778H42.9999Z"
            fill="#F4F4F6"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M48.9191 40.8517L49.4391 38.4943C49.5279 38.0867 49.5725 37.6707 49.572 37.2536C49.572 34.1624 47.2118 31.8889 44.5815 31.8889C41.9512 31.8889 39.5924 34.1624 39.5924 37.2536C39.5924 37.684 39.6386 38.0986 39.7253 38.4943L40.2438 40.8517L38.0151 41.7804C36.6862 42.3337 35.652 43.7507 35.652 45.5071C35.652 45.9347 35.7141 46.3391 35.8253 46.7161L36.484 48.9709L34.4127 50.0773C33.8965 50.3504 33.4867 50.7886 33.2486 51.3218C33.0106 51.8551 32.958 52.4527 33.0993 53.0194C33.2406 53.586 33.5677 54.0889 34.0283 54.4479C34.4889 54.8069 35.0565 55.0013 35.6404 55H53.5225C54.1058 55 54.6723 54.8049 55.132 54.4458C55.5917 54.0867 55.918 53.5842 56.0592 53.0182C56.2004 52.4523 56.1482 51.8554 55.911 51.3225C55.6738 50.7895 55.2652 50.3513 54.7503 50.0773L52.6789 48.9709L53.3391 46.7176C53.4539 46.3249 53.5118 45.9177 53.5109 45.5086C53.5109 43.7507 52.4767 42.3337 51.1478 41.7819L48.9191 40.8517ZM56.1124 47.5293C57.1954 48.1068 58.0543 49.0296 58.5525 50.1513C59.0508 51.2729 59.1599 52.5289 58.8624 53.7196C58.5648 54.9103 57.8778 55.9674 56.9106 56.7229C55.9433 57.4783 54.7512 57.8887 53.5239 57.8889H35.6404C34.4131 57.8887 33.2211 57.4783 32.2538 56.7229C31.2865 55.9674 30.5995 54.9103 30.302 53.7196C30.0045 52.5289 30.1136 51.2729 30.6118 50.1513C31.1101 49.0296 31.969 48.1068 33.052 47.5293C32.8596 46.8725 32.7624 46.1915 32.7631 45.5071C32.7631 42.6067 34.4777 40.1251 36.9043 39.114C36.7699 38.503 36.7021 37.8792 36.7021 37.2536C36.7021 32.6949 40.2323 29 44.5829 29C48.935 29 52.4623 32.6949 52.4623 37.2536C52.4623 37.8934 52.3929 38.516 52.2601 39.114C54.6867 40.1251 56.4012 42.6067 56.4012 45.5071C56.4012 46.212 56.3001 46.8894 56.1124 47.5293ZM69.8691 52.1154C69.8364 52.1172 69.8039 52.1225 69.7723 52.1313C66.5368 53.2854 64.5623 55.6991 63.1424 59.8057C63.0152 60.1652 62.751 60.4599 62.4074 60.6254C62.0638 60.7909 61.6687 60.8138 61.3083 60.6891C60.9479 60.5644 60.6514 60.3022 60.4836 59.9597C60.3157 59.6172 60.2902 59.2223 60.4124 58.861C62.0056 54.2532 64.4612 50.957 68.8046 49.41C69.8099 49.0518 71.0001 49.2612 71.874 49.5833C72.7421 49.9054 73.8211 50.5323 74.3338 51.5478C74.6285 52.1299 74.8856 52.6513 75.1196 53.128C75.4316 53.7636 75.7046 54.3182 75.9747 54.8324C76.4369 55.7121 76.8053 56.3029 77.1779 56.7247C77.5246 57.1204 77.8828 57.3732 78.3522 57.548C78.8535 57.7358 79.5468 57.86 80.5954 57.8889C80.9785 57.8996 81.3417 58.0621 81.605 58.3406C81.8683 58.619 82.0102 58.9907 81.9994 59.3738C81.9887 59.7569 81.8262 60.12 81.5478 60.3833C81.2693 60.6466 80.8976 60.7885 80.5146 60.7778C79.3041 60.7431 78.2569 60.5987 77.3397 60.2549C76.4394 59.9209 75.6383 59.3644 75.0113 58.6371C74.4017 57.9452 73.9048 57.1031 73.4166 56.1743C73.1035 55.569 72.7978 54.9599 72.4994 54.3471C72.2654 53.8704 72.017 53.3678 71.7541 52.8478C71.6926 52.7643 71.6168 52.6924 71.5302 52.6354C71.3276 52.4922 71.1065 52.3771 70.873 52.2931C70.634 52.2036 70.3845 52.1453 70.1306 52.1198C70.0437 52.1108 69.9562 52.1093 69.8691 52.1154Z"
            fill="#F4F4F6"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M68.4073 49.9502C68.5962 49.9672 68.7799 50.0213 68.948 50.1094C69.116 50.1975 69.265 50.3178 69.3865 50.4634C69.508 50.6091 69.5997 50.7773 69.6562 50.9584C69.7127 51.1394 69.733 51.3299 69.7159 51.5188L69.0573 58.7642L76.3228 65.6065C76.4729 65.7474 76.5911 65.9188 76.6694 66.1092L79.0022 71.7844C79.1478 72.1387 79.1466 72.5364 78.999 72.8899C78.8513 73.2434 78.5693 73.5238 78.215 73.6694C77.8606 73.8149 77.463 73.8138 77.1094 73.6662C76.7559 73.5185 76.4756 73.2365 76.33 72.8822L74.1157 67.4958L66.5642 60.3848C66.4047 60.2345 66.2815 60.0499 66.2039 59.8449C66.1264 59.64 66.0964 59.4201 66.1164 59.2018L66.8386 51.2574C66.8735 50.8761 67.0582 50.5242 67.3524 50.2791C67.6465 50.0339 68.026 49.9156 68.4073 49.9502Z"
            fill="#F4F4F6"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M71.8437 53.19C71.9359 52.8196 71.8778 52.4278 71.6821 52.1001C71.4863 51.7724 71.1687 51.5355 70.7989 51.4412C70.429 51.3469 70.0368 51.4029 69.708 51.5969C69.3793 51.7909 69.1407 52.1071 69.0444 52.4765L67.1031 60.08C67.366 60.1306 67.6173 60.2534 67.8253 60.4513L69.5687 62.1008L71.8437 53.19ZM68.7382 65.293L66.3505 63.0325L66.0602 64.1678L64.8613 68.1386L60.8963 71.1878C60.5926 71.4215 60.394 71.7663 60.3445 72.1463C60.2949 72.5264 60.3983 72.9106 60.632 73.2144C60.8657 73.5182 61.2105 73.7167 61.5905 73.7662C61.9706 73.8158 62.3548 73.7124 62.6586 73.4787L66.9918 70.1449C67.2309 69.9606 67.4062 69.706 67.4931 69.4169L68.7382 65.293Z"
            fill="#F4F4F6"
          />
          <path
            d="M76.2218 44.1667C76.2218 45.1244 75.8414 46.0429 75.1642 46.7201C74.487 47.3973 73.5685 47.7778 72.6108 47.7778C71.653 47.7778 70.7346 47.3973 70.0573 46.7201C69.3801 46.0429 68.9997 45.1244 68.9997 44.1667C68.9997 43.2089 69.3801 42.2904 70.0573 41.6132C70.7346 40.936 71.653 40.5556 72.6108 40.5556C73.5685 40.5556 74.487 40.936 75.1642 41.6132C75.8414 42.2904 76.2218 43.2089 76.2218 44.1667ZM74.0552 55L71.8019 63.6667L66.4387 59.4186L66.8764 52.3653L71.8019 52.1111L74.0552 55Z"
            fill="#F4F4F6"
          />
        </svg>
      );
    case 'Pool':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="112" height="112" viewBox="0 0 112 112" fill="none">
          <circle cx="56" cy="56" r="52" fill="#3C4D7D" stroke="#C3CADA" strokeWidth="8" />
          <path
            d="M70.4 61.2368V38.7368C70.4 36.1197 72.548 34 75.2 34H80M39.2 61.2368V38.7368C39.2 36.1197 41.348 34 44 34H48.8M39.2 43.4737H70.4M39.2 52.9474H70.4M32 69.5263L35 71.1267C36.92 72.1508 39.08 72.1508 41 71.1267C42.92 70.1024 45.08 70.1024 47 71.1267C48.92 72.1508 51.08 72.1508 53 71.1267C54.92 70.1024 57.08 70.1024 59 71.1267C60.92 72.1508 63.08 72.1508 65 71.1267C66.92 70.1024 69.08 70.1024 71 71.1267C72.92 72.1508 75.08 72.1508 77 71.1267L80 69.5263M32 76.6316L35 78.2319C36.92 79.256 39.08 79.256 41 78.2319C42.92 77.2077 45.08 77.2077 47 78.2319C48.92 79.256 51.08 79.256 53 78.2319C54.92 77.2077 57.08 77.2077 59 78.2319C60.92 79.256 63.08 79.256 65 78.2319C66.92 77.2077 69.08 77.2077 71 78.2319C72.92 79.256 75.08 79.256 77 78.2319L80 76.6316"
            stroke="#F4F4F6"
            strokeWidth="4"
            stroke-miterlimit="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'Clubhouse':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="112" height="112" viewBox="0 0 112 112" fill="none">
          <circle cx="56" cy="56" r="52" fill="#3C4D7D" stroke="#C3CADA" strokeWidth="8" />
          <path
            d="M83.0667 73.231H79.2V46.8477C79.2 45.848 78.7926 44.8894 78.0675 44.1825C77.3423 43.4757 76.3588 43.0786 75.3333 43.0786H59.8667V31.7715C59.8671 31.089 59.6774 30.4191 59.3179 29.8335C58.9583 29.2479 58.4423 28.7684 57.825 28.4462C57.2077 28.1241 56.5123 27.9714 55.8129 28.0044C55.1135 28.0374 54.4365 28.255 53.854 28.6338L34.5207 41.1941C33.9903 41.539 33.5557 42.0064 33.2555 42.5547C32.9553 43.1029 32.7988 43.7151 32.8 44.3365V73.231H28.9333C28.4206 73.231 27.9288 73.4295 27.5663 73.7829C27.2037 74.1363 27 74.6157 27 75.1155C27 75.6153 27.2037 76.0946 27.5663 76.448C27.9288 76.8015 28.4206 77 28.9333 77H83.0667C83.5794 77 84.0712 76.8015 84.4337 76.448C84.7963 76.0946 85 75.6153 85 75.1155C85 74.6157 84.7963 74.1363 84.4337 73.7829C84.0712 73.4295 83.5794 73.231 83.0667 73.231ZM75.3333 46.8477V73.231H59.8667V46.8477H75.3333ZM36.6667 44.3365L56 31.7715V73.231H36.6667V44.3365ZM52.1333 50.6167V54.3857C52.1333 54.8856 51.9296 55.3649 51.5671 55.7183C51.2045 56.0717 50.7128 56.2703 50.2 56.2703C49.6872 56.2703 49.1955 56.0717 48.8329 55.7183C48.4704 55.3649 48.2667 54.8856 48.2667 54.3857V50.6167C48.2667 50.1169 48.4704 49.6376 48.8329 49.2841C49.1955 48.9307 49.6872 48.7322 50.2 48.7322C50.7128 48.7322 51.2045 48.9307 51.5671 49.2841C51.9296 49.6376 52.1333 50.1169 52.1333 50.6167ZM44.4 50.6167V54.3857C44.4 54.8856 44.1963 55.3649 43.8337 55.7183C43.4712 56.0717 42.9794 56.2703 42.4667 56.2703C41.9539 56.2703 41.4622 56.0717 41.0996 55.7183C40.737 55.3649 40.5333 54.8856 40.5333 54.3857V50.6167C40.5333 50.1169 40.737 49.6376 41.0996 49.2841C41.4622 48.9307 41.9539 48.7322 42.4667 48.7322C42.9794 48.7322 43.4712 48.9307 43.8337 49.2841C44.1963 49.6376 44.4 50.1169 44.4 50.6167ZM44.4 63.8084V67.5774C44.4 68.0772 44.1963 68.5565 43.8337 68.91C43.4712 69.2634 42.9794 69.4619 42.4667 69.4619C41.9539 69.4619 41.4622 69.2634 41.0996 68.91C40.737 68.5565 40.5333 68.0772 40.5333 67.5774V63.8084C40.5333 63.3085 40.737 62.8292 41.0996 62.4758C41.4622 62.1224 41.9539 61.9238 42.4667 61.9238C42.9794 61.9238 43.4712 62.1224 43.8337 62.4758C44.1963 62.8292 44.4 63.3085 44.4 63.8084ZM52.1333 63.8084V67.5774C52.1333 68.0772 51.9296 68.5565 51.5671 68.91C51.2045 69.2634 50.7128 69.4619 50.2 69.4619C49.6872 69.4619 49.1955 69.2634 48.8329 68.91C48.4704 68.5565 48.2667 68.0772 48.2667 67.5774V63.8084C48.2667 63.3085 48.4704 62.8292 48.8329 62.4758C49.1955 62.1224 49.6872 61.9238 50.2 61.9238C50.7128 61.9238 51.2045 62.1224 51.5671 62.4758C51.9296 62.8292 52.1333 63.3085 52.1333 63.8084Z"
            fill="#F4F4F6"
          />
        </svg>
      );
    case 'Baseball Field':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120" fill="none">
          <g filter="url(#filter0_d_1713_603)">
            <circle cx="60" cy="56" r="48" fill="#3C4D7D" />
            <circle cx="60" cy="56" r="52" stroke="#C3CADA" strokeWidth="8" />
          </g>
          <path
            d="M60 29C38.3636 29 26 50 26 50L51.6545 74.9C53.0145 73.31 54.8073 72.11 56.9091 71.51L47.1109 62L60 49.49L72.8891 62L63.0909 71.51C65.1927 72.11 67.0164 73.31 68.3455 74.9L94 50C94 50 81.6364 29 60 29ZM77.2782 57.77L60 41L42.7218 57.77L34.0055 49.28C38.2091 44 47.2964 35 60 35C72.6109 35 81.7291 44 85.9636 49.31L77.2782 57.77ZM63.0909 62C63.0909 63.65 61.7 65 60 65C58.3 65 56.9091 63.65 56.9091 62C56.9091 60.35 58.3 59 60 59C61.7 59 63.0909 60.35 63.0909 62ZM64.6364 83L60 86L55.3636 83V77H64.6364V83Z"
            fill="white"
          />
        </svg>
      );
    case 'Basketball Court':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120" fill="none">
          <g filter="url(#filter0_d_1713_359)">
            <circle cx="60" cy="56" r="48" fill="#3C4D7D" />
            <circle cx="60" cy="56" r="52" stroke="#C3CADA" strokeWidth="8" />
          </g>
          <path
            d="M61.2631 83.5815L61.2478 83.848L61.2191 84.3483L61.7194 84.3759L63.9564 84.4992L64.4547 84.5267L64.4831 84.0285L64.5087 83.5815H66.3471C66.346 83.6993 66.3454 83.8182 66.3454 83.9383V84.4383H66.8454H69.0857H69.5857V83.9383C69.5857 78.8073 70.4715 75.3403 71.6722 71.2306L89.2002 63.5695L89.5 63.4385V63.1114V46.4227V46.2823L89.4269 46.1624L89.2672 45.9005L89.2671 45.9003C83.1571 35.886 74.6136 27.5 60 27.5C45.3864 27.5 36.8429 35.886 30.7329 45.9006L30.5732 46.162L30.5 46.282V46.4226V63.1114V63.4385L30.7998 63.5695L48.2929 71.2153C49.5118 75.386 50.4142 78.7618 50.4142 83.9383V84.4383H50.9142H53.1545H53.6545V83.9383C53.6545 83.8182 53.6539 83.6994 53.6529 83.5815H55.4486L55.473 84.025L55.5004 84.5232L55.9987 84.4969L58.2357 84.3784L58.7358 84.3519L58.7085 83.8518L58.6937 83.5815H61.2631ZM73.5687 60.7937V45.6261V45.1261H73.0687H46.9313H46.4313V45.6261V60.7937H44.0687H43.5687V61.2937V65.4554V65.648L33.7403 61.3521V47.1833C36.6349 42.5022 39.9138 38.4009 44.0836 35.4613C48.2797 32.503 53.4031 30.7033 60 30.7033C66.5969 30.7033 71.7203 32.503 75.9164 35.4612C80.0862 38.4009 83.3651 42.5021 86.2597 47.1833V61.3521L76.4313 65.648V65.4554V61.2937V60.7937H75.9313H73.5687ZM73.1937 65.9554H75.7281L72.8433 67.2163C72.962 66.7965 73.0788 66.3762 73.1937 65.9554ZM46.7983 65.9554C46.9097 66.3736 47.0231 66.7913 47.1387 67.2084L44.2721 65.9554H46.7983ZM66.4912 80.3782H64.6916L64.8442 77.7061H66.8095C66.6723 78.593 66.5661 79.4842 66.4912 80.3782ZM49.6717 48.3293H70.3283V60.7937H49.6717V48.3293ZM50.1507 65.9554H54.4825L54.629 68.6275H50.9123C50.6631 67.7749 50.4079 66.8908 50.1507 65.9554ZM57.8739 68.6275L57.7275 65.9554H62.2686L62.1162 68.6275H57.8739ZM65.3619 68.6275L65.5143 65.9554H69.8358C69.5746 66.8845 69.315 67.7689 69.0615 68.6275H65.3619ZM51.8421 71.8308H54.8046L54.9512 74.5029H52.5454C52.3318 73.6091 52.0945 72.7254 51.8421 71.8308ZM58.1961 74.5029L58.0496 71.8308H61.9333L61.781 74.5029H58.1961ZM65.0267 74.5029L65.179 71.8308H68.1312C67.8823 72.721 67.6486 73.6054 67.4381 74.5029H65.0267ZM53.5081 80.3782C53.4326 79.484 53.3248 78.5928 53.1851 77.7061H55.1266L55.2732 80.3782H53.5081ZM58.5183 80.3782L58.3717 77.7061H61.5985L61.446 80.3782H58.5183Z"
            fill="white"
            stroke="white"
          />
        </svg>
      );
    case 'Beach':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120" fill="none">
          <g filter="url(#filter0_d_1713_354)">
            <circle cx="60" cy="56" r="48" fill="#3C4D7D" />
            <circle cx="60" cy="56" r="52" stroke="#C3CADA" strokeWidth="8" />
          </g>
          <path
            d="M51.1169 30.7455L51.0731 47.8667C49.4917 47.5165 47.8715 47.3591 46.25 47.3982C44.6277 47.8241 43.0054 50.0814 41.4269 50.6351C40.531 46.7451 40.9978 42.6759 42.7531 39.0728C44.5085 35.4697 47.4521 32.5391 51.1169 30.7455ZM61.6838 28.0198L70.5846 42.7133C71.6577 41.6574 72.9019 40.7797 74.2677 40.1153C75.8462 39.6894 78.3892 40.8394 80.1431 40.5838C78.9322 36.8001 76.4628 33.5138 73.1222 31.24C69.7815 28.9662 65.7585 27.8336 61.6838 28.0198ZM32 79H89C86.1062 76.1891 77.4246 74.2725 69.9708 73.3355L61.7715 43.5225C64.0515 43.3096 66.8138 43.6503 68.48 43.5225L59.2285 28.1901H59.1846C58.1506 28.3312 57.1258 28.5303 56.1154 28.7864C55.1565 29.028 54.2183 29.3412 53.3092 29.7234L53.2654 47.3982C54.8 46.6742 56.9485 45.0984 58.9654 44.2466L66.8577 72.9522C64.3146 72.7393 62.0785 72.6115 60.5 72.6115C54.0546 72.6115 36.3846 74.741 32 79Z"
            fill="white"
          />
        </svg>
      );
    case 'HOA':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120" fill="none">
          <g filter="url(#filter0_d_1713_580)">
            <circle cx="60" cy="56" r="48" fill="#3C4D7D" />
            <circle cx="60" cy="56" r="52" stroke="#C3CADA" strokeWidth="8" />
          </g>
          <path
            d="M67.6678 38.9494C67.6678 36.8411 66.8024 34.8191 65.262 33.3283C63.7216 31.8375 61.6324 31 59.4539 31C57.2754 31 55.1862 31.8375 53.6458 33.3283C52.1054 34.8191 51.24 36.8411 51.24 38.9494C51.24 41.0577 52.1054 43.0797 53.6458 44.5705C55.1862 46.0613 57.2754 46.8988 59.4539 46.8988C61.6324 46.8988 63.7216 46.0613 65.262 44.5705C66.8024 43.0797 67.6678 41.0577 67.6678 38.9494ZM31.8991 63.1562H42.9247V52.4999L42.9542 51.8576C43.0501 50.7977 43.3893 49.8055 43.9129 48.9312H33.7465L33.3151 48.9562C32.4181 49.0584 31.5911 49.4758 30.9909 50.129C30.3907 50.7822 30.0591 51.6258 30.059 52.4999V61.3719C30.059 61.8451 30.2533 62.299 30.599 62.6336C30.9448 62.9682 31.4101 63.1562 31.8991 63.1562ZM88.9631 61.3719C88.9631 61.8451 88.7689 62.299 88.4231 62.6336C88.0773 62.9682 87.6084 63.1562 87.1194 63.1562H75.9979V52.4999L75.9757 51.9682C75.8952 50.8982 75.5649 49.8598 75.0096 48.9312H85.2756C86.1794 48.9314 87.0516 49.2528 87.7266 49.8344C88.4016 50.416 88.8325 51.2172 88.9373 52.086L88.9631 52.4999V61.3719ZM72.2846 52.086C72.1797 51.2166 71.7483 50.4149 71.0725 49.8332C70.3967 49.2516 69.5236 48.9305 68.6192 48.9312H50.2997L49.8682 48.9562C48.9713 49.0584 48.1442 49.4758 47.5441 50.129C46.9439 50.7822 46.6123 51.6258 46.6122 52.4999V63.1562H72.3067V52.4999L72.2846 52.086ZM77.8453 33.243C79.7162 33.243 81.5105 33.9622 82.8334 35.2425C84.1563 36.5229 84.8995 38.2593 84.8995 40.07C84.8995 41.8806 84.1563 43.6171 82.8334 44.8974C81.5105 46.1777 79.7162 46.897 77.8453 46.897C75.9739 46.897 74.1792 46.1775 72.8559 44.8969C71.5327 43.6162 70.7893 41.8793 70.7893 40.0682C70.7893 38.2571 71.5327 36.5202 72.8559 35.2395C74.1792 33.9589 75.9739 33.243 77.8453 33.243ZM48.1757 40.0664C48.1757 38.2558 47.4325 36.5193 46.1096 35.239C44.7866 33.9587 42.9924 33.2394 41.1215 33.2394C39.2506 33.2394 37.4564 33.9587 36.1334 35.239C34.8105 36.5193 34.0673 38.2558 34.0673 40.0664C34.0673 41.8771 34.8105 43.6135 36.1334 44.8938C37.4564 46.1742 39.2506 46.8934 41.1215 46.8934C42.9924 46.8934 44.7866 46.1742 46.1096 44.8938C47.4325 43.6135 48.1757 41.8771 48.1757 40.0664ZM31.8438 66.725C31.3548 66.725 30.8858 66.913 30.54 67.2476C30.1943 67.5823 30 68.0361 30 68.5094V72.0781C30 74.4444 30.9713 76.7137 32.7001 78.3868C34.429 80.06 36.7738 81 39.2188 81H79.7812C82.2262 81 84.571 80.06 86.2999 78.3868C88.0287 76.7137 89 74.4444 89 72.0781V68.5094C89 68.0361 88.8057 67.5823 88.46 67.2476C88.1142 66.913 87.6452 66.725 87.1562 66.725H31.8438Z"
            fill="white"
          />
        </svg>
      );
    case 'Lake':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120" fill="none">
          <g filter="url(#filter0_d_1713_584)">
            <circle cx="60" cy="56" r="48" fill="#3C4D7D" />
            <circle cx="60" cy="56" r="52" stroke="#C3CADA" strokeWidth="8" />
          </g>
          <path
            d="M66.5891 76.8586C66.9699 76.7973 67.3551 76.7681 67.7407 76.7714C68.9244 76.7714 70.0595 77.0408 71.0665 77.509C72.0459 77.9352 73.1412 78.1936 74.2885 78.1936C75.4357 78.1936 76.5465 77.9352 77.5259 77.509C78.5631 77.0247 79.6937 76.773 80.8384 76.7714C82.0265 76.7714 82.9186 77.0408 83.9212 77.509C84.9006 77.9352 85.7917 78.1936 86.8958 78.1936V83C85.7917 83 84.8995 82.7416 83.9212 82.2977C82.9186 81.8495 81.9039 81.5734 80.7158 81.5734C79.541 81.5734 78.4677 81.8495 77.4651 82.2977C76.4846 82.7416 75.4059 83 74.2586 83C73.1114 83 72.0304 82.7416 71.0521 82.2977C70.0091 81.8265 68.8787 81.5798 67.7341 81.5734C66.5593 81.5734 65.4253 81.8495 64.4073 82.2977C63.396 82.7587 62.2978 82.9981 61.1864 83C60.0747 82.9982 58.9761 82.7588 57.9645 82.2977C56.9205 81.8257 55.7888 81.5789 54.6431 81.5734C53.4953 81.5791 52.3615 81.8258 51.3152 82.2977C50.3056 82.7581 49.2094 82.9975 48.0998 83C46.9881 82.9983 45.8895 82.7589 44.8779 82.2977C43.8306 81.8287 42.6974 81.5821 41.5499 81.5734C40.3629 81.5734 39.2267 81.8495 38.2242 82.2977C37.2117 82.7587 36.1125 82.9981 35 83V78.1936C36.1103 78.1889 37.2078 77.9559 38.2242 77.509C39.2656 77.0234 40.4008 76.7716 41.5499 76.7714C42.7236 76.7714 43.8587 77.0408 44.8779 77.509C45.8551 77.9352 46.9526 78.1936 48.0998 78.1936C49.2072 78.1884 50.3017 77.9553 51.3152 77.509C51.8898 77.243 52.4945 77.0476 53.1161 76.9271L83.6441 71.5244C84.6334 71.2914 85.9794 70.6068 86.4475 69.4276C86.5403 69.2034 86.8638 69.1394 87.1376 69.1515C87.6356 69.1802 88 69.6065 88 70.1C88 70.8774 87.3982 73.0537 84.0625 73.7261L66.5891 76.8586ZM40.1012 38.7682C42.5404 38.7682 44.5245 36.7995 44.5245 34.3769C44.5245 31.9555 42.5404 30 40.1012 30C37.6632 30 35.6923 31.9555 35.6923 34.3769C35.6933 34.9548 35.8082 35.5268 36.0303 36.0603C36.2525 36.5937 36.5776 37.0782 36.987 37.486C37.3964 37.8938 37.8822 38.2169 38.4166 38.4369C38.9509 38.6569 39.5234 38.7695 40.1012 38.7682ZM52.9449 74.2053C53.168 75.1781 54.3549 76.11 55.5949 76.11L55.5806 76.1232C55.9491 76.1247 56.3144 76.0535 56.6554 75.9137C56.9965 75.7739 57.3066 75.5682 57.5681 75.3084C57.8296 75.0487 58.0373 74.7399 58.1794 74.3998C58.3215 74.0597 58.3952 73.695 58.3962 73.3264L58.3443 72.8715L54.981 58.535C54.6939 57.6152 53.8183 56.7462 52.9184 56.383L47.9684 53.4304L45.7115 43.769L59.6218 43.7436C60.758 43.7436 61.6722 42.9762 61.6722 41.8477C61.6722 40.7215 60.758 39.9386 59.6218 39.9386H39.5392C37.533 39.9386 36.6044 41.2261 36.8406 42.4694L39.685 55.2103C39.908 56.415 40.7019 57.3911 41.7741 57.9233L41.8381 57.931L50.1171 62.7551L52.9449 74.2053ZM62.6042 42.1458H88V43.25H62.6042V42.1458Z"
            fill="white"
          />
        </svg>
      );
    case 'Marina':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120" fill="none">
          <g filter="url(#filter0_d_1713_387)">
            <circle cx="60" cy="56" r="48" fill="#3C4D7D" />
            <circle cx="60" cy="56" r="52" stroke="#C3CADA" strokeWidth="8" />
          </g>
          <path
            d="M81.4307 86.07C81.4307 85.9029 81.3862 85.7389 81.3021 85.5954C81.2179 85.4518 81.0972 85.3339 80.9526 85.2542C77.327 83.2758 74.0202 80.2477 72.5657 78.7276C72.3496 78.4975 72.0612 78.3511 71.7503 78.3137C71.4393 78.2762 71.1252 78.3499 70.862 78.5222C64.1212 82.9304 55.9138 82.9331 49.1716 78.529C48.9061 78.355 48.589 78.2809 48.2753 78.3197C47.9616 78.3584 47.6712 78.5076 47.4546 78.7412C46.0121 80.2749 42.7414 83.269 39.0931 85.2338C38.948 85.3078 38.824 85.4182 38.7328 85.5546C38.6417 85.6909 38.5863 85.8487 38.5721 86.0129C38.5612 86.1526 38.5821 86.2931 38.6332 86.4233C38.6843 86.5536 38.7642 86.6702 38.8667 86.7642C38.9692 86.8581 39.0916 86.9269 39.2244 86.9652C39.3573 87.0035 39.497 87.0103 39.6329 86.9851C42.4254 86.4167 45.1241 85.125 47.6956 83.7449C47.8606 83.6567 48.044 83.61 48.2304 83.6085C48.4168 83.6071 48.6009 83.6511 48.7671 83.7367C52.2486 85.5337 56.0991 86.4703 60.0048 86.4703C63.9104 86.4703 67.7609 85.5337 71.2424 83.7367C71.4106 83.6502 71.5967 83.6058 71.7852 83.6072C71.9737 83.6087 72.1591 83.6559 72.3259 83.7449C74.8841 85.1046 77.5788 86.4086 80.3619 86.981C80.4935 87.0067 80.629 87.0023 80.7586 86.9681C80.8882 86.9339 81.0088 86.8709 81.1114 86.7835C81.214 86.6961 81.2961 86.5866 81.3518 86.4629C81.4075 86.3393 81.4354 86.2046 81.4334 86.0686L81.4307 86.07ZM89.5618 55.3093C89.0944 54.1685 88.1019 53.2847 86.7626 52.8142L83.5736 51.5252V40.2287C83.5736 37.9208 82.6706 35.7074 81.063 34.0754C79.4555 32.4434 77.2753 31.5266 75.0019 31.5266H70.7161V30.4388C70.7161 28.9964 70.1516 27.613 69.1469 26.593C68.1422 25.573 66.7796 25 65.3587 25H54.6441C53.2232 25 51.8606 25.573 50.8559 26.593C49.8512 27.613 49.2868 28.9964 49.2868 30.4388V31.5266H45.0009C42.7275 31.5266 40.5473 32.4434 38.9398 34.0754C37.3323 35.7074 36.4292 37.9208 36.4292 40.2287V51.5347L33.271 52.8115C31.9397 53.2602 30.9098 54.1712 30.4383 55.3188C30.1102 56.1197 29.7352 57.3584 30.2642 58.9166L30.2776 58.9574L36.5269 75.1978C36.7572 75.7944 37.16 76.3063 37.6824 76.666C38.2048 77.0257 38.8222 77.2163 39.4534 77.2128C39.5204 77.2128 39.5873 77.2128 39.6583 77.206C43.8531 76.9341 47.1586 74.8578 49.3818 72.908C52.5574 75.6913 56.2928 77.2128 60.0014 77.2128C63.71 77.2128 67.4253 75.69 70.6009 72.9026C72.8228 74.8551 76.1323 76.9368 80.3258 77.206C80.9896 77.2534 81.6511 77.0845 82.2139 76.7241C82.7768 76.3637 83.2118 75.8304 83.4558 75.2018L89.7038 59.0213C90.1431 57.9213 90.0922 56.6064 89.5618 55.3093ZM61.7425 42.7048L61.5899 42.6504C60.5554 42.3199 59.446 42.3199 58.4116 42.6504L58.3339 42.6749L41.449 49.5047C41.3677 49.5376 41.2797 49.5497 41.1927 49.5401C41.1056 49.5304 41.0223 49.4993 40.9499 49.4494C40.8775 49.3995 40.8182 49.3323 40.7773 49.2538C40.7363 49.1753 40.715 49.0877 40.715 48.9989V40.2287C40.715 39.0748 41.1666 37.9681 41.9703 37.1521C42.7741 36.3361 43.8642 35.8777 45.0009 35.8777H75.0019C76.1386 35.8777 77.2287 36.3361 78.0325 37.1521C78.8362 37.9681 79.2878 39.0748 79.2878 40.2287V48.9907C79.2879 49.0796 79.2665 49.1671 79.2256 49.2456C79.1846 49.3242 79.1254 49.3913 79.0529 49.4412C78.9805 49.4911 78.8972 49.5223 78.8102 49.5319C78.7231 49.5416 78.6351 49.5294 78.5538 49.4965L61.7425 42.7048Z"
            fill="white"
          />
        </svg>
      );
    case 'Playground':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120" fill="none">
          <g filter="url(#filter0_d_1713_575)">
            <circle cx="60" cy="56" r="48" fill="#3C4D7D" />
            <circle cx="60" cy="56" r="52" stroke="#C3CADA" strokeWidth="8" />
          </g>
          <path
            d="M36.6773 64.3774C40.3776 64.3774 43.3712 61.3004 43.3712 57.4922C43.3712 53.7046 40.3776 50.6262 36.6773 50.6262C32.9923 50.6262 30 53.7046 30 57.4922C30 61.2991 32.9923 64.3774 36.6773 64.3774ZM74.1679 76.1982C74.2401 76.1456 74.322 76.1077 74.4089 76.0868C74.4958 76.0658 74.586 76.0622 74.6742 76.0762C74.7625 76.0901 74.8472 76.1213 74.9234 76.168C74.9996 76.2147 75.0658 76.276 75.1183 76.3483L76.356 78.1081C76.4573 78.2612 76.4981 78.4464 76.4706 78.6279C76.4431 78.8094 76.3493 78.9743 76.2073 79.0906L67.1264 85.8719C66.9795 85.9768 66.7972 86.0198 66.6189 85.9915C66.4406 85.9632 66.2806 85.8658 66.1734 85.7205L64.9395 83.9607C64.8382 83.8081 64.7973 83.6232 64.8248 83.4421C64.8523 83.2609 64.9462 83.0965 65.0883 82.9808L74.1679 76.1982ZM63.9032 67.4545L60.3016 60.9604L58.4111 62.3803L62.0126 68.909L63.9032 67.4545ZM55.5008 52.2847L41.4947 27L38.8154 27.018L53.5936 53.7225L55.5008 52.2847ZM68.6873 65.6626C69.4787 65.0713 71.2897 64.1965 72.3261 64.1965H85.1522C87.684 64.1965 89 66.7439 89 69.3322C89 71.936 87.684 73.175 85.1522 73.175H73.6087L59.7103 84.08C54.8262 87.6958 51.8659 83.7235 51.8659 83.7235L40.9855 72.5273C39.1604 70.2788 39.5554 65.9999 41.7436 64.1055L56.8001 53.0786C58.2956 51.796 60.5158 51.9974 61.783 53.5186C63.0349 55.0577 62.8373 57.3588 61.3393 58.644L51.7005 65.8999L58.6253 72.9339L68.6873 65.6626Z"
            fill="white"
          />
        </svg>
      );
    case 'Pond':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120" fill="none">
          <g filter="url(#filter0_d_1713_462)">
            <circle cx="60" cy="56" r="48" fill="#3C4D7D" />
            <circle cx="60" cy="56" r="52" stroke="#C3CADA" strokeWidth="8" />
          </g>
          <path
            d="M54.6035 46.6314C54.815 46.7635 55.0295 46.8902 55.2468 47.0115C55.9843 49.4166 57.2201 50.2811 58.2249 50.5611C58.9841 51.8924 59.8792 53.0667 60.8847 54.0822C59.5059 56.0483 57.6605 56.7187 57.2328 56.8516C55.1982 55.3577 54.3163 51.9179 54.6035 46.6315V46.6314ZM68.6873 48.5213C71.685 47.832 74.4353 46.3146 76.9838 43.9423C75.2511 42.5454 73.2748 41.6296 70.8963 41.1567C70.357 42.0109 69.7488 42.8152 69.0784 43.5606C71.1773 44.4988 71.7287 46.2394 68.1611 47.4492L68.6873 48.5213ZM63.6669 31.0399C64.6162 32.5905 64.991 34.4474 64.7972 36.6515C66.2171 35.9115 67.5885 35.4327 68.8991 35.2078C69.5605 30.5955 68.3014 27.0637 68.3014 27.0637C66.3823 28.0813 64.8221 29.3941 63.6669 31.0399H63.6669ZM54.2274 46.3849C52.0944 44.9646 50.5836 43.1157 49.6643 40.8027C47.0853 41.7416 45.0274 43.2596 44.4243 43.7315C47.6683 46.8465 50.8858 48.6091 54.1707 49.0658C54.1536 48.2274 54.1704 47.3368 54.2274 46.3849ZM73.2496 47.187C71.8489 47.9687 70.392 48.54 68.8723 48.8992C69.3918 49.9633 69.864 50.9549 70.2543 51.8793C73.4866 51.7371 75.438 50.7582 77 48.8319C76.6741 48.3391 75.0302 48.0385 73.2496 47.1871V47.187ZM48.6747 36.5341C48.9122 36.4349 49.1532 36.3448 49.397 36.2639C47.9583 35.2919 45.8918 34.6396 43.0376 35.305C42.6861 36.072 44.8637 39.0399 46.9428 41.6108C47.7038 41.1926 48.5757 40.7734 49.5194 40.4286C49.0832 39.2334 48.8151 37.9262 48.6747 36.5341ZM54.1811 49.48C52.1935 49.2143 50.2328 48.4807 48.2791 47.2761C46.2012 48.9248 43.338 51.5775 43.2003 53.7767C45.726 55.4097 50.6698 54.3916 54.6451 53.1298C54.3868 52.0754 54.2305 50.8602 54.1811 49.48V49.48ZM61.5243 28.705C62.2838 29.2093 62.9965 30.0504 63.4349 30.6846C63.7857 30.1947 64.176 29.7353 64.5966 29.3002C63.7814 27.3323 63.0379 25.698 62.8942 25.4155C62.5765 24.7914 61.9354 24.916 61.4503 25.4861C60.073 27.5435 58.9599 29.5768 58.1129 31.9266C58.2714 32.1596 58.413 32.4017 58.5316 32.6556C59.0197 31.0232 60.0789 29.6317 61.5243 28.705ZM52.6093 36.268C51.6144 33.8366 52.0897 31.3149 52.7719 29.1995C52.0057 28.6018 51.2355 28.1716 50.5426 28.0867C48.8991 28.9361 49.837 32.9434 50.8317 35.9736C51.4139 35.9227 52.0626 36.0287 52.6093 36.268ZM71.1268 40.7883C71.5901 40.8848 72.0341 41.0036 72.4688 41.1339C74.6029 38.6311 75.9492 36.1496 76.751 33.5042C74.9098 33.4834 72.3876 33.5747 69.3327 34.8839L69.3026 35.1441C70.7032 34.9807 71.9958 35.0809 73.1808 35.4439C72.7663 37.4242 72.0843 39.2077 71.1269 40.7883H71.1268ZM62.5144 48.4719C59.6453 51.4565 56.7279 50.6728 55.57 46.729C51.4931 44.52 49.5704 41.0759 49.0958 36.8017C51.2893 35.9369 52.7966 36.4451 53.9063 37.7489C52.0372 35.2788 52.0735 32.284 53.3276 28.7688C55.9924 30.1506 58.287 31.714 58.5721 34.263C58.9844 31.5138 60.1567 30.1624 61.574 29.2614C64.1572 31.3755 64.7752 34.1822 64.3228 37.37C67.3197 35.6905 70.1354 35.0415 72.7139 35.7408C72.1017 38.4442 70.8765 41.1094 68.4099 43.6978C72.4945 45.4616 69.9365 47.0361 62.5144 48.4719ZM65.9439 40.6932C65.6145 40.4109 63.8386 40.783 63.2378 41.6137C63.7804 40.8559 63.9611 38.4689 63.9611 38.4689L63.0569 38.8477L63.5271 36.7259C62.887 37.1208 62.3026 37.833 61.789 38.9487C62.0254 37.8139 62.0808 36.9187 61.8634 36.3849C61.4156 37.3997 61.1182 38.3021 60.5298 39.132C60.5298 39.132 60.4599 37.9594 60.8145 36.9911C60.4599 37.1716 59.9826 38.2794 59.7656 38.6204C59.5486 38.9614 60.0911 37.1427 60.0911 36.5364C59.393 36.5304 58.4274 37.9005 57.8125 38.8477C57.1976 39.795 57.704 37.1426 57.704 37.1426C57.704 37.1426 57.0168 37.1048 56.6913 37.6731C56.3657 38.2415 56.2572 41.1212 56.2572 41.1212C56.2572 41.1212 56.2572 41.1424 56.2574 41.1743C55.7122 39.6292 56.0171 39.1127 56.0171 39.1127C56.0171 39.1127 55.5737 39.0754 55.1903 40.1694C54.8067 41.2635 54.7799 41.8956 56.4572 44.4044C57.6707 46.2195 59.8033 46.0554 60.8928 45.826C61.091 45.7952 61.5711 45.7296 61.7218 45.5241C61.9913 45.2417 62.3507 44.4575 62.8298 44.4575C63.3088 44.4575 64.5964 43.9556 64.8359 43.1714C65.0755 42.3872 64.4167 42.5126 64.7162 42.2303C65.0157 41.948 65.685 40.9067 65.9439 40.6932ZM58.7386 50.6602C61.3533 55.0375 65.4632 57.6646 70.396 58C71.9293 55.6631 69.9874 52.0551 67.7885 47.5808C66.614 47.9811 64.9819 48.4049 62.7092 48.8484C61.581 50.0738 60.1239 50.8086 58.7386 50.6602Z"
            fill="white"
          />
          <path
            d="M34 86V81.2727C35.6783 81.2727 36.9265 80.8788 37.7445 80.0909C38.5624 79.303 40.2734 78.9091 42.8775 78.9091C45.4833 78.9091 47.1952 79.303 48.0132 80.0909C48.8312 80.8788 50.0343 81.2727 51.6225 81.2727C53.3008 81.2727 54.549 80.8788 55.367 80.0909C56.1849 79.303 57.8959 78.9091 60.5 78.9091C63.0175 78.9091 64.7294 79.303 65.6357 80.0909C66.542 80.8788 67.7893 81.2727 69.3775 81.2727C71.0558 81.2727 72.2819 80.8788 73.0557 80.0909C73.8295 79.303 75.5184 78.9091 78.1225 78.9091C80.7283 78.9091 82.4402 79.303 83.2582 80.0909C84.0762 80.8788 85.3234 81.2727 87 81.2727V86C84.4825 86 82.7715 85.6061 81.867 84.8182C80.9624 84.0303 79.7143 83.6364 78.1225 83.6364C76.5325 83.6364 75.3294 84.0303 74.5132 84.8182C73.697 85.6061 71.9851 86 69.3775 86C66.86 86 65.149 85.6061 64.2445 84.8182C63.3399 84.0303 62.0918 83.6364 60.5 83.6364C58.8217 83.6364 57.5735 84.0303 56.7556 84.8182C55.9376 85.6061 54.2266 86 51.6225 86C49.0167 86 47.3269 85.6061 46.5531 84.8182C45.7793 84.0303 44.5541 83.6364 42.8775 83.6364C41.1992 83.6364 39.9519 84.0303 39.1357 84.8182C38.3195 85.6061 36.6076 86 34 86ZM34 76.5455V71.8182C35.6783 71.8182 36.9265 71.4242 37.7445 70.6364C38.5624 69.8485 40.2734 69.4545 42.8775 69.4545C45.395 69.4545 47.0848 69.8485 47.947 70.6364C48.8091 71.4242 50.0343 71.8182 51.6225 71.8182C53.3008 71.8182 54.5481 71.4242 55.3643 70.6364C56.1805 69.8485 57.8924 69.4545 60.5 69.4545C63.0175 69.4545 64.7179 69.8485 65.6013 70.6364C66.4846 71.4242 67.6992 71.8182 69.245 71.8182C70.9233 71.8182 72.1706 71.4242 72.9868 70.6364C73.803 69.8485 75.5149 69.4545 78.1225 69.4545C80.64 69.4545 82.3519 69.8485 83.2582 70.6364C84.1645 71.4242 85.4118 71.8182 87 71.8182V76.5455C84.3942 76.5455 82.6602 76.1515 81.7981 75.3636C80.9359 74.5758 79.7107 74.1818 78.1225 74.1818C76.5325 74.1818 75.3294 74.5758 74.5132 75.3636C73.697 76.1515 71.9851 76.5455 69.3775 76.5455C66.86 76.5455 65.149 76.1515 64.2445 75.3636C63.3399 74.5758 62.0918 74.1818 60.5 74.1818C58.8217 74.1818 57.5956 74.5758 56.8218 75.3636C56.048 76.1515 54.3591 76.5455 51.755 76.5455C49.1492 76.5455 47.4161 76.1515 46.5557 75.3636C45.6953 74.5758 44.4693 74.1818 42.8775 74.1818C41.2875 74.1818 40.0402 74.5758 39.1357 75.3636C38.2312 76.1515 36.5193 76.5455 34 76.5455ZM34 67.0909V62.3636C35.6783 62.3636 36.9265 61.9697 37.7445 61.1818C38.5624 60.3939 40.2734 60 42.8775 60C45.395 60 47.0848 60.3939 47.947 61.1818C48.8091 61.9697 50.0343 62.3636 51.6225 62.3636C53.3008 62.3636 54.5481 61.9697 55.3643 61.1818C56.1805 60.3939 57.8924 60 60.5 60C63.0175 60 64.7179 60.3939 65.6013 61.1818C66.4846 61.9697 67.6992 62.3636 69.245 62.3636C70.9233 62.3636 72.1706 61.9697 72.9868 61.1818C73.803 60.3939 75.5149 60 78.1225 60C80.64 60 82.3519 60.3939 83.2582 61.1818C84.1645 61.9697 85.4118 62.3636 87 62.3636V67.0909C84.3942 67.0909 82.6602 66.697 81.7981 65.9091C80.9359 65.1212 79.7107 64.7273 78.1225 64.7273C76.5325 64.7273 75.3294 65.1212 74.5132 65.9091C73.697 66.697 71.9851 67.0909 69.3775 67.0909C66.86 67.0909 65.149 66.697 64.2445 65.9091C63.3399 65.1212 62.0918 64.7273 60.5 64.7273C58.8217 64.7273 57.5956 65.1212 56.8218 65.9091C56.048 66.697 54.3591 67.0909 51.755 67.0909C49.1492 67.0909 47.4161 66.697 46.5557 65.9091C45.6953 65.1212 44.4693 64.7273 42.8775 64.7273C41.2875 64.7273 40.0402 65.1212 39.1357 65.9091C38.2312 66.697 36.5193 67.0909 34 67.0909Z"
            fill="white"
          />
        </svg>
      );
    case 'Soccer Field':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120" fill="none">
          <g filter="url(#filter0_d_1713_156)">
            <circle cx="60" cy="56" r="48" fill="#3C4D7D" />
            <circle cx="60" cy="56" r="52" stroke="#C3CADA" strokeWidth="8" />
          </g>
          <path
            d="M36 33C32.67 33 30 35.6144 30 38.875V74.125C30 75.6831 30.6321 77.1775 31.7574 78.2793C32.8826 79.381 34.4087 80 36 80H84C85.5913 80 87.1174 79.381 88.2426 78.2793C89.3679 77.1775 90 75.6831 90 74.125V38.875C90 37.3169 89.3679 35.8225 88.2426 34.7207C87.1174 33.619 85.5913 33 84 33H36ZM36 38.875H57V45.1319C51.72 46.4831 48 51.1538 48 56.5C48.0071 59.1021 48.894 61.6287 50.5222 63.6853C52.1503 65.7419 54.4282 67.2127 57 67.8681V74.125H36V68.25H45V44.75H36V38.875ZM63 38.875H84V44.75H75V68.25H84V74.125H63V67.8681C68.28 66.5169 72 61.8463 72 56.5C71.9929 53.8979 71.106 51.3713 69.4778 49.3147C67.8497 47.2581 65.5718 45.7873 63 45.1319V38.875ZM36 50.625H39V62.375H36V50.625ZM81 50.625H84V62.375H81V50.625ZM63 51.4181C64.86 52.4756 66 54.4144 66 56.5C66 58.5856 64.86 60.5244 63 61.5819V51.4181ZM57 51.4181V61.5819C55.14 60.5244 54 58.5856 54 56.5C54 54.4144 55.14 52.4756 57 51.4181Z"
            fill="white"
          />
        </svg>
      );
    case 'Tennis Court':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120" fill="none">
          <g filter="url(#filter0_d_1713_364)">
            <circle cx="60" cy="56" r="48" fill="#3C4D7D" />
            <circle cx="60" cy="56" r="52" stroke="#C3CADA" strokeWidth="8" />
          </g>
          <path
            d="M33.0116 55.0154C32.4034 55.017 31.8206 55.2591 31.3901 55.6888C30.9597 56.1184 30.7167 56.7008 30.7141 57.3089C30.7141 58.5676 31.7491 59.5837 33.0116 59.5837C33.311 59.5847 33.6076 59.5266 33.8845 59.4127C34.1614 59.2989 34.4131 59.1314 34.6251 58.9201C34.8372 58.7088 35.0055 58.4577 35.1202 58.1812C35.2351 57.9047 35.2941 57.6083 35.2941 57.3089C35.2948 56.7024 35.0549 56.1203 34.627 55.6904C34.1991 55.2605 33.6182 55.0177 33.0116 55.0154ZM64.8721 35.9434C66.1897 35.9451 67.454 35.4234 68.387 34.4931C69.32 33.5628 69.8452 32.3001 69.8472 30.9827C69.8472 29.6612 69.3222 28.3938 68.3876 27.4594C67.4531 26.525 66.1856 26 64.864 26C63.5424 26 62.2749 26.525 61.3403 27.4594C60.4058 28.3938 59.8808 29.6612 59.8808 30.9827C59.8808 33.7299 62.1183 35.9434 64.8721 35.9434ZM86.2862 80.2043L78.1898 70.6727C78.1898 70.6727 75.661 55.9566 75.661 55.9253L75.2823 54.2567C75.2973 54.273 74.2647 49.6147 73.4735 45.9738C74.736 46.7012 75.876 47.3536 75.9373 47.3849C75.9985 47.5199 80.2273 55.5466 80.2273 55.5466C80.5498 56.1403 81.0849 56.5803 81.7211 56.7752C82.0394 56.8747 82.3743 56.9097 82.7064 56.8784C83.0384 56.8471 83.3608 56.75 83.6549 56.5928C83.9503 56.4418 84.2117 56.2321 84.4232 55.9766C84.6347 55.721 84.7918 55.425 84.8849 55.1066C84.9913 54.7939 85.0312 54.4624 85.0021 54.1333C84.9731 53.8042 84.8757 53.4849 84.7162 53.1956L80.0798 44.3789C80.0798 44.3789 79.8948 44.0602 79.6523 43.819C79.3173 43.4852 78.5836 43.0753 78.5836 43.0753L69.5772 37.9608C68.4347 37.3846 67.1721 37.1883 65.9071 37.4608C65.3871 37.567 64.9034 37.7645 64.3571 38.0682C64.2933 38.082 62.2996 38.9619 61.1445 41.6654L56.5195 50.9508L49.2281 52.3619L49.0606 52.4219L42.478 47.7786C41.0017 46.7474 40.8205 43.6515 40.803 43.5302C40.6217 41.4067 39.403 39.4031 37.4554 38.022C35.6916 36.7784 33.5591 36.2484 31.6103 36.5646C30.0878 36.8234 28.7953 37.612 27.9728 38.7669C27.3294 39.681 26.9892 40.7739 27.0003 41.8916L27.0915 42.8953C27.4278 44.8501 28.629 46.6712 30.3953 47.9311C32.1753 49.1897 34.2916 49.7222 36.2392 49.3884L36.6967 49.2972C36.7417 49.2672 39.6642 48.3698 41.0942 49.3434C41.0942 49.3572 46.0168 52.8169 47.3268 53.743C47.1906 53.9555 46.9468 54.4242 46.9618 54.9117C46.9652 55.2829 47.0503 55.6488 47.211 55.9834C47.3718 56.318 47.6043 56.6132 47.8919 56.8478C48.1796 57.0825 48.5154 57.251 48.8755 57.3412C49.2357 57.4315 49.6112 57.4414 49.9756 57.3702L58.7095 55.6691C58.7095 55.6691 59.457 55.4416 59.777 55.2129C60.1895 54.9254 60.492 54.3192 60.492 54.3192L62.7896 49.7059C62.7896 49.7059 64.3746 57.1552 64.4008 57.2914C64.2196 57.4739 57.2357 64.8632 57.2357 64.8632L56.967 65.0157C56.2782 65.6357 55.7507 66.4543 55.7507 67.3218V82.9778C55.7507 84.6501 57.2095 86 58.8833 86C60.5433 86 62.0008 84.6501 62.0008 82.9778V69.9003C63.2508 69.2341 68.0559 63.6058 69.4859 62.1147C69.6397 62.9947 71.0509 70.9339 71.0509 70.9339C71.1735 71.6326 71.5247 72.2688 72.0272 72.7825C72.0272 72.8 81.6511 84.1202 81.6511 84.1202C82.1814 84.7243 82.9222 85.1034 83.7224 85.1801C84.5238 85.2402 85.3171 84.9855 85.9337 84.4701C86.2675 84.1848 86.5356 83.8306 86.7196 83.4319C86.9037 83.0332 86.9993 82.5995 86.9999 82.1604C87.0043 81.4438 86.751 80.7496 86.2862 80.2043ZM38.2779 46.065C37.7454 46.8087 36.9242 47.2936 35.9042 47.4761C34.4729 47.7173 32.8741 47.3086 31.5366 46.3375C30.1828 45.3801 29.2678 44.0164 29.0253 42.5903L28.9628 41.8766C28.9628 41.133 29.1615 40.4668 29.5728 39.8893C30.8966 38.0395 33.9241 37.9183 36.3279 39.6168C38.7192 41.3167 39.6017 44.2139 38.2779 46.065Z"
            fill="white"
          />
        </svg>
      );
    case 'Views':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120" fill="none">
          <g filter="url(#filter0_d_1713_475)">
            <circle cx="60" cy="56" r="48" fill="#3C4D7D" />
            <circle cx="60" cy="56" r="52" stroke="#C3CADA" strokeWidth="8" />
          </g>
          <path
            d="M52.3957 54.088L61.8095 37.1667L82 78H29L46.6667 42.6111L52.3957 54.088ZM55.2224 59.5923L61.7767 72.5556H73.5881L61.5496 48.2134L55.2224 59.5923ZM37.4497 72.5556H55.8836L46.6667 54.0962L37.4497 72.5556ZM37.8333 42.6111C36.1599 42.6111 34.5551 41.8941 33.3718 40.6178C32.1886 39.3415 31.5238 37.6105 31.5238 35.8056C31.5238 34.0006 32.1886 32.2696 33.3718 30.9933C34.5551 29.717 36.1599 29 37.8333 29C39.5067 29 41.1116 29.717 42.2948 30.9933C43.4781 32.2696 44.1429 34.0006 44.1429 35.8056C44.1429 37.6105 43.4781 39.3415 42.2948 40.6178C41.1116 41.8941 39.5067 42.6111 37.8333 42.6111Z"
            fill="white"
          />
          <path
            d="M77.7133 39.6539C77.5802 39.4528 77.3997 39.2878 77.1881 39.1738C76.9764 39.0597 76.7401 39 76.5 39C76.2599 39 76.0236 39.0597 75.8119 39.1738C75.6003 39.2878 75.4198 39.4528 75.2867 39.6539L66.5366 52.873C66.3905 53.0942 66.3067 53.3512 66.2941 53.6165C66.2815 53.8819 66.3406 54.1458 66.4651 54.38C66.5896 54.6142 66.7748 54.81 67.0011 54.9466C67.2274 55.0832 67.4862 55.1554 67.75 55.1555H68.0358L62.1383 64.6585C62.0003 64.8809 61.924 65.1364 61.9171 65.3985C61.9103 65.6605 61.9732 65.9197 62.0994 66.149C62.2256 66.3783 62.4105 66.5695 62.6348 66.7025C62.8591 66.8356 63.1146 66.9058 63.375 66.9058H63.932L59.1545 76.5293C59.0431 76.7532 58.9904 77.0021 59.0014 77.2523C59.0124 77.5025 59.0868 77.7458 59.2175 77.9589C59.3481 78.172 59.5307 78.348 59.7479 78.47C59.965 78.592 60.2096 78.6561 60.4583 78.6561H73.5833V86H79.4167V78.6561H92.5417C92.7904 78.6561 93.035 78.592 93.2521 78.47C93.4693 78.348 93.6519 78.172 93.7826 77.9589C93.9132 77.7458 93.9876 77.5025 93.9986 77.2523C94.0096 77.0021 93.9569 76.7532 93.8455 76.5293L89.0709 66.9058H89.628C89.8883 66.9058 90.1439 66.8356 90.3681 66.7025C90.5924 66.5695 90.7773 66.3783 90.9035 66.149C91.0297 65.9197 91.0926 65.6605 91.0858 65.3985C91.079 65.1364 91.0026 64.8809 90.8646 64.6585L84.9642 55.1555H85.25C85.5138 55.1554 85.7726 55.0832 85.9989 54.9466C86.2252 54.81 86.4104 54.6142 86.5349 54.38C86.6594 54.1458 86.7185 53.8819 86.7059 53.6165C86.6933 53.3512 86.6095 53.0942 86.4634 52.873L77.7133 39.6539Z"
            fill="white"
          />
        </svg>
      );
    case 'Volleyball':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120" fill="none">
          <g filter="url(#filter0_d_1713_588)">
            <circle cx="60" cy="56" r="48" fill="#3C4D7D" />
            <circle cx="60" cy="56" r="52" stroke="#C3CADA" strokeWidth="8" />
          </g>
          <path
            d="M57.0234 54.4809C56.9306 50.0835 55.9986 45.7443 54.2774 41.6966C43.2933 46.8248 35.2245 56.5007 32.4664 67.9182C34.0805 71.6158 36.4212 74.9515 39.3496 77.7272C42.1344 68.0455 48.4382 59.7542 57.0234 54.4809ZM52.5596 38.2254C50.7198 35.0204 48.3751 32.133 45.6159 29.6743C34.6076 35.6976 28.0993 48.1673 30.4946 61.387C34.535 51.3362 42.3981 43.0028 52.5596 38.2254ZM75.2537 58.194C76.294 46.1233 71.9512 34.3067 63.459 26.2152C61.6808 26.0096 57.217 25.55 51.4951 27.2433C58.4958 34.4964 62.5303 44.105 62.8058 54.1809C66.661 56.3004 70.8863 57.6626 75.2537 58.194ZM60.1687 59.343C56.406 61.627 53.1133 64.6071 50.4668 68.1239C60.3864 75.0542 72.7859 77.2071 84.0362 73.9052C86.4561 70.6634 88.1928 66.9644 89.1411 63.0319C85.9421 63.8469 82.6557 64.2693 79.3546 64.2898C72.7496 64.2777 66.1809 62.5844 60.1687 59.343ZM48.2772 71.4016C46.4385 74.5462 45.1683 77.9812 44.3941 81.5854C49.7603 84.8784 56.0295 86.393 62.3075 85.913C68.5856 85.433 74.5516 82.983 79.3546 78.9125C65.697 80.8597 54.7613 75.9129 48.2772 71.4016ZM70.0882 27.7875C76.7779 36.3023 80.0683 47.2844 79.1126 58.4601C82.798 58.4678 86.461 57.8881 89.9637 56.7426C89.9637 56.5007 90 56.2588 90 56.0169C90 42.9787 81.6893 31.9361 70.0882 27.7875Z"
            fill="white"
          />
        </svg>
      );
    case 'Waterfront Lots':
      return (
        <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_d_1713_266)">
            <circle cx="60" cy="56" r="48" fill="#3C4D7D" />
            <circle cx="60" cy="56" r="52" stroke="#C3CADA" strokeWidth="8" />
          </g>
          <path
            d="M34 84.9883V82.4428C35.6783 82.4428 36.9265 82.2307 37.7445 81.8065C38.5624 81.3822 40.2734 81.1701 42.8775 81.1701C45.4833 81.1701 47.1952 81.3822 48.0132 81.8065C48.8312 82.2307 50.0343 82.4428 51.6225 82.4428C53.3008 82.4428 54.549 82.2307 55.367 81.8065C56.1849 81.3822 57.8959 81.1701 60.5 81.1701C63.0175 81.1701 64.7294 81.3822 65.6357 81.8065C66.542 82.2307 67.7893 82.4428 69.3775 82.4428C71.0558 82.4428 72.2819 82.2307 73.0557 81.8065C73.8295 81.3822 75.5184 81.1701 78.1225 81.1701C80.7283 81.1701 82.4402 81.3822 83.2582 81.8065C84.0762 82.2307 85.3234 82.4428 87 82.4428V84.9883C84.4825 84.9883 82.7715 84.7762 81.867 84.3519C80.9624 83.9277 79.7143 83.7156 78.1225 83.7156C76.5325 83.7156 75.3294 83.9277 74.5132 84.3519C73.697 84.7762 71.9851 84.9883 69.3775 84.9883C66.86 84.9883 65.149 84.7762 64.2445 84.3519C63.3399 83.9277 62.0918 83.7156 60.5 83.7156C58.8217 83.7156 57.5735 83.9277 56.7556 84.3519C55.9376 84.7762 54.2266 84.9883 51.6225 84.9883C49.0167 84.9883 47.3269 84.7762 46.5531 84.3519C45.7793 83.9277 44.5541 83.7156 42.8775 83.7156C41.1992 83.7156 39.9519 83.9277 39.1357 84.3519C38.3195 84.7762 36.6076 84.9883 34 84.9883ZM34 79.8974V77.3519C35.6783 77.3519 36.9265 77.1398 37.7445 76.7156C38.5624 76.2913 40.2734 76.0792 42.8775 76.0792C45.395 76.0792 47.0848 76.2913 47.947 76.7156C48.8091 77.1398 50.0343 77.3519 51.6225 77.3519C53.3008 77.3519 54.5481 77.1398 55.3643 76.7156C56.1805 76.2913 57.8924 76.0792 60.5 76.0792C63.0175 76.0792 64.7179 76.2913 65.6013 76.7156C66.4846 77.1398 67.6992 77.3519 69.245 77.3519C70.9233 77.3519 72.1706 77.1398 72.9868 76.7156C73.803 76.2913 75.5149 76.0792 78.1225 76.0792C80.64 76.0792 82.3519 76.2913 83.2582 76.7156C84.1645 77.1398 85.4118 77.3519 87 77.3519V79.8974C84.3942 79.8974 82.6602 79.6853 81.7981 79.261C80.9359 78.8368 79.7107 78.6246 78.1225 78.6246C76.5325 78.6246 75.3294 78.8368 74.5132 79.261C73.697 79.6853 71.9851 79.8974 69.3775 79.8974C66.86 79.8974 65.149 79.6853 64.2445 79.261C63.3399 78.8368 62.0918 78.6246 60.5 78.6246C58.8217 78.6246 57.5956 78.8368 56.8218 79.261C56.048 79.6853 54.3591 79.8974 51.755 79.8974C49.1492 79.8974 47.4161 79.6853 46.5557 79.261C45.6953 78.8368 44.4693 78.6246 42.8775 78.6246C41.2875 78.6246 40.0402 78.8368 39.1357 79.261C38.2312 79.6853 36.5193 79.8974 34 79.8974ZM34 74.8065V72.261C35.6783 72.261 36.9265 72.0489 37.7445 71.6246C38.5624 71.2004 40.2734 70.9883 42.8775 70.9883C45.395 70.9883 47.0848 71.2004 47.947 71.6246C48.8091 72.0489 50.0343 72.261 51.6225 72.261C53.3008 72.261 54.5481 72.0489 55.3643 71.6246C56.1805 71.2004 57.8924 70.9883 60.5 70.9883C63.0175 70.9883 64.7179 71.2004 65.6013 71.6246C66.4846 72.0489 67.6992 72.261 69.245 72.261C70.9233 72.261 72.1706 72.0489 72.9868 71.6246C73.803 71.2004 75.5149 70.9883 78.1225 70.9883C80.64 70.9883 82.3519 71.2004 83.2582 71.6246C84.1645 72.0489 85.4118 72.261 87 72.261V74.8065C84.3942 74.8065 82.6602 74.5943 81.7981 74.1701C80.9359 73.7459 79.7107 73.5337 78.1225 73.5337C76.5325 73.5337 75.3294 73.7459 74.5132 74.1701C73.697 74.5943 71.9851 74.8065 69.3775 74.8065C66.86 74.8065 65.149 74.5943 64.2445 74.1701C63.3399 73.7459 62.0918 73.5337 60.5 73.5337C58.8217 73.5337 57.5956 73.7459 56.8218 74.1701C56.048 74.5943 54.3591 74.8065 51.755 74.8065C49.1492 74.8065 47.4161 74.5943 46.5557 74.1701C45.6953 73.7459 44.4693 73.5337 42.8775 73.5337C41.2875 73.5337 40.0402 73.7459 39.1357 74.1701C38.2312 74.5943 36.5193 74.8065 34 74.8065Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M33 65.703C33 65.3228 33.151 64.9582 33.4198 64.6894C33.6887 64.4206 34.0533 64.2695 34.4335 64.2695H86.0378C86.418 64.2695 86.7826 64.4206 87.0514 64.6894C87.3202 64.9582 87.4712 65.3228 87.4712 65.703C87.4712 66.0832 87.3202 66.4478 87.0514 66.7166C86.7826 66.9854 86.418 67.1364 86.0378 67.1364H34.4335C34.0533 67.1364 33.6887 66.9854 33.4198 66.7166C33.151 66.4478 33 66.0832 33 65.703Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M41.6008 44.202V65.7038H81.7375V44.202L61.6692 32.7344L41.6008 44.202ZM67.403 48.5024H76.0037V64.2704H67.403V48.5024ZM63.1026 48.5024H47.3346V57.1031H63.1026V48.5024Z"
            fill="white"
          />
          <path d="M73.137 33.9067V29.8672H77.4373V37.0345L73.137 33.9067Z" fill="white" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M71.7034 29.867C71.7034 29.4869 71.8544 29.1223 72.1232 28.8534C72.392 28.5846 72.7566 28.4336 73.1368 28.4336H77.4372C77.8174 28.4336 78.182 28.5846 78.4508 28.8534C78.7196 29.1223 78.8706 29.4869 78.8706 29.867V37.0343C78.8707 37.2987 78.7976 37.558 78.6594 37.7834C78.5213 38.0089 78.3235 38.1917 78.0879 38.3118C77.8523 38.4318 77.5881 38.4843 77.3245 38.4635C77.0609 38.4427 76.8082 38.3495 76.5943 38.194L72.294 35.0662C72.111 34.9332 71.9621 34.7588 71.8595 34.5572C71.7568 34.3557 71.7033 34.1327 71.7034 33.9065V29.867ZM74.5703 31.3005V33.1769L76.0037 34.219V31.3005H74.5703Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M60.9422 27.1979C61.1625 27.0683 61.4134 27 61.669 27C61.9246 27 62.1755 27.0683 62.3958 27.1979L88.0001 42.2592L86.5466 44.7305L61.669 30.0963L36.7914 44.7319L35.3379 42.2606L60.9422 27.1993V27.1979Z"
            fill="white"
          />
        </svg>
      );
    case 'Golf Course':
      return (
        <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120" fill="none">
          <g filter="url(#filter0_d_1713_554)">
            <circle cx="60" cy="56" r="48" fill="#3C4D7D" />
            <circle cx="60" cy="56" r="52" stroke="#C3CADA" strokeWidth="8" />
          </g>
          <path
            d="M48.3162 25V85.6649C49.4252 85.7576 50.5442 85.8199 51.6709 85.8437L51.6551 47.7752L88 39.0874L51.6482 30.398L51.6457 25H48.3162ZM81.3987 73.1435C77.8143 73.1435 74.9487 75.0273 74.9487 77.3834C74.9487 79.7396 77.8143 81.6233 81.3987 81.6233C84.983 81.6233 87.8487 79.7396 87.8487 77.3834C87.8487 75.0273 84.983 73.1435 81.3987 73.1435ZM59.7598 79.7085C58.278 79.7085 56.8269 79.7304 55.4133 79.7694L55.416 85.9394C56.8288 85.9785 58.279 86 59.7598 86C66.9876 86 73.5355 85.5112 78.1375 84.7548C79.3931 84.5486 80.4978 84.3191 81.426 84.0847C81.417 84.0847 81.4081 84.0852 81.3989 84.0852C77.3333 84.0852 73.8066 82.5003 72.1724 80.2241C68.5028 79.8986 64.2636 79.7085 59.7598 79.7085ZM44.571 80.511C43.43 80.6454 42.3597 80.793 41.3822 80.9537C39.081 81.3317 37.2636 81.7866 36.1733 82.2102C35.2626 82.5642 35.057 82.8156 35.0131 82.8544C35.0568 82.8932 35.2628 83.1446 36.1731 83.4986C37.2633 83.9222 39.0808 84.3769 41.3818 84.755C42.3593 84.9157 43.4296 85.0633 44.5706 85.1977L44.571 80.511ZM35.0131 82.8544C35.0048 82.8467 35 82.8441 35 82.8543C35 82.8644 35.0046 82.8621 35.0131 82.8544Z"
            fill="white"
          />
        </svg>
      );
  }

  return null;
};

export const CustomHighlightsContainer = styled.div`
  display: flex;
  padding: 1.5rem;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  align-self: stretch;
  border-radius: 0.5rem;
  border: 1px solid var(--border-light-bd-tertiary-light, #EAEAEA);
  background: var(--primary-b, #FFF);
  max-width: 1052px;
  width: 100%;
  margin: 0 auto;
  position: relative;
`
export const CustomHighlightsContent = ({ headerTitle, tooltipText, children, onAddClick}) => {
  const [showTooltip, setShowTooltip] = useState(false)
  return (
    <CustomHighlightsContainer>
       <CustomHighlightsComponents>
        <CustomHighlightsIcon />
        <CustomHighlightsWrapper>
          <CustomHighlightsHeader
            title={headerTitle}
            toggleTooltip={(flag) => setShowTooltip(flag)}
            onAddClick={onAddClick}
          />
          {children}
        </CustomHighlightsWrapper>
      </CustomHighlightsComponents>
      {showTooltip && <CustomHighlightsTooltip text={tooltipText} /> }
    </CustomHighlightsContainer>
  )
}
export const CustomHighlightsTooltipContainer = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
position: absolute;
right: -23.5px;
top: -11.717px;
`

export const CustomHighlightsTooltipText = styled.div`
display: flex;
padding: var(--borderRadius, 4px) 12px;
justify-content: center;
align-items: center;
border-radius: var(--borderRadius, 4px);
background: var(--primitives-orange-orange-200, #FEE284);
& p {
  color: var(--content-light-ct-primary-a-light, #2F2F2F);
text-align: center;

/* paragraph/body */
font-family: Montserrat;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 24px; /* 150% */
}
`

export const CustomHighlightsTooltip = ({ text }) => {
  return (
    <CustomHighlightsTooltipContainer>
      <CustomHighlightsTooltipText>
        <p>{text}</p>
      </CustomHighlightsTooltipText>
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="6" viewBox="0 0 12 6" fill="none">
        <path d="M6 6L5.24537e-07 -1.04907e-06L12 0L6 6Z" fill="#FEE284"/>
      </svg>
    </CustomHighlightsTooltipContainer>
  )
}

export const CustomHighlightsComponents = styled.div`
display: flex;
align-items: flex-start;
gap: 1rem;
align-self: stretch;
`
export const CustomHighlightsIconContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const CustomHighlightsIcon = () => {
  return (
    <CustomHighlightsIconContainer>
     <svg xmlns="http://www.w3.org/2000/svg" width="35" height="36" viewBox="0 0 35 36" fill="none">
        <path d="M17.5 35.7168C12.8587 35.7168 8.40752 33.8731 5.12563 30.5912C1.84374 27.3093 0 22.8581 0 18.2168C0 13.5755 1.84374 9.12432 5.12563 5.84243C8.40752 2.56054 12.8587 0.716797 17.5 0.716797C22.1413 0.716797 26.5925 2.56054 29.8744 5.84243C33.1563 9.12432 35 13.5755 35 18.2168C35 22.8581 33.1563 27.3093 29.8744 30.5912C26.5925 33.8731 22.1413 35.7168 17.5 35.7168ZM18.0513 7.42805C17.9274 7.34999 17.7884 7.29895 17.6434 7.27825C17.4985 7.25755 17.3508 7.26765 17.21 7.30791C17.0692 7.34817 16.9385 7.41766 16.8264 7.51187C16.7143 7.60607 16.6233 7.72286 16.5594 7.85461L13.9344 13.1746L8.06313 14.0277C7.86908 14.0544 7.68647 14.1352 7.53618 14.2608C7.38589 14.3864 7.27399 14.5518 7.21328 14.738C7.15258 14.9243 7.14551 15.1238 7.1929 15.3139C7.24029 15.5039 7.34022 15.6768 7.48125 15.8127L11.7337 19.9515L10.7275 25.8009C10.6952 25.9931 10.7172 26.1906 10.791 26.371C10.8647 26.5514 10.9874 26.7077 11.1451 26.8223C11.3029 26.9368 11.4894 27.0051 11.6838 27.0194C11.8782 27.0337 12.0728 26.9936 12.2456 26.9034L17.5 24.1427L22.75 26.9012C22.9227 26.9923 23.1175 27.0331 23.3123 27.0192C23.5071 27.0053 23.6941 26.9371 23.8521 26.8223C24.0101 26.7075 24.1328 26.5508 24.2064 26.3699C24.2799 26.189 24.3013 25.9911 24.2681 25.7987L23.2662 19.9515L27.5144 15.8105C27.6531 15.674 27.751 15.5015 27.7971 15.3124C27.8433 15.1233 27.8358 14.9251 27.7757 14.7399C27.7155 14.5548 27.6049 14.3901 27.4564 14.2644C27.3078 14.1386 27.1272 14.0566 26.9347 14.0277L21.0613 13.1746L18.4363 7.85461C18.3508 7.67892 18.2173 7.53103 18.0513 7.42805Z" fill="#5069AF"/>
      </svg>
    </CustomHighlightsIconContainer>
  )
}
export const CustomHighlightsWrapper = styled.div`
display: flex;
padding: var(--borderRadius, 0.25rem) 0rem;
flex-direction: column;
justify-content: center;
align-items: flex-start;
gap: 1rem;
flex: 1 0 0;

& .__images {
    display: flex;
    align-items: flex-start;
    align-content: flex-start;
    gap: 8px 16px;
    align-self: stretch;
    flex-wrap: wrap;
    & .__photo {
      display: flex;
      padding: var(--borderRadius, 4px);
      flex-direction: column;
      align-items: center;
      gap: var(--borderRadius, 4px);
      border-radius: var(--borderRadius, 4px);
      border: 1px solid var(--border-light-bd-tertiary-light, #EAEAEA);

      & img {
        width: calc(250px - 38px) !important;
        height: 178.571px !important;
        object-fit: cover;
        border-radius: var(--borderRadius, 4px);
        border: 1px solid #FFF;
        background: url(<path-to-image>) lightgray 50% / cover no-repeat;
      }

      & .upload-photo-wrapper {
        
        & > div {
          width: calc(250px - 38px);
          height: 178.571px;
        }

        & h5 {
          font-size: 1rem;
        }
      }

      & svg {
        cursor: pointer;
      }
    }
  }

  & .__text-fields {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
    & .__text-field-group {
      display: flex;
      padding: 8px 16px;
      justify-content: space-between;
      align-items: center;
      align-self: stretch;
      border-radius: var(--borderRadius, 4px);
      border: 1px solid var(--border-light-bd-secondary-light, #DADADA);
      background: var(--background-light-bg-secondary-light, #F7F7F7);

      & .__text-field {
        display: flex;
        padding-right: 8px;
        align-items: center;
        gap: 8px;
        flex: 1 0 0;

        & input {
          flex: 1;
          border: none;
          background: transparent;
          color: var(--content-light-ct-primary-a-light, #2F2F2F);

          /* paragraph/body */
          font-family: Montserrat;
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 24px; /* 150% */
          &:focus-visible {
            outline: unset;
          }
        }
      }

      & svg {
        cursor: pointer;
      }
    }
  }
`
export const CustomHighlightsHeaderContainer = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
align-self: stretch;

& p {
  color: var(--content-light-ct-primary-b-light, #494949);

  /* paragraph/body */
  font-family: Montserrat;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem; /* 150% */
}

& svg {
  cursor: pointer;
}
`
export const CustomHighlightsHeader = ({ title, toggleTooltip, onAddClick}) => {
  return (
    <CustomHighlightsHeaderContainer>
      <p>{ title }</p>
      <svg
        onClick={onAddClick}
        onMouseOver={() => toggleTooltip(true)}
        onMouseLeave={() => toggleTooltip(false)} xmlns="http://www.w3.org/2000/svg" width="25" height="26" viewBox="0 0 25 26" fill="none">
        <path d="M12.5 0.716797C5.6 0.716797 0 6.3168 0 13.2168C0 20.1168 5.6 25.7168 12.5 25.7168C19.4 25.7168 25 20.1168 25 13.2168C25 6.3168 19.4 0.716797 12.5 0.716797ZM17.5 14.4668H13.75V18.2168C13.75 18.9043 13.1875 19.4668 12.5 19.4668C11.8125 19.4668 11.25 18.9043 11.25 18.2168V14.4668H7.5C6.8125 14.4668 6.25 13.9043 6.25 13.2168C6.25 12.5293 6.8125 11.9668 7.5 11.9668H11.25V8.2168C11.25 7.5293 11.8125 6.9668 12.5 6.9668C13.1875 6.9668 13.75 7.5293 13.75 8.2168V11.9668H17.5C18.1875 11.9668 18.75 12.5293 18.75 13.2168C18.75 13.9043 18.1875 14.4668 17.5 14.4668Z" fill="#979797"/>
      </svg>
    </CustomHighlightsHeaderContainer>
  )
}

export const CustomHighlightTextFieldGroup = ({ value, handleChange, remove}) => {
  return (
    <div className='__text-field-group'>
      <div className='__text-field'>
        <input type='text' value={value} onChange={handleChange} placeholder='enter custom highlight' />
      </div>
      <svg
        onClick={remove}
        xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
        <path d="M9 0.288086C7.21997 0.288086 5.47991 0.815927 3.99987 1.80486C2.51983 2.79379 1.36628 4.1994 0.685088 5.84393C0.00389956 7.48847 -0.17433 9.29807 0.172936 11.0439C0.520203 12.7897 1.37737 14.3934 2.63604 15.652C3.89471 16.9107 5.49836 17.7679 7.24419 18.1151C8.99002 18.4624 10.7996 18.2842 12.4442 17.603C14.0887 16.9218 15.4943 15.7683 16.4832 14.2882C17.4722 12.8082 18 11.0681 18 9.28808C17.9975 6.90191 17.0485 4.61419 15.3612 2.92691C13.6739 1.23963 11.3862 0.290606 9 0.288086ZM12.259 11.5675C12.3234 11.6318 12.3744 11.7082 12.4092 11.7922C12.444 11.8763 12.4619 11.9663 12.4619 12.0573C12.4619 12.1483 12.444 12.2384 12.4092 12.3224C12.3744 12.4064 12.3234 12.4828 12.259 12.5471C12.1947 12.6114 12.1184 12.6625 12.0343 12.6973C11.9503 12.7321 11.8602 12.75 11.7692 12.75C11.6783 12.75 11.5882 12.7321 11.5042 12.6973C11.4201 12.6625 11.3437 12.6114 11.2794 12.5471L9 10.2668L6.72058 12.5471C6.65626 12.6114 6.5799 12.6625 6.49585 12.6973C6.41181 12.7321 6.32174 12.75 6.23077 12.75C6.13981 12.75 6.04973 12.7321 5.96569 12.6973C5.88165 12.6625 5.80529 12.6114 5.74096 12.5471C5.67664 12.4828 5.62562 12.4064 5.59081 12.3224C5.556 12.2384 5.53808 12.1483 5.53808 12.0573C5.53808 11.9663 5.556 11.8763 5.59081 11.7922C5.62562 11.7082 5.67664 11.6318 5.74096 11.5675L8.02125 9.28808L5.74096 7.00866C5.61106 6.87876 5.53808 6.70257 5.53808 6.51885C5.53808 6.33514 5.61106 6.15895 5.74096 6.02905C5.87087 5.89914 6.04706 5.82616 6.23077 5.82616C6.41449 5.82616 6.59067 5.89914 6.72058 6.02905L9 8.30933L11.2794 6.02905C11.3437 5.96472 11.4201 5.9137 11.5042 5.87889C11.5882 5.84408 11.6783 5.82616 11.7692 5.82616C11.8602 5.82616 11.9503 5.84408 12.0343 5.87889C12.1184 5.9137 12.1947 5.96472 12.259 6.02905C12.3234 6.09337 12.3744 6.16973 12.4092 6.25377C12.444 6.33781 12.4619 6.42789 12.4619 6.51885C12.4619 6.60982 12.444 6.69989 12.4092 6.78394C12.3744 6.86798 12.3234 6.94434 12.259 7.00866L9.97875 9.28808L12.259 11.5675Z" fill="#A79877"/>
      </svg>
    </div>
  )
}

export const CustomHighlightPhoto = ({ name, handleChange, remove, communityFiles }) => {
  return (
    <div className='__photo'>
        <UploadPhoto name={name} handleChange={handleChange} communityFiles={communityFiles} />
        <svg
          onClick={remove} 
          xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
          <path d="M10 0.288086C8.02219 0.288086 6.08879 0.874576 4.4443 1.97339C2.79981 3.0722 1.51809 4.63399 0.761209 6.46125C0.00433284 8.28851 -0.1937 10.2992 0.192152 12.239C0.578004 14.1788 1.53041 15.9606 2.92894 17.3591C4.32746 18.7577 6.10929 19.7101 8.0491 20.0959C9.98891 20.4818 11.9996 20.2838 13.8268 19.5269C15.6541 18.77 17.2159 17.4883 18.3147 15.8438C19.4135 14.1993 20 12.2659 20 10.2881C19.9972 7.63678 18.9427 5.09487 17.068 3.22011C15.1932 1.34535 12.6513 0.290886 10 0.288086ZM13.6212 12.8208C13.6926 12.8922 13.7493 12.9771 13.788 13.0705C13.8267 13.1638 13.8466 13.2639 13.8466 13.365C13.8466 13.4661 13.8267 13.5662 13.788 13.6595C13.7493 13.7529 13.6926 13.8378 13.6212 13.9092C13.5497 13.9807 13.4648 14.0374 13.3715 14.0761C13.2781 14.1148 13.178 14.1347 13.0769 14.1347C12.9759 14.1347 12.8758 14.1148 12.7824 14.0761C12.689 14.0374 12.6042 13.9807 12.5327 13.9092L10 11.3756L7.46731 13.9092C7.39584 13.9807 7.31099 14.0374 7.21762 14.0761C7.12424 14.1148 7.02415 14.1347 6.92308 14.1347C6.82201 14.1347 6.72192 14.1148 6.62854 14.0761C6.53516 14.0374 6.45032 13.9807 6.37885 13.9092C6.30738 13.8378 6.25069 13.7529 6.21201 13.6595C6.17333 13.5662 6.15342 13.4661 6.15342 13.365C6.15342 13.2639 6.17333 13.1638 6.21201 13.0705C6.25069 12.9771 6.30738 12.8922 6.37885 12.8208L8.9125 10.2881L6.37885 7.75539C6.23451 7.61105 6.15342 7.41529 6.15342 7.21116C6.15342 7.00704 6.23451 6.81127 6.37885 6.66693C6.52319 6.52259 6.71895 6.4415 6.92308 6.4415C7.12721 6.4415 7.32297 6.52259 7.46731 6.66693L10 9.20058L12.5327 6.66693C12.6042 6.59546 12.689 6.53877 12.7824 6.50009C12.8758 6.46141 12.9759 6.4415 13.0769 6.4415C13.178 6.4415 13.2781 6.46141 13.3715 6.50009C13.4648 6.53877 13.5497 6.59546 13.6212 6.66693C13.6926 6.7384 13.7493 6.82325 13.788 6.91663C13.8267 7.01 13.8466 7.11009 13.8466 7.21116C13.8466 7.31223 13.8267 7.41232 13.788 7.5057C13.7493 7.59908 13.6926 7.68392 13.6212 7.75539L11.0875 10.2881L13.6212 12.8208Z" fill="#A79877"/>
        </svg>
    </div>
  )
}

const AddCommunity = ({ fieldErrors = {} }) => {
  const { communityData, setCommunityData, loading, setLoading } = useContext(MainContext);
  const [chd, setCHD] = useState(['']);
  const [highlights, setHighlights] = useState([]);
  const [selectedHighlights, setSelectedHighlights] = useState([]);
  const [showHighlightsModal, setShowHighlightsModal] = useState(false);
  const [keyword, setKeyword] = useState('');
  const [_fieldErrors, _setFieldErrors] = useState(fieldErrors);
  const [highlightsPhotos, setHighlightsPhotos] = useState([]);
  const [customHighlights, setCustomHighlights] = useState([]);
  const [embedUrlValue, setEmbedUrlValue] = useState('')
  const [embedURLs, setEmbedURLs] = useState([])
  const [toggleVideoUpload, setToggleVideoUpload] = useState(true)

  const fetchAllHighlights = async () => {
    setLoading(true);
    let result = await getAllHighlights();
    if (result.result) {
      setHighlights(result.highlights);
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCommunityData({
      ...communityData,
      [name]: (name == 'photos' || name == 'videos') ?  communityData[name].concat(Array.from(value)) : value
    });
    _setFieldErrors({
      ..._fieldErrors,
      [name]: '',
    });
  };

  const handleChangeWithIndex = (e, index) => {
    const { name, value } = e.target;
    if (name === 'community_description') {
      const copyCHD = chd;
      copyCHD[index] = value;
      setCHD([...copyCHD]);
    }
  };

  const removeCustomHighlightPhoto = (h) => {
    delete communityData[h]
    setCommunityData(communityData)
    setHighlightsPhotos(highlightsPhotos.filter(hp => hp !== h))
  }

  const removeCustomHighlight = (c) => {
    setCustomHighlights(customHighlights.filter(cp => cp !== c))
  }

  const handleCustomHighlightChange = (e, index) => {
    const copych = customHighlights
    copych[index] =  {
      value: e.target.value,
      key: index
    }
    setCustomHighlights([...copych])
  }

  const handleDeleteVideo = (file) => {
    const copyVideos = Array.from(communityData.videos);
    const newVideos = copyVideos.filter(c => c.name !== file.name)
    setCommunityData({
        ...communityData,
        ['videos']: [...newVideos]
    });
  }

  const handleAddEmbedUrl = (e) => {
    e.preventDefault();

    if (embedUrlValue.trim() !== '') {
        setCommunityData({
            ...communityData,
            embed_urls: [...embedURLs, embedUrlValue]
        })
        setEmbedURLs((prevEmbedURLs) => [...prevEmbedURLs, embedUrlValue]);
        setEmbedUrlValue('');
      }
  };

  const handleSetEmbedUrlValue = (e) => {
    setEmbedUrlValue(e.target.value)
  }

  const handleDeleteEmbedURL = (index) => {
    setCommunityData({
        ...communityData,
        embed_urls: embedURLs.filter((_, i) => i !== index)
    })
    setEmbedURLs((prevEmbedURLs) => prevEmbedURLs.filter((_, i) => i !== index));
  };

  useEffect(() => {
    setCommunityData({
      ...communityData,
      ['additional_highlights']: JSON.stringify(customHighlights),
    });
  }, [customHighlights]);

  useEffect(() => {
    setCommunityData({
      ...communityData,
      ['community_highlights_description']: chd.join('\n'),
    });
    console.log('chd', chd);
  }, [chd]);

  useEffect(() => {
    setCommunityData({
      ...communityData,
      ['highlights']: selectedHighlights,
    });
  }, [selectedHighlights]);

  useEffect(() => {
    setCommunityData({
      ...communityData,
      ['videos']: [],
    });
  }, []);

  useEffect(() => {
    fetchAllHighlights();
  }, []);

  useEffect(() => {
    _setFieldErrors(fieldErrors);
  }, [fieldErrors]);

  const [officers, setOfficers] = useState([])
  useEffect(() => {
    async function fetchOfficers() {
      const result = await getOfficers();
      setOfficers(result.results)
    }

    fetchOfficers()
  }, [])

  return (
    <AddCommunityContainer>
      <HeroAndCommunityNameWrapper>
        <HeroWrapper>
          <HeroLeftCol>
            <UploadPhoto name="hero_0" handleChange={handleChange} />
          </HeroLeftCol>
          <HeroRightCol>
            <HeroRightColImages>
              <HeroRightColImage>
                <UploadPhoto name="hero_1" handleChange={handleChange} />
              </HeroRightColImage>
              <HeroRightColImage>
                <UploadPhoto name="hero_2" handleChange={handleChange} />
              </HeroRightColImage>
              <HeroRightColImage>
                <UploadPhoto name="hero_3" handleChange={handleChange} />
              </HeroRightColImage>
              <HeroRightColImage>
                <UploadPhoto name="hero_4" handleChange={handleChange} />
              </HeroRightColImage>
            </HeroRightColImages>
          </HeroRightCol>
        </HeroWrapper>
        <CommunityNameWrapper>
          <CommunityNameDetailsWrapper>
            <CommunityNameDetails>
              <input
                type="text"
                name="name"
                onChange={handleChange}
                class="community-name"
                placeholder="Community Name"
              />
              {_fieldErrors.name && <FieldErrorMessage>{_fieldErrors.name[0]}</FieldErrorMessage>}
              <input type="text" name="street" onChange={handleChange} class="community-address" placeholder="Street" />
              <div style={{ display: 'flex', gap: 16 }}>
                <input type="text" name="city" onChange={handleChange} class="community-address" placeholder="City" />
                {_fieldErrors.city && <FieldErrorMessage>{_fieldErrors.city[0]}</FieldErrorMessage>}
                <select class="community-address" name="state" onChange={handleChange} placeholder="State">
                  {US_STATES.map((s) => (
                    <option value={s.value}>{s.name}</option>
                  ))}
                </select>
                {_fieldErrors.state && <FieldErrorMessage>{_fieldErrors.state[0]}</FieldErrorMessage>}
                <input type="text" name="zip" onChange={handleChange} class="community-address" placeholder="Zip" />
              </div>
              <div style={{ display: 'flex', gap: 16, width: '100%' }}>
                <div style={{ width: '100%' }}>
                  <input
                    type="text"
                    name="url"
                    onChange={handleChange}
                    class="community-address"
                    placeholder="NHS URL"
                  />
                  {communityData.url && !isValidUrl(communityData.url) && (
                    <FieldErrorMessage>Not a valid URL</FieldErrorMessage>
                  )}
                </div>
                <HomesButton
                  style={{ height: 66.39 }}
                  onClick={() => window.open(communityData.url, '_blank')}
                  disabled={!isValidUrl(communityData.url ?? '')}
                >
                  PREVIEW
                </HomesButton>
              </div>

              <CommunityByWrapper>
                <label>Community by</label>
                <input type="text" name="builder_name" onChange={handleChange} placeholder="Builder Name" />
              </CommunityByWrapper>
              {_fieldErrors.builder_name && <FieldErrorMessage>{_fieldErrors.builder_name[0]}</FieldErrorMessage>}

              <textarea name="description" onChange={handleChange} placeholder="Community Description"></textarea>
              {_fieldErrors.description && <FieldErrorMessage>{_fieldErrors.description}</FieldErrorMessage>}
              <AgentDetailsInputGroup>
                <label style={{minWidth: 200}}>Loan Officer</label>
                <Select
                  name="loan_officer"
                  className='loan-officer-container'
                  classNamePrefix='loan-officer-select'
                  options={officers.map(o => { return {value: o.id, label: o.first_name + ' ' + o.last_name} })}
                  onChange={(option) =>  setCommunityData({
                    ...communityData,
                    ["loan_officer"]: option.value,
                  })}
                />
              </AgentDetailsInputGroup>
            </CommunityNameDetails>
            {/*<CommunityNameButtons>
                        <HomesButton>
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                            <path d="M21.2236 19.4949C21.7631 18.6488 22.0696 17.6312 22.0696 16.5522C22.0696 13.487 19.6175 11.0348 16.5522 11.0348C13.487 11.0348 11.0348 13.487 11.0348 16.5522C11.0348 19.6175 13.487 22.0696 16.5522 22.0696C17.6189 22.0696 18.6243 21.7631 19.4703 21.2359L23.2957 25L25 23.2957L21.2236 19.4949ZM16.5522 19.6175C15.7393 19.6175 14.9596 19.2945 14.3848 18.7197C13.8099 18.1448 13.487 17.3652 13.487 16.5522C13.487 15.7393 13.8099 14.9596 14.3848 14.3848C14.9596 13.8099 15.7393 13.487 16.5522 13.487C17.3652 13.487 18.1448 13.8099 18.7197 14.3848C19.2945 14.9596 19.6175 15.7393 19.6175 16.5522C19.6175 17.3652 19.2945 18.1448 18.7197 18.7197C18.1448 19.2945 17.3652 19.6175 16.5522 19.6175ZM3.67827 20.8436V11.0348H0L12.2609 0L24.5218 11.0348H22.2903C21.2342 9.92917 19.8797 9.15396 18.3914 8.80334L12.2609 3.29819L6.13046 8.8156V18.3914H8.80334C9.01177 19.2742 9.36734 20.0956 9.84551 20.8436H3.67827Z" fill="white"/>
                            </svg>
                            View New Homes
                        </HomesButton>
                        <HomesButton>
                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                            <path d="M21.2236 19.4949C21.7631 18.6488 22.0696 17.6312 22.0696 16.5522C22.0696 13.487 19.6175 11.0348 16.5522 11.0348C13.487 11.0348 11.0348 13.487 11.0348 16.5522C11.0348 19.6175 13.487 22.0696 16.5522 22.0696C17.6189 22.0696 18.6243 21.7631 19.4703 21.2359L23.2957 25L25 23.2957L21.2236 19.4949ZM16.5522 19.6175C15.7393 19.6175 14.9596 19.2945 14.3848 18.7197C13.8099 18.1448 13.487 17.3652 13.487 16.5522C13.487 15.7393 13.8099 14.9596 14.3848 14.3848C14.9596 13.8099 15.7393 13.487 16.5522 13.487C17.3652 13.487 18.1448 13.8099 18.7197 14.3848C19.2945 14.9596 19.6175 15.7393 19.6175 16.5522C19.6175 17.3652 19.2945 18.1448 18.7197 18.7197C18.1448 19.2945 17.3652 19.6175 16.5522 19.6175ZM3.67827 20.8436V11.0348H0L12.2609 0L24.5218 11.0348H22.2903C21.2342 9.92917 19.8797 9.15396 18.3914 8.80334L12.2609 3.29819L6.13046 8.8156V18.3914H8.80334C9.01177 19.2742 9.36734 20.0956 9.84551 20.8436H3.67827Z" fill="white"/>
                            </svg>
                            Search for Resale Homes
                        </HomesButton>
                    </CommunityNameButtons> */}
          </CommunityNameDetailsWrapper>
        </CommunityNameWrapper>
      </HeroAndCommunityNameWrapper>
      <QuickFactsWrapper>
        <QuickFactsContentWrapper>
          <QuickFactsLeftCol>
            <UploadPhoto name="section_0" handleChange={handleChange} />
          </QuickFactsLeftCol>
          <QuickFactsRightCol>
            <QuickFactsRightColDetails>
              <QuickFactsTextDetails>
                <FactsCard>
                  <FactsCardIconWrapper>
                    <svg xmlns="http://www.w3.org/2000/svg" width="67" height="66" viewBox="0 0 67 66" fill="none">
                      <path
                        d="M33.7506 0.5H33.75C27.3221 0.5 21.0386 2.40609 15.694 5.97724C10.3494 9.54838 6.18378 14.6242 3.72393 20.5628C1.26408 26.5014 0.620473 33.036 1.87449 39.3404C3.12851 45.6448 6.22384 51.4358 10.769 55.981C15.3142 60.5262 21.1052 63.6215 27.4096 64.8755C33.714 66.1295 40.2486 65.4859 46.1872 63.0261C52.1258 60.5662 57.2016 56.4006 60.7728 51.056C64.3439 45.7114 66.25 39.4279 66.25 33V32.9994C66.2399 24.3831 62.8126 16.1227 56.72 10.03C50.6273 3.9374 42.3669 0.510119 33.7506 0.5ZM33.7495 60.7353C28.2641 60.7352 22.902 59.1085 18.3411 56.061C13.7801 53.0135 10.2252 48.6818 8.12594 43.6138C6.02672 38.5459 5.47747 32.9692 6.54765 27.5891C7.61782 22.209 10.2593 17.267 14.1382 13.3882C18.017 9.50933 22.959 6.8678 28.3391 5.79763C33.7192 4.72746 39.2959 5.27671 44.3638 7.37593C49.4318 9.47515 53.7635 13.03 56.8111 17.5911C59.8585 22.152 61.4852 27.5141 61.4853 32.9994C61.4771 40.3529 58.5524 47.4029 53.3526 52.6026C48.1529 57.8023 41.103 60.7271 33.7495 60.7353ZM43.636 45.3958C45.2595 43.7724 46.1716 41.5704 46.1716 39.2745C46.1716 36.9786 45.2595 34.7766 43.636 33.1532C42.0126 31.5297 39.8107 30.6176 37.5147 30.6176H29.9853C28.953 30.6176 27.9631 30.2076 27.2331 29.4777C26.5032 28.7477 26.0931 27.7577 26.0931 26.7255C26.0931 25.6932 26.5032 24.7032 27.2331 23.9733C27.9631 23.2434 28.953 22.8333 29.9853 22.8333H41.2794C41.9113 22.8333 42.5172 22.5823 42.964 22.1356C43.4108 21.6888 43.6618 21.0828 43.6618 20.451C43.6618 19.8191 43.4108 19.2132 42.964 18.7664C42.5172 18.3196 41.9113 18.0686 41.2794 18.0686H36.1324V15.4314C36.1324 14.7995 35.8814 14.1936 35.4346 13.7468C34.9878 13.3 34.3818 13.049 33.75 13.049C33.1182 13.049 32.5122 13.3 32.0654 13.7468C31.6187 14.1936 31.3677 14.7995 31.3677 15.4314V18.0686H29.9853C27.6894 18.0686 25.4875 18.9807 23.864 20.6042C22.2405 22.2276 21.3284 24.4295 21.3284 26.7255C21.3284 29.0214 22.2405 31.2233 23.864 32.8468C25.4875 34.4703 27.6894 35.3823 29.9853 35.3823H37.5147C38.547 35.3823 39.537 35.7924 40.2669 36.5223C40.9968 37.2523 41.4069 38.2422 41.4069 39.2745C41.4069 40.3068 40.9968 41.2967 40.2669 42.0267C39.537 42.7566 38.547 43.1667 37.5147 43.1667H26.2206C25.5888 43.1667 24.9828 43.4177 24.536 43.8644C24.0892 44.3112 23.8382 44.9172 23.8382 45.549C23.8382 46.1808 24.0892 46.7868 24.536 47.2336C24.9828 47.6804 25.5888 47.9314 26.2206 47.9314H31.3677V50.5686C31.3677 51.2005 31.6187 51.8064 32.0654 52.2532C32.5122 52.7 33.1182 52.951 33.75 52.951C34.3818 52.951 34.9878 52.7 35.4346 52.2532C35.8814 51.8064 36.1324 51.2005 36.1324 50.5686V47.9314H37.5147C39.8107 47.9314 42.0126 47.0193 43.636 45.3958Z"
                        fill="#5284E0"
                        stroke="#5284E0"
                      />
                    </svg>
                  </FactsCardIconWrapper>
                  <FactsCardTextContentWrapper>
                    <label>Min:</label>
                    <input type="number" name="price_min" onChange={handleChange} placeholder="Min Price" min={1} />
                    {_fieldErrors.price_min && <FieldErrorMessage>{_fieldErrors.price_min[0]}</FieldErrorMessage>}
                  </FactsCardTextContentWrapper>
                  <FactsCardTextContentWrapper>
                    <label>Max:</label>
                    <input type="number" name="price_max" onChange={handleChange} placeholder="Max Price" min={1} />
                    {_fieldErrors.price_max && <FieldErrorMessage>{_fieldErrors.price_max[0]}</FieldErrorMessage>}
                  </FactsCardTextContentWrapper>
                </FactsCard>
                <FactsCard>
                  <FactsCardIconWrapper>
                    <svg xmlns="http://www.w3.org/2000/svg" width="65" height="64" viewBox="0 0 65 64" fill="none">
                      <path
                        d="M37.05 25.7134V29.9277H28.45V25.7134V24.5216L27.5996 25.3567L21.1996 31.6424L20.8364 31.9992L21.1996 32.3559L27.5996 38.6416L28.45 39.4768V38.2849V34.0706H37.05V38.2849V39.4768L37.9004 38.6416L44.3004 32.3559L44.6636 31.9992L44.3004 31.6424L37.9004 25.3567L37.05 24.5216V25.7134ZM16.75 18.9277H16.25V19.4277V44.5706V45.0706H16.75H19.95H20.45V44.5706V19.4277V18.9277H19.95H16.75ZM45.55 18.9277H45.05V19.4277V44.5706V45.0706H45.55H48.75H49.25V44.5706V19.4277V18.9277H48.75H45.55Z"
                        fill="#5284E0"
                        stroke="#5284E0"
                      />
                      <circle cx="32.75" cy="32" r="29" stroke="#5284E0" strokeWidth="6" />
                    </svg>
                  </FactsCardIconWrapper>
                  <FactsCardTextContentWrapper>
                    <label>Min:</label>
                    <input type="number" name="area_min" onChange={handleChange} placeholder="Min Area" min={1} />
                    {_fieldErrors.area_min && <FieldErrorMessage>{_fieldErrors.area_min[0]}</FieldErrorMessage>}
                  </FactsCardTextContentWrapper>
                  <FactsCardTextContentWrapper>
                    <label>Max:</label>
                    <input type="number" name="area_max" onChange={handleChange} placeholder="Max Area" min={1} />
                    {_fieldErrors.area_max && <FieldErrorMessage>{_fieldErrors.area_max[0]}</FieldErrorMessage>}
                  </FactsCardTextContentWrapper>
                </FactsCard>
                <FactsCard160>
                  <FactsCardIconWrapper>
                    <svg xmlns="http://www.w3.org/2000/svg" width="70" height="66" viewBox="0 0 70 66" fill="none">
                      <path
                        d="M37.5823 1.91316L37.5822 1.91311C36.6771 1.0083 35.4497 0.5 34.1699 0.5C32.8901 0.5 31.6627 1.00829 30.7576 1.91311L30.7576 1.91313L1.99962 30.6665L1.99959 30.6665C1.75204 30.9141 1.55566 31.208 1.42169 31.5314C1.28771 31.8549 1.21875 32.2015 1.21875 32.5516C1.21875 32.9017 1.28771 33.2484 1.42169 33.5719C1.55566 33.8953 1.75204 34.1892 1.99959 34.4367C2.49956 34.9367 3.17765 35.2176 3.88471 35.2176C4.23481 35.2176 4.58148 35.1486 4.90493 35.0147C5.22838 34.8807 5.52227 34.6843 5.76983 34.4367L5.7701 34.4365L7.71117 32.4924V54.1837C7.71117 56.0375 8.44758 57.8153 9.7584 59.1261C11.0692 60.437 12.8471 61.1734 14.7009 61.1734H32.0067C32.713 61.1734 33.3904 60.8928 33.8899 60.3933C34.3893 59.8939 34.6699 59.2165 34.6699 58.5101C34.6699 57.8038 34.3893 57.1264 33.8899 56.627C33.3904 56.1275 32.713 55.8469 32.0067 55.8469H14.7009C14.2597 55.8469 13.8367 55.6717 13.5248 55.3598C13.2129 55.0479 13.0376 54.6248 13.0376 54.1837V27.1647L34.1699 6.03262L62.57 34.4367L62.57 34.4367C63.07 34.9367 63.7481 35.2176 64.4551 35.2176C65.1622 35.2176 65.8403 34.9367 66.3402 34.4367C66.8402 33.9368 67.1211 33.2587 67.1211 32.5516C67.1211 31.8446 66.8402 31.1665 66.3402 30.6665L66.3402 30.6665L56.3022 20.6329V6.59313C56.3022 5.88681 56.0216 5.20941 55.5222 4.70996C55.0227 4.21051 54.3453 3.92993 53.639 3.92993H49.3125C48.6062 3.92993 47.9288 4.21051 47.4293 4.70996L47.7829 5.06352L47.4293 4.70996C46.9299 5.20941 46.6493 5.88681 46.6493 6.59313V10.9801L37.5823 1.91316ZM51.4758 48.1943H51.9758V47.6943V43.3679C51.9758 42.9268 52.151 42.5038 52.463 42.1918C52.7749 41.8799 53.1979 41.7047 53.639 41.7047C54.0802 41.7047 54.5032 41.8799 54.8151 42.1918C55.127 42.5038 55.3023 42.9268 55.3023 43.3679V47.6943V48.1943H55.8023H60.1287C60.5698 48.1943 60.9929 48.3696 61.3048 48.6815C61.6167 48.9934 61.792 49.4164 61.792 49.8575C61.792 50.2986 61.6167 50.7217 61.3048 51.0336C60.9929 51.3455 60.5698 51.5207 60.1287 51.5207H55.8023H55.3023V52.0207V56.3472C55.3023 56.7883 55.127 57.2113 54.8151 57.5232C54.5032 57.8351 54.0802 58.0104 53.639 58.0104C53.1979 58.0104 52.7749 57.8351 52.463 57.5232C52.151 57.2113 51.9758 56.7883 51.9758 56.3472V52.0207V51.5207H51.4758H47.1494C46.7082 51.5207 46.2852 51.3455 45.9733 51.0336C45.6614 50.7217 45.4861 50.2986 45.4861 49.8575C45.4861 49.4164 45.6614 48.9934 45.9733 48.6815C46.2852 48.3696 46.7082 48.1943 47.1494 48.1943H51.4758ZM64.7 60.9184C67.6336 57.9849 69.2816 54.0062 69.2816 49.8575C69.2816 45.7089 67.6336 41.7302 64.7 38.7966C61.7665 35.8631 57.7877 34.2151 53.639 34.2151C49.4904 34.2151 45.5116 35.8631 42.5781 38.7966C39.6445 41.7302 37.9964 45.7089 37.9964 49.8575C37.9964 54.0062 39.6445 57.9849 42.5781 60.9184C45.5116 63.852 49.4904 65.5 53.639 65.5C57.7877 65.5 61.7665 63.852 64.7 60.9184Z"
                        fill="#5284E0"
                        stroke="#5284E0"
                      />
                    </svg>
                  </FactsCardIconWrapper>
                  <input type="number" name="homes" onChange={handleChange} placeholder="Quantity" />
                  {_fieldErrors.homes && <FieldErrorMessage>{_fieldErrors.homes[0]}</FieldErrorMessage>}
                  <p>New Homes</p>
                </FactsCard160>
                <FactsCard160>
                  <FactsCardIconWrapper>
                    <svg xmlns="http://www.w3.org/2000/svg" width="70" height="66" viewBox="0 0 70 66" fill="none">
                      <path
                        d="M30.7575 1.91311L30.7574 1.91314L1.99962 30.6666L1.99959 30.6667C1.75203 30.9142 1.55566 31.2081 1.42168 31.5315C1.28771 31.855 1.21875 32.2017 1.21875 32.5518C1.21875 32.9019 1.28771 33.2485 1.42168 33.572C1.55566 33.8954 1.75203 34.1893 1.99959 34.4369C2.24715 34.6844 2.54104 34.8808 2.86448 35.0148C3.18794 35.1488 3.53461 35.2177 3.8847 35.2177C4.23479 35.2177 4.58146 35.1488 4.90491 35.0148C5.22836 34.8808 5.52225 34.6844 5.76981 34.4369L5.77008 34.4366L7.71113 32.4925V54.1839C7.71113 56.0377 8.44754 57.8155 9.75836 59.1264C11.0692 60.4372 12.847 61.1736 14.7008 61.1736H32.0065C32.7129 61.1736 33.3903 60.893 33.8897 60.3935C34.3892 59.8941 34.6697 59.2167 34.6697 58.5104C34.6697 57.804 34.3892 57.1266 33.8897 56.6272C33.3903 56.1277 32.7129 55.8471 32.0065 55.8471H14.7008C14.2597 55.8471 13.8366 55.6719 13.5247 55.36C13.2128 55.0481 13.0376 54.625 13.0376 54.1839V27.1648L34.1697 6.03264L62.5696 34.4368L62.5697 34.4369C62.8172 34.6844 63.1111 34.8808 63.4346 35.0148C63.758 35.1488 64.1047 35.2177 64.4548 35.2177C64.8049 35.2177 65.1516 35.1488 65.475 35.0148C65.7984 34.8808 66.0923 34.6844 66.3399 34.4369C66.5874 34.1893 66.7838 33.8954 66.9178 33.572C67.0518 33.2485 67.1207 32.9019 67.1207 32.5518C67.1207 32.2017 67.0518 31.855 66.9178 31.5315C66.7838 31.2081 66.5874 30.9142 66.3399 30.6667L66.3398 30.6666L56.3019 20.6329V6.59316C56.3019 5.88683 56.0213 5.20943 55.5219 4.70998C55.0224 4.21053 54.345 3.92994 53.6387 3.92994H49.3123C48.6059 3.92994 47.9285 4.21053 47.4291 4.70998C46.9296 5.20943 46.649 5.88683 46.649 6.59316V10.9801L37.5821 1.91317L37.582 1.91311C36.6769 1.0083 35.4495 0.5 34.1697 0.5C32.8899 0.5 31.6625 1.0083 30.7575 1.91311ZM51.1217 46.0733L48.3269 48.8725C48.0149 49.1849 47.5917 49.3605 47.1503 49.3608C46.7089 49.3612 46.2854 49.1861 45.973 48.8742C45.6607 48.5623 45.485 48.139 45.4847 47.6976C45.4844 47.2562 45.6594 46.8327 45.9713 46.5203L52.4608 40.0309L52.4612 40.0305C52.6157 39.8756 52.7992 39.7527 53.0013 39.6689L52.8097 39.207L53.0013 39.6689C53.2034 39.585 53.42 39.5419 53.6388 39.5419C53.8575 39.5419 54.0742 39.585 54.2762 39.6689L54.4678 39.207L54.2762 39.6689C54.4783 39.7527 54.6618 39.8756 54.8163 40.0305L55.6703 40.8867V40.8802L61.3064 46.5163C61.6188 46.8287 61.7944 47.2524 61.7944 47.6943C61.7944 48.1361 61.6188 48.5598 61.3064 48.8723C60.994 49.1847 60.5703 49.3602 60.1284 49.3602C59.6867 49.3602 59.2631 49.1848 58.9507 48.8725C58.9507 48.8725 58.9507 48.8725 58.9506 48.8725C58.9506 48.8724 58.9505 48.8723 58.9504 48.8723L56.1558 46.0733L55.302 45.2182V46.4266V58.5103C55.302 58.9515 55.1267 59.3745 54.8148 59.6864C54.5029 59.9983 54.0799 60.1736 53.6388 60.1736C53.1976 60.1736 52.7746 59.9983 52.4627 59.6864C52.1508 59.3745 51.9755 58.9515 51.9755 58.5103V46.4266V45.2182L51.1217 46.0733ZM53.6388 65.5C57.7874 65.5 61.7662 63.852 64.6997 60.9184C67.6332 57.9849 69.2813 54.0061 69.2813 49.8575C69.2813 45.7088 67.6332 41.7301 64.6997 38.7965C61.7662 35.863 57.7874 34.215 53.6388 34.215C49.4901 34.215 45.5114 35.863 42.5778 38.7965C39.6443 41.7301 37.9962 45.7088 37.9962 49.8575C37.9962 54.0061 39.6443 57.9849 42.5778 60.9184C45.5114 63.852 49.4901 65.5 53.6388 65.5Z"
                        fill="#5284E0"
                        stroke="#5284E0"
                      />
                    </svg>
                  </FactsCardIconWrapper>
                  <input type="number" name="quick_move_ins" onChange={handleChange} placeholder="Quantity" />
                  {_fieldErrors.quick_move_ins && (
                    <FieldErrorMessage>{_fieldErrors.quick_move_ins[0]}</FieldErrorMessage>
                  )}
                  <p>Quick Move-Ins</p>
                </FactsCard160>
                {/* <FactsCard160>
                                <FactsCardIconWrapper>
                                <svg xmlns="http://www.w3.org/2000/svg" width="73" height="66" viewBox="0 0 73 66" fill="none">
                                <mask id="path-1-outside-1_1575_13576" maskUnits="userSpaceOnUse" x="0.444336" y="0" width="72" height="66" fill="black">
                                    <rect fill="white" x="0.444336" width="72" height="66"/>
                                    <path d="M32.9693 2.35856C33.8395 1.48867 35.0196 1 36.2501 1C37.4805 1 38.6606 1.48867 39.5308 2.35856L50.1712 12.9983V6.99867C50.1712 6.38335 50.4156 5.79324 50.8507 5.35814C51.2858 4.92305 51.876 4.67861 52.4913 4.67861H57.1317C57.7471 4.67861 58.3372 4.92305 58.7723 5.35814C59.2075 5.79324 59.4519 6.38335 59.4519 6.99867V22.2785L70.3753 33.1967C70.5911 33.4124 70.7622 33.6685 70.8789 33.9503C70.9957 34.2322 71.0558 34.5343 71.0558 34.8393C71.0558 35.1444 70.9957 35.4464 70.8789 35.7283C70.7622 36.0101 70.5911 36.2662 70.3753 36.4819C70.1596 36.6976 69.9035 36.8687 69.6217 36.9855C69.3398 37.1022 69.0377 37.1623 68.7327 37.1623C68.4276 37.1623 68.1255 37.1022 67.8436 36.9855C67.5618 36.8687 67.3057 36.6976 67.09 36.4819L36.2501 5.63912L13.0482 28.8397V58.0398C13.0482 58.6552 13.2926 59.2453 13.7278 59.6804C14.1629 60.1155 14.753 60.3599 15.3684 60.3599H33.9299C34.5452 60.3599 35.1354 60.6043 35.5705 61.0394C36.0056 61.4745 36.2501 62.0646 36.2501 62.68C36.2501 63.2953 36.0056 63.8854 35.5705 64.3205C35.1354 64.7556 34.5452 65 33.9299 65H15.3684C13.5223 65 11.7519 64.2667 10.4465 62.9614C9.14117 61.6561 8.40782 59.8858 8.40782 58.0398V33.4798L5.41014 36.4819C5.19442 36.6976 4.93832 36.8687 4.65647 36.9855C4.37462 37.1022 4.07253 37.1623 3.76745 37.1623C3.46238 37.1623 3.16029 37.1022 2.87843 36.9855C2.59658 36.8687 2.34048 36.6976 2.12476 36.4819C1.90904 36.2662 1.73792 36.0101 1.62117 35.7283C1.50443 35.4464 1.44434 35.1444 1.44434 34.8393C1.44434 34.5343 1.50443 34.2322 1.62117 33.9503C1.73792 33.6685 1.90904 33.4124 2.12476 33.1967L32.9693 2.35856Z"/>
                                    <path d="M48.4611 35.0749C49.2043 32.5439 52.7884 32.5439 53.5357 35.0749L53.7133 35.6859C53.8242 36.065 54.0186 36.4144 54.2824 36.7084C54.5461 37.0024 54.8723 37.2335 55.2372 37.3848C55.602 37.5361 55.9961 37.6038 56.3905 37.5827C56.7849 37.5616 57.1695 37.4525 57.5162 37.2632L58.0777 36.9576C60.3942 35.6942 62.9294 38.2293 61.6701 40.5456L61.3604 41.1071C61.1719 41.4536 61.0633 41.8379 61.0426 42.2317C61.022 42.6256 61.0898 43.0191 61.241 43.3834C61.3923 43.7477 61.6232 44.0735 61.9168 44.3369C62.2104 44.6003 62.5592 44.7947 62.9377 44.9057L63.5529 45.0915C66.0799 45.8347 66.0799 49.4185 63.5529 50.1659L62.9336 50.3434C62.5552 50.4552 62.2067 50.6504 61.9136 50.9145C61.6205 51.1786 61.3903 51.5049 61.2398 51.8696C61.0893 52.2343 61.0224 52.6281 61.044 53.022C61.0656 53.4159 61.1751 53.8 61.3645 54.1461L61.6701 54.7076C62.9294 57.0239 60.3942 59.559 58.0777 58.2997L57.5162 57.9901C57.1697 57.8015 56.7854 57.693 56.3915 57.6723C55.9976 57.6517 55.6041 57.7195 55.2398 57.8707C54.8755 58.022 54.5497 58.2529 54.2862 58.5464C54.0228 58.84 53.8285 59.1888 53.7174 59.5673L53.5316 60.1825C52.7884 62.7094 49.2043 62.7094 48.4569 60.1825L48.2794 59.5632C48.1675 59.1848 47.9724 58.8363 47.7083 58.5433C47.4442 58.2502 47.1178 58.02 46.7531 57.8695C46.3884 57.719 45.9946 57.6521 45.6006 57.6737C45.2067 57.6953 44.8226 57.8048 44.4765 57.9942L43.9149 58.2997C41.5985 59.559 39.0632 57.0239 40.3226 54.7076L40.6323 54.1461C40.8208 53.7996 40.9294 53.4154 40.95 53.0215C40.9707 52.6276 40.9029 52.2341 40.7516 51.8698C40.6004 51.5055 40.3695 51.1798 40.0759 50.9163C39.7823 50.6529 39.4335 50.4586 39.055 50.3475L38.4439 50.1659C35.9127 49.4185 35.9127 45.8347 38.4439 45.0874L39.055 44.9098C39.434 44.7989 39.7834 44.6045 40.0775 44.3408C40.3715 44.0771 40.6026 43.7508 40.754 43.386C40.9053 43.0212 40.9729 42.6271 40.9518 42.2328C40.9308 41.8384 40.8216 41.4538 40.6323 41.1071L40.3267 40.5456C39.0632 38.2293 41.5985 35.6942 43.9149 36.9535L44.4765 37.2632C44.823 37.4517 45.2072 37.5602 45.6012 37.5809C45.9951 37.6015 46.3886 37.5337 46.7529 37.3825C47.1172 37.2312 47.443 37.0004 47.7064 36.7068C47.9698 36.4132 48.1642 36.0644 48.2753 35.6859L48.4611 35.0749ZM57.19 47.6266C57.19 46.8133 57.0298 46.0079 56.7185 45.2565C56.4073 44.5051 55.951 43.8224 55.3759 43.2473C54.8008 42.6722 54.118 42.216 53.3665 41.9048C52.6151 41.5935 51.8097 41.4333 50.9963 41.4333C50.183 41.4333 49.3776 41.5935 48.6261 41.9048C47.8747 42.216 47.1919 42.6722 46.6168 43.2473C46.0416 43.8224 45.5854 44.5051 45.2741 45.2565C44.9629 46.0079 44.8027 46.8133 44.8027 47.6266C44.8027 49.2692 45.4552 50.8445 46.6168 52.0059C47.7783 53.1674 49.3537 53.8199 50.9963 53.8199C52.639 53.8199 54.2144 53.1674 55.3759 52.0059C56.5374 50.8445 57.19 49.2692 57.19 47.6266Z"/>
                                </mask>
                                <path d="M32.9693 2.35856C33.8395 1.48867 35.0196 1 36.2501 1C37.4805 1 38.6606 1.48867 39.5308 2.35856L50.1712 12.9983V6.99867C50.1712 6.38335 50.4156 5.79324 50.8507 5.35814C51.2858 4.92305 51.876 4.67861 52.4913 4.67861H57.1317C57.7471 4.67861 58.3372 4.92305 58.7723 5.35814C59.2075 5.79324 59.4519 6.38335 59.4519 6.99867V22.2785L70.3753 33.1967C70.5911 33.4124 70.7622 33.6685 70.8789 33.9503C70.9957 34.2322 71.0558 34.5343 71.0558 34.8393C71.0558 35.1444 70.9957 35.4464 70.8789 35.7283C70.7622 36.0101 70.5911 36.2662 70.3753 36.4819C70.1596 36.6976 69.9035 36.8687 69.6217 36.9855C69.3398 37.1022 69.0377 37.1623 68.7327 37.1623C68.4276 37.1623 68.1255 37.1022 67.8436 36.9855C67.5618 36.8687 67.3057 36.6976 67.09 36.4819L36.2501 5.63912L13.0482 28.8397V58.0398C13.0482 58.6552 13.2926 59.2453 13.7278 59.6804C14.1629 60.1155 14.753 60.3599 15.3684 60.3599H33.9299C34.5452 60.3599 35.1354 60.6043 35.5705 61.0394C36.0056 61.4745 36.2501 62.0646 36.2501 62.68C36.2501 63.2953 36.0056 63.8854 35.5705 64.3205C35.1354 64.7556 34.5452 65 33.9299 65H15.3684C13.5223 65 11.7519 64.2667 10.4465 62.9614C9.14117 61.6561 8.40782 59.8858 8.40782 58.0398V33.4798L5.41014 36.4819C5.19442 36.6976 4.93832 36.8687 4.65647 36.9855C4.37462 37.1022 4.07253 37.1623 3.76745 37.1623C3.46238 37.1623 3.16029 37.1022 2.87843 36.9855C2.59658 36.8687 2.34048 36.6976 2.12476 36.4819C1.90904 36.2662 1.73792 36.0101 1.62117 35.7283C1.50443 35.4464 1.44434 35.1444 1.44434 34.8393C1.44434 34.5343 1.50443 34.2322 1.62117 33.9503C1.73792 33.6685 1.90904 33.4124 2.12476 33.1967L32.9693 2.35856Z" fill="#5284E0"/>
                                <path d="M48.4611 35.0749C49.2043 32.5439 52.7884 32.5439 53.5357 35.0749L53.7133 35.6859C53.8242 36.065 54.0186 36.4144 54.2824 36.7084C54.5461 37.0024 54.8723 37.2335 55.2372 37.3848C55.602 37.5361 55.9961 37.6038 56.3905 37.5827C56.7849 37.5616 57.1695 37.4525 57.5162 37.2632L58.0777 36.9576C60.3942 35.6942 62.9294 38.2293 61.6701 40.5456L61.3604 41.1071C61.1719 41.4536 61.0633 41.8379 61.0426 42.2317C61.022 42.6256 61.0898 43.0191 61.241 43.3834C61.3923 43.7477 61.6232 44.0735 61.9168 44.3369C62.2104 44.6003 62.5592 44.7947 62.9377 44.9057L63.5529 45.0915C66.0799 45.8347 66.0799 49.4185 63.5529 50.1659L62.9336 50.3434C62.5552 50.4552 62.2067 50.6504 61.9136 50.9145C61.6205 51.1786 61.3903 51.5049 61.2398 51.8696C61.0893 52.2343 61.0224 52.6281 61.044 53.022C61.0656 53.4159 61.1751 53.8 61.3645 54.1461L61.6701 54.7076C62.9294 57.0239 60.3942 59.559 58.0777 58.2997L57.5162 57.9901C57.1697 57.8015 56.7854 57.693 56.3915 57.6723C55.9976 57.6517 55.6041 57.7195 55.2398 57.8707C54.8755 58.022 54.5497 58.2529 54.2862 58.5464C54.0228 58.84 53.8285 59.1888 53.7174 59.5673L53.5316 60.1825C52.7884 62.7094 49.2043 62.7094 48.4569 60.1825L48.2794 59.5632C48.1675 59.1848 47.9724 58.8363 47.7083 58.5433C47.4442 58.2502 47.1178 58.02 46.7531 57.8695C46.3884 57.719 45.9946 57.6521 45.6006 57.6737C45.2067 57.6953 44.8226 57.8048 44.4765 57.9942L43.9149 58.2997C41.5985 59.559 39.0632 57.0239 40.3226 54.7076L40.6323 54.1461C40.8208 53.7996 40.9294 53.4154 40.95 53.0215C40.9707 52.6276 40.9029 52.2341 40.7516 51.8698C40.6004 51.5055 40.3695 51.1798 40.0759 50.9163C39.7823 50.6529 39.4335 50.4586 39.055 50.3475L38.4439 50.1659C35.9127 49.4185 35.9127 45.8347 38.4439 45.0874L39.055 44.9098C39.434 44.7989 39.7834 44.6045 40.0775 44.3408C40.3715 44.0771 40.6026 43.7508 40.754 43.386C40.9053 43.0212 40.9729 42.6271 40.9518 42.2328C40.9308 41.8384 40.8216 41.4538 40.6323 41.1071L40.3267 40.5456C39.0632 38.2293 41.5985 35.6942 43.9149 36.9535L44.4765 37.2632C44.823 37.4517 45.2072 37.5602 45.6012 37.5809C45.9951 37.6015 46.3886 37.5337 46.7529 37.3825C47.1172 37.2312 47.443 37.0004 47.7064 36.7068C47.9698 36.4132 48.1642 36.0644 48.2753 35.6859L48.4611 35.0749ZM57.19 47.6266C57.19 46.8133 57.0298 46.0079 56.7185 45.2565C56.4073 44.5051 55.951 43.8224 55.3759 43.2473C54.8008 42.6722 54.118 42.216 53.3665 41.9048C52.6151 41.5935 51.8097 41.4333 50.9963 41.4333C50.183 41.4333 49.3776 41.5935 48.6261 41.9048C47.8747 42.216 47.1919 42.6722 46.6168 43.2473C46.0416 43.8224 45.5854 44.5051 45.2741 45.2565C44.9629 46.0079 44.8027 46.8133 44.8027 47.6266C44.8027 49.2692 45.4552 50.8445 46.6168 52.0059C47.7783 53.1674 49.3537 53.8199 50.9963 53.8199C52.639 53.8199 54.2144 53.1674 55.3759 52.0059C56.5374 50.8445 57.19 49.2692 57.19 47.6266Z" fill="#5284E0"/>
                                <path d="M32.9693 2.35856C33.8395 1.48867 35.0196 1 36.2501 1C37.4805 1 38.6606 1.48867 39.5308 2.35856L50.1712 12.9983V6.99867C50.1712 6.38335 50.4156 5.79324 50.8507 5.35814C51.2858 4.92305 51.876 4.67861 52.4913 4.67861H57.1317C57.7471 4.67861 58.3372 4.92305 58.7723 5.35814C59.2075 5.79324 59.4519 6.38335 59.4519 6.99867V22.2785L70.3753 33.1967C70.5911 33.4124 70.7622 33.6685 70.8789 33.9503C70.9957 34.2322 71.0558 34.5343 71.0558 34.8393C71.0558 35.1444 70.9957 35.4464 70.8789 35.7283C70.7622 36.0101 70.5911 36.2662 70.3753 36.4819C70.1596 36.6976 69.9035 36.8687 69.6217 36.9855C69.3398 37.1022 69.0377 37.1623 68.7327 37.1623C68.4276 37.1623 68.1255 37.1022 67.8436 36.9855C67.5618 36.8687 67.3057 36.6976 67.09 36.4819L36.2501 5.63912L13.0482 28.8397V58.0398C13.0482 58.6552 13.2926 59.2453 13.7278 59.6804C14.1629 60.1155 14.753 60.3599 15.3684 60.3599H33.9299C34.5452 60.3599 35.1354 60.6043 35.5705 61.0394C36.0056 61.4745 36.2501 62.0646 36.2501 62.68C36.2501 63.2953 36.0056 63.8854 35.5705 64.3205C35.1354 64.7556 34.5452 65 33.9299 65H15.3684C13.5223 65 11.7519 64.2667 10.4465 62.9614C9.14117 61.6561 8.40782 59.8858 8.40782 58.0398V33.4798L5.41014 36.4819C5.19442 36.6976 4.93832 36.8687 4.65647 36.9855C4.37462 37.1022 4.07253 37.1623 3.76745 37.1623C3.46238 37.1623 3.16029 37.1022 2.87843 36.9855C2.59658 36.8687 2.34048 36.6976 2.12476 36.4819C1.90904 36.2662 1.73792 36.0101 1.62117 35.7283C1.50443 35.4464 1.44434 35.1444 1.44434 34.8393C1.44434 34.5343 1.50443 34.2322 1.62117 33.9503C1.73792 33.6685 1.90904 33.4124 2.12476 33.1967L32.9693 2.35856Z" stroke="#5284E0" strokeWidth="2" mask="url(#path-1-outside-1_1575_13576)"/>
                                <path d="M48.4611 35.0749C49.2043 32.5439 52.7884 32.5439 53.5357 35.0749L53.7133 35.6859C53.8242 36.065 54.0186 36.4144 54.2824 36.7084C54.5461 37.0024 54.8723 37.2335 55.2372 37.3848C55.602 37.5361 55.9961 37.6038 56.3905 37.5827C56.7849 37.5616 57.1695 37.4525 57.5162 37.2632L58.0777 36.9576C60.3942 35.6942 62.9294 38.2293 61.6701 40.5456L61.3604 41.1071C61.1719 41.4536 61.0633 41.8379 61.0426 42.2317C61.022 42.6256 61.0898 43.0191 61.241 43.3834C61.3923 43.7477 61.6232 44.0735 61.9168 44.3369C62.2104 44.6003 62.5592 44.7947 62.9377 44.9057L63.5529 45.0915C66.0799 45.8347 66.0799 49.4185 63.5529 50.1659L62.9336 50.3434C62.5552 50.4552 62.2067 50.6504 61.9136 50.9145C61.6205 51.1786 61.3903 51.5049 61.2398 51.8696C61.0893 52.2343 61.0224 52.6281 61.044 53.022C61.0656 53.4159 61.1751 53.8 61.3645 54.1461L61.6701 54.7076C62.9294 57.0239 60.3942 59.559 58.0777 58.2997L57.5162 57.9901C57.1697 57.8015 56.7854 57.693 56.3915 57.6723C55.9976 57.6517 55.6041 57.7195 55.2398 57.8707C54.8755 58.022 54.5497 58.2529 54.2862 58.5464C54.0228 58.84 53.8285 59.1888 53.7174 59.5673L53.5316 60.1825C52.7884 62.7094 49.2043 62.7094 48.4569 60.1825L48.2794 59.5632C48.1675 59.1848 47.9724 58.8363 47.7083 58.5433C47.4442 58.2502 47.1178 58.02 46.7531 57.8695C46.3884 57.719 45.9946 57.6521 45.6006 57.6737C45.2067 57.6953 44.8226 57.8048 44.4765 57.9942L43.9149 58.2997C41.5985 59.559 39.0632 57.0239 40.3226 54.7076L40.6323 54.1461C40.8208 53.7996 40.9294 53.4154 40.95 53.0215C40.9707 52.6276 40.9029 52.2341 40.7516 51.8698C40.6004 51.5055 40.3695 51.1798 40.0759 50.9163C39.7823 50.6529 39.4335 50.4586 39.055 50.3475L38.4439 50.1659C35.9127 49.4185 35.9127 45.8347 38.4439 45.0874L39.055 44.9098C39.434 44.7989 39.7834 44.6045 40.0775 44.3408C40.3715 44.0771 40.6026 43.7508 40.754 43.386C40.9053 43.0212 40.9729 42.6271 40.9518 42.2328C40.9308 41.8384 40.8216 41.4538 40.6323 41.1071L40.3267 40.5456C39.0632 38.2293 41.5985 35.6942 43.9149 36.9535L44.4765 37.2632C44.823 37.4517 45.2072 37.5602 45.6012 37.5809C45.9951 37.6015 46.3886 37.5337 46.7529 37.3825C47.1172 37.2312 47.443 37.0004 47.7064 36.7068C47.9698 36.4132 48.1642 36.0644 48.2753 35.6859L48.4611 35.0749ZM57.19 47.6266C57.19 46.8133 57.0298 46.0079 56.7185 45.2565C56.4073 44.5051 55.951 43.8224 55.3759 43.2473C54.8008 42.6722 54.118 42.216 53.3665 41.9048C52.6151 41.5935 51.8097 41.4333 50.9963 41.4333C50.183 41.4333 49.3776 41.5935 48.6261 41.9048C47.8747 42.216 47.1919 42.6722 46.6168 43.2473C46.0416 43.8224 45.5854 44.5051 45.2741 45.2565C44.9629 46.0079 44.8027 46.8133 44.8027 47.6266C44.8027 49.2692 45.4552 50.8445 46.6168 52.0059C47.7783 53.1674 49.3537 53.8199 50.9963 53.8199C52.639 53.8199 54.2144 53.1674 55.3759 52.0059C56.5374 50.8445 57.19 49.2692 57.19 47.6266Z" stroke="#5284E0" strokeWidth="2" mask="url(#path-1-outside-1_1575_13576)"/>
                                </svg>
                                </FactsCardIconWrapper>
                                <input placeholder="Quantity" readOnly value="1" />
                                <p>Builder</p>
                            </FactsCard160> */}
              </QuickFactsTextDetails>
            </QuickFactsRightColDetails>
          </QuickFactsRightCol>
        </QuickFactsContentWrapper>
      </QuickFactsWrapper>
      <HighlightsWrapper>
        <SectionHeader title="Highlights" />
        <div className="section__content-wrapper">
          <div className="section__description">
            <textarea
              placeholder="Community Highlights Description"
              name="highlights_description"
              onChange={handleChange}
            ></textarea>
          </div>
        </div>

        <div className="section__highlight-card-wrapper">
          {selectedHighlights.map((highlight) => (
            <div className="section__highlight-card">
              <div className="section__highlight-menu">
                <EditIcon onClick={() => setShowHighlightsModal(!showHighlightsModal)} />
                <CloseIcon
                  onClick={() =>
                    setSelectedHighlights([...selectedHighlights.filter((h) => h.value !== highlight.value)])
                  }
                />
              </div>
              <HighlightIcon variant={highlight.name} />
              <h5>{highlight.name}</h5>
            </div>
          ))}
          <div className="section__highlight-card" onClick={() => setShowHighlightsModal(!showHighlightsModal)}>
            <svg xmlns="http://www.w3.org/2000/svg" width="104" height="120" viewBox="0 0 76 75" fill="none">
              <path
                d="M61.1975 42.8275C60.2506 42.8275 59.3424 43.2037 58.6728 43.8733C58.0033 44.5429 57.6271 45.451 57.6271 46.3979V47.7547L52.3428 42.4705C50.477 40.6194 47.9552 39.5806 45.3269 39.5806C42.6986 39.5806 40.1768 40.6194 38.311 42.4705L35.8117 44.9698L26.957 36.1151C25.0651 34.3142 22.5531 33.3097 19.9411 33.3097C17.329 33.3097 14.8171 34.3142 12.9251 36.1151L7.64089 41.3993V21.4049C7.64089 20.4579 8.01706 19.5498 8.68664 18.8802C9.35623 18.2106 10.2644 17.8344 11.2113 17.8344H36.2044C37.1514 17.8344 38.0595 17.4582 38.7291 16.7886C39.3987 16.1191 39.7749 15.2109 39.7749 14.264C39.7749 13.317 39.3987 12.4089 38.7291 11.7393C38.0595 11.0697 37.1514 10.6935 36.2044 10.6935H11.2113C8.37051 10.6935 5.64604 11.822 3.63728 13.8308C1.62851 15.8396 0.5 18.564 0.5 21.4049V64.2502C0.5 67.091 1.62851 69.8155 3.63728 71.8242C5.64604 73.833 8.37051 74.9615 11.2113 74.9615H54.0566C56.8975 74.9615 59.6219 73.833 61.6307 71.8242C63.6395 69.8155 64.768 67.091 64.768 64.2502V46.3979C64.768 45.451 64.3918 44.5429 63.7222 43.8733C63.0526 43.2037 62.1445 42.8275 61.1975 42.8275ZM11.2113 67.8206C10.2644 67.8206 9.35623 67.4444 8.68664 66.7749C8.01706 66.1053 7.64089 65.1971 7.64089 64.2502V51.5037L17.9952 41.1494C18.5197 40.6495 19.2165 40.3707 19.9411 40.3707C20.6656 40.3707 21.3624 40.6495 21.887 41.1494L33.2053 52.4677L48.5582 67.8206H11.2113ZM57.6271 64.2502C57.6219 64.9336 57.3966 65.5973 56.9844 66.1425L40.8817 49.9684L43.381 47.4691C43.637 47.2078 43.9425 47.0003 44.2797 46.8586C44.6169 46.7169 44.979 46.6439 45.3448 46.6439C45.7105 46.6439 46.0726 46.7169 46.4098 46.8586C46.747 47.0003 47.0525 47.2078 47.3085 47.4691L57.6271 57.8591V64.2502ZM74.4439 11.729L63.7325 1.01762C63.393 0.692569 62.9926 0.437764 62.5543 0.267831C61.685 -0.0892772 60.71 -0.0892772 59.8408 0.267831C59.4025 0.437764 59.0021 0.692569 58.6625 1.01762L47.9512 11.729C47.2789 12.4013 46.9011 13.3132 46.9011 14.264C46.9011 15.2148 47.2789 16.1267 47.9512 16.799C48.6235 17.4713 49.5354 17.849 50.4862 17.849C51.437 17.849 52.3489 17.4713 53.0212 16.799L57.6271 12.1574V32.1162C57.6271 33.0631 58.0033 33.9713 58.6728 34.6409C59.3424 35.3105 60.2506 35.6866 61.1975 35.6866C62.1445 35.6866 63.0526 35.3105 63.7222 34.6409C64.3918 33.9713 64.768 33.0631 64.768 32.1162V12.1574L69.3738 16.799C69.7058 17.1336 70.1007 17.3993 70.5357 17.5805C70.9708 17.7618 71.4375 17.8551 71.9089 17.8551C72.3802 17.8551 72.8469 17.7618 73.282 17.5805C73.7171 17.3993 74.1119 17.1336 74.4439 16.799C74.7785 16.4671 75.0441 16.0722 75.2254 15.6371C75.4067 15.202 75.5 14.7353 75.5 14.264C75.5 13.7926 75.4067 13.3259 75.2254 12.8909C75.0441 12.4558 74.7785 12.0609 74.4439 11.729Z"
                fill="#BCBCBC"
              />
            </svg>
            <h5>ADD HIGHLIGHT</h5>
          </div>
        </div>
        {chd.map((c, index) => (
          <SectionDetails className="section__details">
            {index > 0 && (
              <CloseIcon
                onClick={() => {
                  const copyCHD = chd;
                  copyCHD.pop();
                  setCHD([...copyCHD]);
                  return;
                }}
              />
            )}
            <SectionDetailsLeftCol className="section__details-left-col">
              <SectionDetailsText value={c} handleChangeWithIndex={handleChangeWithIndex} index={index} />
            </SectionDetailsLeftCol>
            <SectionDetailsRightCol className="section__details-right-col">
              <UploadPhoto name={`section_${index + 1}`} handleChange={handleChange} />
            </SectionDetailsRightCol>
          </SectionDetails>
        ))}

        <HomesButton onClick={() => setCHD([...chd, ''])}>ADD MORE COMMUNITY HIGHLIGHTS DETAILS</HomesButton>

        <CustomHighlightsContent
          headerTitle={"Upload Highlight Photos (max of 4 images)"}
          tooltipText={"Upload Photo"}
          onAddClick={() => {
            if(highlightsPhotos.length < 4) {
              setHighlightsPhotos([...highlightsPhotos, 'highlights_'+(highlightsPhotos.length + 1)])
            }
            }}>
            {highlightsPhotos.length > 0 && <div className='__images'>
                {highlightsPhotos.map((hp) => (
                  <CustomHighlightPhoto
                    key={hp}
                    name={hp}
                    handleChange={handleChange}
                    remove={() => removeCustomHighlightPhoto(hp)}/>
                ))}
            </div>}
        </CustomHighlightsContent>
        <CustomHighlightsContent
          headerTitle="Add Custom Highlights"
          tooltipText="Add Row"
          onAddClick={() => {
            setCustomHighlights([...customHighlights, { key: customHighlights.length, value: ''}])
            
            }}>
            
            { customHighlights.length > 0 && <div className="__text-fields">
                {customHighlights.map((ch, index) => (
                  <CustomHighlightTextFieldGroup 
                    key={ch.key}
                    value={ch.value}
                    handleChange={(e) => handleCustomHighlightChange(e, index)}
                    remove={() => removeCustomHighlight(ch)}/>
                ))}
            </div> }
        </CustomHighlightsContent>
      </HighlightsWrapper>
      <SectionGalleryWrapper>
        <SectionGallery>
          <SectionHeader title="Gallery" />
        </SectionGallery>
        <SectionGalleryUploadWrapper>
          <SectionGalleryUploadImageWrapper>
            <SectionGalleryUploadImage>
              <UploadPhoto title="UPLOAD PHOTO" name="photos" handleChange={handleChange} />
            </SectionGalleryUploadImage>
            <SectionGalleryUploadImage>
                {/* <UploadPhoto title="UPLOAD VIDEO" name="videos" handleChange={handleChange} isEmbedURL={true}/> */}
                <div style={{ display: toggleVideoUpload ? 'flex' : 'none', flexDirection: 'column', height: '100%' }}>
                    <div style={{ fontSize: '12px', cursor: 'pointer', position: 'absolute', padding: '12px 2px', zIndex: '5' }} onClick={() => {
                        setToggleVideoUpload(false);
                    }}>Embed Video URL</div>
                    <UploadPhoto title="UPLOAD VIDEO" name="videos" handleChange={handleChange} isEmbedURL={true}/>
                </div>
                
                <div style={{ display: !toggleVideoUpload ? 'flex' : 'none', flexDirection: 'column', gap: '8px' }}>
                  <div style={{ fontSize: '12px', cursor: 'pointer', padding: '9px 14px' }} onClick={() => {
                      setToggleVideoUpload(true);
                  }}>Upload Video</div>
                  <EmbedUrlGuidleines>
                      <h3 className="title">Embed URL Video Guidelines</h3>
                      <p className="sub-title">You can upload videos by providing an embed URL. Currently, we accept and support embed URLs from YouTube and Vimeo.</p>
                      <div className="instructions">
                        <p>Accepted URL Formats</p>
                        <span>YouTube: {`https://www.youtube.com/embed/{video_id}`}</span>
                        <span>Vimeo: {`https://player.vimeo.com/video/{video_id}?h={hash}`}</span>
                      </div>
                      <p className="sub-title">Please ensure your video URLs match the formats above for a successful upload.</p>
                  </EmbedUrlGuidleines>
                  <EmbedUrlForm onSubmit={handleAddEmbedUrl}>
                      <p>Embed URL</p>
                      <input
                          onChange={handleSetEmbedUrlValue}
                          type="url"
                          value={embedUrlValue}
                          name="embed_url"
                      />
                      <div className="embed-url-submit" onClick={(e) => {
                          e.preventDefault();
                          handleAddEmbedUrl(e);
                      }}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                              <path d="M10 0.859497C4.48 0.859497 0 5.3395 0 10.8595C0 16.3795 4.48 20.8595 10 20.8595C15.52 20.8595 20 16.3795 20 10.8595C20 5.3395 15.52 0.859497 10 0.859497ZM14 11.8595H11V14.8595C11 15.4095 10.55 15.8595 10 15.8595C9.45 15.8595 9 15.4095 9 14.8595V11.8595H6C5.45 11.8595 5 11.4095 5 10.8595C5 10.3095 5.45 9.8595 6 9.8595H9V6.8595C9 6.3095 9.45 5.8595 10 5.8595C10.55 5.8595 11 6.3095 11 6.8595V9.8595H14C14.55 9.8595 15 10.3095 15 10.8595C15 11.4095 14.55 11.8595 14 11.8595Z" fill="#979797"/>
                          </svg>
                      </div>
                  </EmbedUrlForm>
                </div>

                {/* <form
                    onSubmit={handleAddEmbedUrl}
                    style={{
                        zIndex: '5',
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        marginTop: '-42px',
                        borderWidth: '1px 0px 1px 0px',
                        borderStyle: 'solid',
                        borderColor: '#d8d8d8',
                        borderRadius: '0px 0px 16px 16px',
                    }}
                >
                    <p
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            width: '30%',
                            fontSize: '15px',
                            padding: '5px'
                        }}
                    >Embed URL</p>
                    <input
                        style={{
                            fontSize: '15px',
                            width: '70%',
                            borderWidth: '0px 0px 0px 1px',
                            borderRadius: '0px 0px 16px 0px',
                            borderColor: '#d8d8d8',
                            outline: 'none'
                        }}
                        onChange={handleSetEmbedUrlValue}
                        type="url"
                        value={embedUrlValue}
                        name="embed_url"
                    />
                    <div style={{ cursor: 'pointer', margin: '0 5px' }} onClick={(e) => {
                        e.preventDefault();
                        handleAddEmbedUrl(e);
                    }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                            <path d="M10 0.859497C4.48 0.859497 0 5.3395 0 10.8595C0 16.3795 4.48 20.8595 10 20.8595C15.52 20.8595 20 16.3795 20 10.8595C20 5.3395 15.52 0.859497 10 0.859497ZM14 11.8595H11V14.8595C11 15.4095 10.55 15.8595 10 15.8595C9.45 15.8595 9 15.4095 9 14.8595V11.8595H6C5.45 11.8595 5 11.4095 5 10.8595C5 10.3095 5.45 9.8595 6 9.8595H9V6.8595C9 6.3095 9.45 5.8595 10 5.8595C10.55 5.8595 11 6.3095 11 6.8595V9.8595H14C14.55 9.8595 15 10.3095 15 10.8595C15 11.4095 14.55 11.8595 14 11.8595Z" fill="#979797"/>
                        </svg>
                    </div>
                </form> */}
            </SectionGalleryUploadImage>
          </SectionGalleryUploadImageWrapper>
        </SectionGalleryUploadWrapper>
        <SectionGalleryMediaWrapper>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
            { embedURLs && embedURLs.map((url, index) => {
                return (
                    <div
                      key={index}
                      style={{
                          display: 'flex',
                          flexDirection: 'row',
                          flexWrap: 'wrap',
                          padding: '10px',
                          borderRadius: '4px',
                          border: '1px solid gray',
                          justifyContent: 'space-between',
                          gap: '10px'
                      }}
                  >
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="27" height="35" viewBox="0 0 30 38" fill="none">
                              <path d="M9.375 30H16.875C17.4062 30 17.8519 29.82 18.2119 29.46C18.5719 29.1 18.7512 28.655 18.75 28.125V26.25L22.5 28.2187V20.5312L18.75 22.5V20.625C18.75 20.0938 18.57 19.6488 18.21 19.29C17.85 18.9312 17.405 18.7512 16.875 18.75H9.375C8.84375 18.75 8.39875 18.93 8.04 19.29C7.68125 19.65 7.50125 20.095 7.5 20.625V28.125C7.5 28.6562 7.68 29.1019 8.04 29.4619C8.4 29.8219 8.845 30.0012 9.375 30ZM3.75 37.5C2.71875 37.5 1.83625 37.1331 1.1025 36.3994C0.36875 35.6656 0.00125 34.7825 0 33.75V3.75C0 2.71875 0.3675 1.83625 1.1025 1.1025C1.8375 0.36875 2.72 0.00125 3.75 0H18.75L30 11.25V33.75C30 34.7812 29.6331 35.6644 28.8994 36.3994C28.1656 37.1344 27.2825 37.5013 26.25 37.5H3.75ZM16.875 13.125H26.25L16.875 3.75V13.125Z" fill="#636363"/>
                          </svg>
                          <p style={{ fontSize: '15px' }}>{ url }</p>
                      </div>
                      <div style={{ cursor: 'pointer' }} onClick={() => handleDeleteEmbedURL(index)}>
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                              <path d="M10 0.145264C8.02219 0.145264 6.08879 0.731753 4.4443 1.83057C2.79981 2.92938 1.51809 4.49117 0.761209 6.31843C0.00433284 8.14569 -0.1937 10.1564 0.192152 12.0962C0.578004 14.036 1.53041 15.8178 2.92894 17.2163C4.32746 18.6149 6.10929 19.5673 8.0491 19.9531C9.98891 20.339 11.9996 20.1409 13.8268 19.3841C15.6541 18.6272 17.2159 17.3455 18.3147 15.701C19.4135 14.0565 20 12.1231 20 10.1453C19.9972 7.49396 18.9427 4.95204 17.068 3.07729C15.1932 1.20253 12.6513 0.148063 10 0.145264ZM13.6212 12.678C13.6926 12.7494 13.7493 12.8343 13.788 12.9276C13.8267 13.021 13.8466 13.1211 13.8466 13.2222C13.8466 13.3233 13.8267 13.4233 13.788 13.5167C13.7493 13.6101 13.6926 13.6949 13.6212 13.7664C13.5497 13.8379 13.4648 13.8946 13.3715 13.9333C13.2781 13.9719 13.178 13.9918 13.0769 13.9918C12.9759 13.9918 12.8758 13.9719 12.7824 13.9333C12.689 13.8946 12.6042 13.8379 12.5327 13.7664L10 11.2328L7.46731 13.7664C7.39584 13.8379 7.31099 13.8946 7.21762 13.9333C7.12424 13.9719 7.02415 13.9918 6.92308 13.9918C6.82201 13.9918 6.72192 13.9719 6.62854 13.9333C6.53516 13.8946 6.45032 13.8379 6.37885 13.7664C6.30738 13.6949 6.25069 13.6101 6.21201 13.5167C6.17333 13.4233 6.15342 13.3233 6.15342 13.2222C6.15342 13.1211 6.17333 13.021 6.21201 12.9276C6.25069 12.8343 6.30738 12.7494 6.37885 12.678L8.9125 10.1453L6.37885 7.61257C6.23451 7.46823 6.15342 7.27247 6.15342 7.06834C6.15342 6.86421 6.23451 6.66845 6.37885 6.52411C6.52319 6.37977 6.71895 6.29868 6.92308 6.29868C7.12721 6.29868 7.32297 6.37977 7.46731 6.52411L10 9.05776L12.5327 6.52411C12.6042 6.45264 12.689 6.39595 12.7824 6.35727C12.8758 6.31859 12.9759 6.29868 13.0769 6.29868C13.178 6.29868 13.2781 6.31859 13.3715 6.35727C13.4648 6.39595 13.5497 6.45264 13.6212 6.52411C13.6926 6.59558 13.7493 6.68042 13.788 6.7738C13.8267 6.86718 13.8466 6.96727 13.8466 7.06834C13.8466 7.16941 13.8267 7.2695 13.788 7.36287C13.7493 7.45625 13.6926 7.5411 13.6212 7.61257L11.0875 10.1453L13.6212 12.678Z" fill="#A79877"/>
                          </svg>
                      </div>
                  </div>
                )
              })
            }
          </div>

          <SectionGalleryImages>
            {communityData.videos && communityData.videos.map((f, index) => (
              <SectionGalleryImage key={index}>
                <CloseIcon onClick={() => handleDeleteVideo(f)} />
                <MediaPreview file={f} />
              </SectionGalleryImage> 
            ))}
          </SectionGalleryImages>
              
          <SectionGalleryImages>
            {communityData.photos &&
              Array.from(communityData.photos).map((f, index) => (
                <SectionGalleryImage>
                  <CloseIcon
                    onClick={() => {
                      const copyPhotos = Array.from(communityData.photos);
                      copyPhotos.splice(index, 1);
                      setCommunityData({
                        ...communityData,
                        ['photos']: [...copyPhotos],
                      });
                      return;
                    }}
                  />
                  <MediaPreview file={f} />
                </SectionGalleryImage>
              ))}
          </SectionGalleryImages>
        </SectionGalleryMediaWrapper>
      </SectionGalleryWrapper>

      <SectionBuilderDetailsContainer>
        <SectionHeader title="Builder Details" />
        <SectionBuilderDetailsWrapper>
          <SectionBuilderDescriptionWrapper>
            <SectionBuilderLogoWrapper>
              <UploadPhoto title="UPLOAD LOGO" name="builder_image" handleChange={handleChange} />
            </SectionBuilderLogoWrapper>
            <textarea placeholder="Builder's Details" name="builder_description" onChange={handleChange}></textarea>
            {_fieldErrors.builder_description && (
              <FieldErrorMessage>{_fieldErrors.builder_description[0]}</FieldErrorMessage>
            )}
          </SectionBuilderDescriptionWrapper>
          <SectionBuilderDetailsContentWrapper>
            <SectionBuilderDetailsContentWrapper>
              <SectionBuilderDetailsContent>
                <SectionBuilderDetailsContentLeftCol>
                  <textarea placeholder="Builder's Details" name="builder_content" onChange={handleChange}></textarea>
                </SectionBuilderDetailsContentLeftCol>
                <SectionBuilderDetailsContentRightCol>
                  <UploadPhoto title="UPLOAD LOGO" name="builder_content_image" handleChange={handleChange} />
                </SectionBuilderDetailsContentRightCol>
              </SectionBuilderDetailsContent>
            </SectionBuilderDetailsContentWrapper>
            <SectionBuilderDetailsContentText>
              <textarea
                placeholder="Builder's Highlight Details"
                name="builder_highlight_details"
                onChange={handleChange}
              ></textarea>
            </SectionBuilderDetailsContentText>
          </SectionBuilderDetailsContentWrapper>
        </SectionBuilderDetailsWrapper>
      </SectionBuilderDetailsContainer>
      <Modal
        show={showHighlightsModal}
        size="lg"
        centered
        onHide={() => {
          //onChange(name, selectedValues)
          setShowHighlightsModal(!showHighlightsModal);
        }}
      >
        <ModalHeader>Select highlights</ModalHeader>
        <ModalBody>
          {loading && <Loader />}
          {!loading && (
            <Form.Control placeholder="Search highlight" onChange={(e) => setKeyword(e.target.value.toLowerCase())} />
          )}

          {!loading &&
            highlights
              .filter(({ name }) => name.toLowerCase().includes(keyword))
              .map((h) => {
                return { ...h, value: h.id };
              })
              .map((highlight) => (
                <>
                  <Form.Check
                    checked={selectedHighlights.find((h) => highlight.value === h.value)}
                    style={{ minHeight: 'auto' }}
                    onChange={(e) => {
                      const { checked, name, value } = e.target;
                      console.log('name', checked, value);
                      if (checked) {
                        setSelectedHighlights([...selectedHighlights, highlight]);
                      } else {
                        setSelectedHighlights([...selectedHighlights.filter((h) => h.value != value)]);
                      }
                      return;
                    }}
                    label={highlight.name}
                    name={highlight.name}
                    value={highlight.id}
                  />
                </>
              ))}
        </ModalBody>
        <ModalFooter>
          <Button
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              // onChange(name, selectedValues)
              setShowHighlightsModal(!showHighlightsModal);
            }}
          >
            {' '}
            Save{' '}
          </Button>
        </ModalFooter>
      </Modal>
    </AddCommunityContainer>
  );
};

export default AddCommunity;
